/* eslint-disable */
// App.js — Refactored for Live API Integration (Render Backend)
// This version replaces all synchronous Local Storage data access with asynchronous API calls managed by the useGlobalData hook.

import React, { useEffect, useMemo, useState, useCallback, useContext, createContext } from 'react';
import { BrowserRouter, Routes, Route, Link, useNavigate, useParams, Navigate } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';

/* =========================
   CONFIG / CONSTANTS
   ========================= */

const API_URL = 'https://edizz-enginev1.onrender.com';
const APP_DOMAIN = 'https://Edgram.in';

// NOTE: Only session/auth constants are kept. Data constants like LS_USERS are deleted.
const LS_MEMBER_EMAIL = 'ed_member_email_v1';
const LS_USER_TYPE = 'userType';
const LS_EMAIL = 'email';
const LS_TOKEN = 'token';
const LS_PROGRESS = 'ed_progress_v1'; 

const ROLE_MEMBER = 'member';
const ROLE_SUPER_PREMIUM = 'super_premium';
const ROLE_ACCOUNTANT = 'accountant';
const ROLE_ADMIN = 'admin';

const STATUS_ACTIVE = 'active';
const STATUS_BLOCKED = 'blocked';

const PAYOUT_MEMBER = 3000;
const PAYOUT_SUPER_PREMIUM = 5000;

// THEME CONSTANTS - CONSOLIDATED COLORS
const PRIMARY_COLOR_CLASS = 'text-red-600'; 
const SECONDARY_COLOR_CLASS = 'text-orange-400'; 
const CTA_BUTTON_CLASS = 'bg-gradient-to-r from-orange-500 to-red-600 hover:from-orange-600 hover:to-red-700'; const Icon = ({ name, className = 'w-5 h-5' }) => { const paths = { lock: (<><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></>), repeat: (<><polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></>), 'file-text': (<><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></>), smartphone: (<><rect x="5" y="2" width="14" height="20" rx="2" ry="2"/><line x1="12" y1="18" x2="12.01" y2="18"/></>), zap: (<polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>), target: (<><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></>), 'book-open': (<><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></>), 'check-circle': (<><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></>), 'graduation-cap': (<><path d="M22 10L12 4 2 10l10 6 10-6z"/><path d="M6 12v5c0 1.657 3 3 6 3s6-1.343 6-3v-5"/></>), eye: (<><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></>), 'trending-up': (<><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></>), link: (<><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></>), 'log-out': (<><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></>), clock: (<><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></>), 'alert-triangle': (<><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></>), inbox: (<><polyline points="22 12 16 12 14 15 10 15 8 12 2 12"/><path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"/></>), landmark: (<><line x1="3" y1="22" x2="21" y2="22"/><line x1="6" y1="18" x2="6" y2="11"/><line x1="10" y1="18" x2="10" y2="11"/><line x1="14" y1="18" x2="14" y2="11"/><line x1="18" y1="18" x2="18" y2="11"/><polygon points="12 2 20 7 4 7"/></>), video: (<><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/></>) }; return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>{paths[name]}</svg>); };


/* =========================
   DELETED LS HELPERS (Removed getLS, setLS, mockFetch, load/save functions)
   ========================= */


/* =========================
   API CLIENT (Using fetch for Render Backend)
   ========================= */

// Utility to handle API calls with token and retry logic
async function fetchWithRetry(url, options = {}, retries = 3) {
    const token = localStorage.getItem(LS_TOKEN);
    const headers = { 
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Bearer ${token}` }),
        ...options.headers
    };

    for (let i = 0; i < retries; i++) {
        try {
            const response = await fetch(url, { ...options, headers });
            
            // 🛑 STOP RETRYING if it's a Client Error (4xx)
            // Example: 400 (Bad Data), 401 (Unauthorized), 409 (Email Exists)
            if (response.status >= 400 && response.status < 500) {
                const errorText = await response.text();
                // Parse JSON error if possible
                try {
                    const jsonErr = JSON.parse(errorText);
                    throw new Error(jsonErr.message || jsonErr.error || errorText);
                } catch (e) {
                    throw new Error(errorText || `Error ${response.status}`);
                }
            }

            // Check for Server Errors (5xx)
            if (!response.ok) {
                const errorBody = await response.text();
                throw new Error(`API Error ${response.status}: ${errorBody.substring(0, 100)}`);
            }
            
            if (response.status === 204) return {};

            return await response.json();

        } catch (error) {
            // If it's a 4xx error (like "Email already registered"), throw it IMMEDIATELY.
            // Do not retry.
            if (!error.message.includes("Failed to fetch") && !error.message.includes("NetworkError")) {
                 throw error;
            }

            console.error(`Attempt ${i + 1} failed for ${url}:`, error.message);
            
            // Retry logic for Network Errors only
            if (i < retries - 1) {
                await new Promise(res => setTimeout(res, 2000 * (i + 1))); 
            } else {
                // On the final attempt, throw the REAL error, not a generic one
                throw error;
            }
        }
    }
}


const ApiClient = {
    // --- AUTH ---
    login: (email, password) => fetchWithRetry(`${API_URL}/api/login`, {
        method: 'POST',
        body: JSON.stringify({ email, password }),
    }),

    // ✅ FIXED: Changed from '/api/register' to '/api/users/register'
    registerUser: (userData) => fetchWithRetry(`${API_URL}/api/users/register`, {
    method: 'POST',
    body: JSON.stringify(userData),
}),
    // Checks an email BEFORE any payment is taken, so we never charge for an
    // account that cannot then be created. Returns { available: true | false }.
    checkEmailAvailable: (email) => fetchWithRetry(API_URL + '/api/users/email-available', {
        method: 'POST',
        body: JSON.stringify({ email }),
    }),

    // The signed-in user's OWN record, earnings and purchases. These replace the
    // admin-only whole-list endpoints that the member screens used to rely on.
    fetchMe: () => fetchWithRetry(API_URL + '/api/me'),
    fetchMyPayouts: () => fetchWithRetry(API_URL + '/api/me/payouts'),
    fetchMySales: () => fetchWithRetry(API_URL + '/api/me/sales'),
    // --- CRUD ---
    fetchUsers: () => fetchWithRetry(`${API_URL}/api/users`),
    updateUser: (userId, updates) => fetchWithRetry(`${API_URL}/api/users/${userId}`, {
        method: 'PUT',
        body: JSON.stringify(updates),
    }),
    
    fetchSales: () => fetchWithRetry(`${API_URL}/api/sales`),
    saveSales: (salesData) => fetchWithRetry(`${API_URL}/api/sales`, { 
        method: 'PUT',
        body: JSON.stringify(salesData),
    }),

    fetchPayouts: () => fetchWithRetry(`${API_URL}/api/payouts`),
    savePayouts: (payoutsData) => fetchWithRetry(`${API_URL}/api/payouts`, { 
        method: 'PUT',
        body: JSON.stringify(payoutsData),
    }),

    fetchContent: () => fetchWithRetry(`${API_URL}/api/content`),
    saveContent: (contentData) => fetchWithRetry(`${API_URL}/api/content`, {
        method: 'PUT',
        body: JSON.stringify(contentData),
    }),
    
    fetchProgress: () => fetchWithRetry(`${API_URL}/api/progress`), 
    saveProgress: (progressData) => fetchWithRetry(`${API_URL}/api/progress`, {
        method: 'PUT',
        body: JSON.stringify(progressData),
    }),

    // Password reset. The security answer is checked on the server, so the
    // browser is never given the answer and never decides if it was correct.
    fetchSecretQuestion: (email) => fetchWithRetry(API_URL + '/api/auth/forgot/question', {
        method: 'POST',
        body: JSON.stringify({ email }),
    }),
    resetPassword: (email, answer, newPassword) => fetchWithRetry(API_URL + '/api/auth/forgot/reset', {
        method: 'POST',
        body: JSON.stringify({ email, answer, newPassword }),
    }),

    fetchInvoiceSettings: () => fetchWithRetry(`${API_URL}/api/settings/invoice`),
    saveInvoiceSettings: (s) => fetchWithRetry(`${API_URL}/api/settings/invoice`, {
        method: 'PUT',
        body: JSON.stringify(s),
    }),
    
    fetchLegalDocs: () => fetchWithRetry(`${API_URL}/api/settings/legal`),
    saveLegalDocs: (d) => fetchWithRetry(`${API_URL}/api/settings/legal`, {
        method: 'PUT',
        body: JSON.stringify(d),
    }),

    fetchContactInfo: () => fetchWithRetry(`${API_URL}/api/settings/contact`),
    saveContactInfo: (d) => fetchWithRetry(`${API_URL}/api/settings/contact`, {
        method: 'PUT',
        body: JSON.stringify(d),
    }),
    
    fetchNextInvoiceNumber: () => {
        const LS_NEXT_NO = 'invoice_next_no_v2';
        const n = Number(localStorage.getItem(LS_NEXT_NO)); 
        return Promise.resolve(Number.isFinite(n) && n > 0 ? n : 1001);
    },
    saveNextInvoiceNumber: (n) => { 
        const LS_NEXT_NO = 'invoice_next_no_v2';
        localStorage.setItem(LS_NEXT_NO, String(n));
        return Promise.resolve(n);
    }
};
/* =========================
   GLOBAL STATE HOOK (The Core Replacement)
   ========================= */

const GlobalDataContext = createContext(null);

function useGlobalData() {
    const [isLoading, setIsLoading] = useState(true);
    const [allUsers, setAllUsers] = useState([]);
    const [allSales, setAllSales] = useState([]);
    const [allPayouts, setAllPayouts] = useState([]);
    const [content, setContent] = useState({ categories: [], videos: [] });
    const [progress, setProgress] = useState({});
    const [me, setMe] = useState(null);
    const [error, setError] = useState(null);

    const email = localStorage.getItem(LS_MEMBER_EMAIL);

    const fetchData = useCallback(async () => {
        setIsLoading(true);
        setError(null);
        try {
            // Members and visitors are not allowed to download the full member,
            // sales or payout lists, so those requests used to be refused and then
            // thrown away on every single page load. Admins still get the full
            // lists; a signed-in member now gets only their own profile, earnings
            // and purchases. /api/progress returns a fixed placeholder, so we use
            // that value directly instead of asking the server for it.
            const token = localStorage.getItem(LS_TOKEN);
            const isAdminUser = !!token && localStorage.getItem(LS_USER_TYPE) === ROLE_ADMIN;
            const [usersData, salesData, payoutsData, contentData, meData] = await Promise.all([
                isAdminUser ? ApiClient.fetchUsers().catch(e => { console.error("Error fetching users:", e.message); return []; }) : Promise.resolve([]),
                isAdminUser
                    ? ApiClient.fetchSales().catch(e => { console.error("Error fetching sales:", e.message); return []; })
                    : (token ? ApiClient.fetchMySales().catch(e => { console.error("Error fetching own sales:", e.message); return []; }) : Promise.resolve([])),
                isAdminUser
                    ? ApiClient.fetchPayouts().catch(e => { console.error("Error fetching payouts:", e.message); return []; })
                    : (token ? ApiClient.fetchMyPayouts().catch(e => { console.error("Error fetching own payouts:", e.message); return []; }) : Promise.resolve([])),
                ApiClient.fetchContent().catch(e => { console.error("Error fetching content:", e.message); return { categories: [], videos: [] }; }),
                token ? ApiClient.fetchMe().catch(e => { console.error("Error fetching own profile:", e.message); return null; }) : Promise.resolve(null)
            ]);
            const progressData = { percent: 0, message: 'Tracker Active' };

            setAllUsers(usersData);
            setAllSales(salesData);
            setAllPayouts(payoutsData);
            setContent(contentData);
            setProgress(progressData);
            setMe(meData);

        } catch (e) {
            console.error("Global data fetch failed:", e);
            setError("Failed to load global application data.");
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        // Only run fetch on initial load
        fetchData();
    }, [fetchData]);

    const memberUser = useMemo(() => {
        // Prefer the account the server says we are signed in as. Only admins may
        // download the full member list, so looking ourselves up inside it left
        // every ordinary member with no profile at all.
        if (me) return me;
        return allUsers.find(u => u.email === email) || null;
    }, [me, allUsers, email]);

    // Expose all data and the refetch function
    const value = {
        isLoading,
        error,
        allUsers,
        memberUser, // The currently logged-in member
        allSales,
        allPayouts,
        content,
        progress,
        fetchData, // Function to trigger data refresh
        setContent, // Needed for ContentManager local update before refetch
    };

    return value;
}

// Custom hook to use global data
const useAppGlobal = () => useContext(GlobalDataContext);


/* =========================
   SMALL HELPERS (UPDATED to remove LS logic)
   ========================= */
function uid(prefix = 'id') { return `${prefix}_${Math.random().toString(36).slice(2, 8)}_${Date.now().toString(36)}`; }
function todayISO() { const d = new Date(); return d.toISOString().slice(0, 10); }
function formatINR(n) { return `₹${Number(n || 0).toLocaleString('en-IN')}`; }
function csvCell(v) { const s = String(v ?? ''); return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s; } 
function trigger(blob, filename) { const a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = filename; document.body.appendChild(a); a.click(); a.remove(); }
function generateReferralCode() { return Math.random().toString(36).substring(2, 10).toUpperCase(); }
function parseQuery() { try { return Object.fromEntries(new URLSearchParams(window.location.search)); } catch { return {}; } }

// Session management helper (kept local storage but simplified)
function setMember(email, role) {
    localStorage.setItem(LS_MEMBER_EMAIL, email);
    localStorage.setItem(LS_USER_TYPE, role);
}

// ... [YOUTUBE / INVOICE HELPERS remain unchanged] ...
function getYouTubeId(url) {
  try {
    const u = new URL(url);
    if (u.hostname === 'youtu.be') return u.pathname.slice(1);
    if (u.searchParams.get('v')) return u.searchParams.get('v');
    const m = u.pathname.match(/\/embed\/([^/?#]+)/);
    if (m) return m[1];
  } catch {}
  const m = String(url).match(/([a-zA-Z0-9_-]{11})/);
  return m ? m[1] : '';
}
const ytThumb = (id) => `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
const ytEmbed = (id) => `https://www.youtube-nocookie.com/embed/${id}?rel=0`;


// SHA-512 helper using Web Crypto API (for Easebuzz hash)
async function sha512(message) {
  const msgBuffer = new TextEncoder().encode(message);
  const hashBuffer = await crypto.subtle.digest('SHA-512', msgBuffer);
  return Array.from(new Uint8Array(hashBuffer)).map(b => b.toString(16).padStart(2, '0')).join('');
}

// Load Easebuzz Checkout SDK
function loadEasebuzzCheckout() {
  return new Promise((resolve, reject) => {
    if (window.EasebuzzCheckout) return resolve(window.EasebuzzCheckout);
    const s = document.createElement('script');
    s.src = 'https://ebz-static.s3.ap-south-1.amazonaws.com/easecheckout/easebuzz-checkout.js';
    s.onload = () => {
      if (window.EasebuzzCheckout) resolve(window.EasebuzzCheckout);
      else reject(new Error('Easebuzz SDK loaded but EasebuzzCheckout is undefined'));
    };
    s.onerror = () => reject(new Error('Easebuzz script load failed'));
    document.head.appendChild(s);
  });
}


// Google OAuth Client ID
const GOOGLE_CLIENT_ID = '635132503666-vapkjq7n7evgek1bneca4a91in6qnr89.apps.googleusercontent.com';

// Load Google Identity Services script
function loadGoogleGSI() {
  return new Promise((resolve, reject) => {
    if (window.google?.accounts?.id) return resolve(window.google.accounts.id);
    const s = document.createElement('script');
    s.src = 'https://accounts.google.com/gsi/client';
    s.async = true;
    s.defer = true;
    s.onload = () => {
      if (window.google?.accounts?.id) resolve(window.google.accounts.id);
      else reject(new Error('Google GSI loaded but google.accounts.id is undefined'));
    };
    s.onerror = () => reject(new Error('Failed to load Google Sign-In script'));
    document.head.appendChild(s);
  });
}

// Renders a Google Sign-In button inside a given container div ID
// Much more reliable than gsi.prompt() which gets suppressed by browsers
async function renderGoogleButton(containerId, callback) {
  const gsi = await loadGoogleGSI();
  gsi.initialize({
    client_id: GOOGLE_CLIENT_ID,
    callback,
    auto_select: false,
    cancel_on_tap_outside: true,
  });
  gsi.renderButton(document.getElementById(containerId), {
    theme: 'outline',
    size: 'large',
    width: '100%',
    text: 'continue_with',
    shape: 'rectangular',
    logo_alignment: 'left',
  });
}
// NEW HELPER: Load JSZip externally
function loadJSZip() {
  return new Promise((resolve, reject) => {
    if (window.JSZip) return resolve(window.JSZip);
    const s = document.createElement('script');
    s.src = 'https://cdnjs.cloudflare.com/ajax/libs/jszip/3.10.1/jszip.min.js';
    s.onload = () => {
        // Ensure JSZip is loaded globally
        if (window.JSZip) {
            resolve(window.JSZip);
        } else {
            reject(new Error('JSZip loaded but window.JSZip is undefined'));
        }
    };
    s.onerror = () => reject(new Error('JSZip script load failed'));
    document.head.appendChild(s);
  });
}


const monthName = (m) => ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][m - 1];
function splitGST({ grossAmount, sameState }) {
  const taxable = +(grossAmount / 1.18).toFixed(2);
  const tax = +(grossAmount - taxable).toFixed(2);
  const half = +((tax / 2).toFixed(2));
  return sameState ? { taxable, cgst: half, sgst: half, igst: 0, total: grossAmount } : { taxable, cgst: 0, sgst: 0, igst: tax, total: grossAmount };
}
function invoiceHTML(row, s) {
  const cssColor = s.primaryColor || '#1f2937', fs = Number(s.fontSize || 14);
  return `<!doctype html><html><head><meta charset="utf-8"><title>${row.invoiceNo}</title>
  <style>body{font-family:Arial,Helvetica,sans-serif;color:#111;padding:24px}.inv{border:1px solid #eee;padding:16px}.header{display:flex;gap:16px;align-items:center}.logo{height:70px}.small{color:#555;font-size:12px}table{width:100%;border-collapse:collapse;margin-top:10px}th,td{border:1px solid #e5e7eb;padding:6px;text-align:left;font-size:13px}</style>
  </head><body>
  <div class="inv">
    <div class="header">
      ${s.logoUrl ? `<img class="logo" src="${s.logoUrl}" alt="Edgram Logo"/>` : '<h2 style="color:'+cssColor+';font-size:36px;margin:0">Edgram Logo</h2>'}
      <div>
        <h2 style="color:${cssColor};font-size:${fs + 4}px;margin:0">${s.companyName || ''}</h2>
        <div class="small">${s.companyAddress || ''}</div>
        <div class="small">GSTIN: ${s.gstin || '-'}</div>
      </div>
    </div>
    <hr style="margin:12px 0;border-color:#eee"/>
    <div class="small">Invoice No: <strong>${row.invoiceNo}</strong></div>
    <div class="small">Date: ${row.date}</div>
    <div class="small">Billed To: ${row.customerName}${row.customerGSTIN ? ` (${row.customerGSTIN})` : ''}</div>
    <div class="small">Place of supply: ${row.customerState || '-'}</div>
    <table><thead><tr><th>Description</th><th>SAC</th><th>Taxable</th><th>CGST</th><th>SGST</th><th>IGST</th><th>Total</th></tr></thead>
      <tbody><tr>
        <td>${s.itemDescription || 'Membership'}</td>
        <td>${s.sacCode || '-'}</td>
        <td>₹${row.taxableValue.toFixed(2)}</td>
        <td>₹${row.cgst.toFixed(2)}</td>
        <td>₹${row.sgst.toFixed(2)}</td>
        <td>₹${row.igst.toFixed(2)}</td>
        <td>₹${row.total.toFixed(2)}</td>
      </tr></tbody></table>
    <div class="small" style="margin-top:10px">${s.footerNote || ''}</div>
    <div style="margin-top:16px;display:flex;gap:8px;align-items:center">
      ${s.signatoryImageUrl ? `<img src="${s.signatoryImageUrl}" alt="sign" style="height:40px"/>` : ''}
      <div class="small">For ${s.companyName || ''}<br/><strong>${s.signatoryName || 'Authorized Signatory'}</strong></div>
    </div>
  </div></body></html>`;
}
// ... [YOUTUBE / INVOICE HELPERS end] ...


/* =========================
   BASIC UI
   ========================= */
const Container = ({ children }) => <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">{children}</div>;
const Card = ({ children, className = '' }) => <div className={`bg-white rounded-2xl shadow-sm border border-gray-100 p-6 ${className}`}>{children}</div>;
const Modal = ({ children, onClose }) => (
  <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4 backdrop-blur-sm">
    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-3xl relative border border-gray-100">
      {onClose && <button onClick={onClose} className="absolute right-4 top-4 w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 text-gray-500 transition text-lg font-bold">×</button>}
      <div className="p-6">{children}</div>
    </div>
  </div>
);
const EmptyState = ({ title, message, icon = <Icon name="inbox" className="w-8 h-8" /> }) => (
  <div className="text-center py-16 px-6 bg-gray-50 rounded-2xl border border-gray-100">
    <div className="w-16 h-16 bg-gray-100 rounded-2xl flex items-center justify-center mx-auto mb-4 text-gray-400">{icon}</div>
    <h3 className="text-lg font-bold text-gray-800 mb-1">{title}</h3>
    <p className="text-sm text-gray-500">{message}</p>
  </div>
);
/* =========================
   SKELETON LOADERS
   ========================= */
const SkeletonBox = ({ className = '' }) => (
  <div className={`animate-pulse bg-gray-200 rounded-lg ${className}`} />
);

const SkeletonCategoryGrid = () => (
  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
    {[1, 2, 3].map(i => (
      <div key={i} className="bg-white rounded-xl border border-gray-100 p-4">
        <SkeletonBox className="h-40 mb-3" />
        <SkeletonBox className="h-4 w-3/4 mb-2" />
        <SkeletonBox className="h-3 w-1/2" />
      </div>
    ))}
  </div>
);

const SkeletonDashboard = () => (
  <div className="space-y-6">
    <div className="grid md:grid-cols-3 gap-6">
      {[1, 2, 3].map(i => (
        <div key={i} className="bg-gray-50 rounded-xl p-6">
          <SkeletonBox className="h-3 w-24 mb-4 rounded" />
          <SkeletonBox className="h-7 w-32 rounded" />
        </div>
      ))}
    </div>
    <div className="bg-white rounded-xl border border-gray-100 p-6">
      <SkeletonBox className="h-4 w-48 mb-4 rounded" />
      <SkeletonBox className="h-10 rounded" />
    </div>
  </div>
);

const SkeletonVideoGrid = () => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
    {[1, 2, 3, 4].map(i => (
      <div key={i} className="bg-white rounded-xl border border-gray-100 overflow-hidden">
        <SkeletonBox className="h-40 rounded-none" />
        <div className="p-4">
          <SkeletonBox className="h-4 w-3/4 mb-2 rounded" />
          <SkeletonBox className="h-3 w-1/4 rounded" />
        </div>
      </div>
    ))}
  </div>
);

/* =========================
   AUTH (Admin login only - REPLACED API CALL)
   ========================= */
function Login() {
  const [email, setEmail] = useState(''); 
  const [password, setPassword] = useState(''); 
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { fetchData } = useAppGlobal();
  
  const submit = async (e) => {
    e.preventDefault(); 
    setError('');
    setLoading(true);

    // NEW LOGIC: Use ApiClient.login
    try {
        const data = await ApiClient.login(email, password);
        
        // Assuming the API returns user data and token upon successful login
        if (data.token && data.user) {
            localStorage.setItem(LS_TOKEN, data.token);
            localStorage.setItem(LS_USER_TYPE, data.user.role); 
            localStorage.setItem(LS_EMAIL, data.user.email);

            if (data.user.role === ROLE_ADMIN) {
                 toast.success('Admin login successful!');
                 navigate('/admin');
            } else {
                 setError('This login screen is for Admin only. Use the Member Login screen for non-admin users.');
            }
        } else {
            setError('Login failed: Invalid response from server.');
        }
    } catch (e) {
        setError(e.message.includes('401') ? 'Invalid credentials.' : 'Login failed. Please try again.');
        console.error("Login error:", e);
    } finally {
        setLoading(false);
        fetchData(); // Refresh global data after auth change
    }
  };
  const inputCls = "w-full border border-gray-200 bg-gray-50 focus:bg-white focus:border-red-400 focus:ring-2 focus:ring-red-100 rounded-xl px-4 py-3 text-sm text-gray-800 placeholder-gray-400 outline-none transition";
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-10 px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/"><span className="text-3xl font-black text-red-600">Edgram</span></Link>
          <p className="text-gray-500 text-sm mt-2">Admin access only</p>
        </div>
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 bg-red-50 rounded-xl flex items-center justify-center text-xl">🛡️</div>
            <div>
              <h2 className="text-xl font-bold text-gray-900">Admin Login</h2>
              <p className="text-xs text-gray-400">Restricted access</p>
            </div>
          </div>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">Email</label>
              <input className={inputCls} placeholder="admin@edgram.in" value={email} onChange={e=>setEmail(e.target.value)} required />
            </div>
            <div>
              <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">Password</label>
              <input className={inputCls} type="password" placeholder="Admin password" value={password} onChange={e=>setPassword(e.target.value)} required />
            </div>
            {error && <div className="bg-red-50 border border-red-200 text-red-600 text-sm px-4 py-3 rounded-xl">{error}</div>}
            <button type="submit" className={`w-full ${CTA_BUTTON_CLASS} text-white py-3.5 rounded-xl font-bold text-sm disabled:opacity-50 transition`} disabled={loading}>
              {loading ? 'Signing in...' : 'Sign In as Admin'}
            </button>
          </form>
          <p className="text-center text-xs text-gray-400 mt-6">
            Member? <Link to="/login" className="text-red-600 hover:underline font-medium">Sign in here</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

// ... [AuthWrapper, AdminRoute, MemberRoute, AccountantRoute remain unchanged] ...
const AuthWrapper = ({ children, setUserType }) => {
  const token = localStorage.getItem(LS_TOKEN);
  const userType = localStorage.getItem(LS_USER_TYPE);
  const navigate = useNavigate();

  useEffect(() => {
    if (!token && userType !== ROLE_MEMBER && userType !== ROLE_SUPER_PREMIUM && userType !== ROLE_ACCOUNTANT) {
      localStorage.removeItem(LS_TOKEN);
      localStorage.removeItem(LS_USER_TYPE);
      localStorage.removeItem(LS_EMAIL);
      localStorage.removeItem(LS_MEMBER_EMAIL);
      setUserType('guest');
    }
  }, [token, userType, setUserType, navigate]);

  return children;
};

const AdminRoute = ({ children }) => {
  const token = localStorage.getItem(LS_TOKEN);
  const userType = localStorage.getItem(LS_USER_TYPE);
  if (!token || userType !== ROLE_ADMIN) return <Navigate to="/admin-login" replace />;
  return children;
};

const MemberRoute = ({ children }) => {
  const userType = localStorage.getItem(LS_USER_TYPE);
  const memberEmail = localStorage.getItem(LS_MEMBER_EMAIL);
  // Also check if a token exists for API auth
  const token = localStorage.getItem(LS_TOKEN); 
  if ((userType !== ROLE_MEMBER && userType !== ROLE_SUPER_PREMIUM) || !memberEmail || !token) return <Navigate to="/login" replace />;
  return children;
};

const AccountantRoute = ({ children }) => {
  const userType = localStorage.getItem(LS_USER_TYPE);
  const memberEmail = localStorage.getItem(LS_MEMBER_EMAIL);
  const token = localStorage.getItem(LS_TOKEN);
  if (userType !== ROLE_ACCOUNTANT || !memberEmail || !token) return <Navigate to="/login" replace />;
  return children;
};


/* =========================
   NAVBAR (Unchanged)
   ========================= */
const Navbar = ({ userType, setUserType }) => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const logout = () => {
    sessionStorage.removeItem('admin_unlocked');
    localStorage.removeItem(LS_TOKEN);
    localStorage.removeItem(LS_USER_TYPE);
    localStorage.removeItem(LS_EMAIL);
    localStorage.removeItem(LS_MEMBER_EMAIL);
    setUserType('guest');
    setMenuOpen(false);
    toast.success('Logged out successfully.');
    navigate('/');
  };

  const dashRoute =
    userType === ROLE_MEMBER || userType === ROLE_SUPER_PREMIUM
      ? '/dashboard'
      : userType === ROLE_ACCOUNTANT
      ? '/accountant'
      : '/admin';

  const close = () => setMenuOpen(false);

  return (
    <nav className="bg-gray-900 shadow-md sticky top-0 z-40 border-b border-gray-800">
      <div className="container mx-auto px-6 py-4 flex justify-between items-center">
        <Link to="/" onClick={close} className={`text-3xl font-extrabold ${SECONDARY_COLOR_CLASS}`}>
          Edgram
        </Link>

        {/* Desktop links */}
        <div className="hidden md:flex items-center gap-6">
          <Link to="/" className="text-gray-300 hover:text-white font-medium transition text-sm">Home</Link>
          <Link to="/about" className="text-gray-300 hover:text-white font-medium transition text-sm">About</Link>
          {userType === 'guest' ? (
            <>
              <Link
                to="/login"
                className="border border-gray-600 hover:border-gray-400 text-gray-300 hover:text-white px-5 py-2 rounded-full font-semibold transition text-sm"
              >
                Login
              </Link>
              <Link
                to="/register"
                className={`${CTA_BUTTON_CLASS} text-white px-5 py-2 rounded-full font-semibold shadow-lg transition text-sm`}
              >
                Join Now
              </Link>
            </>
          ) : (
            <>
              <Link to={dashRoute} className="text-gray-300 hover:text-white font-medium text-sm">Dashboard</Link>
              <button onClick={logout} className="border border-gray-600 hover:border-red-500 text-gray-300 hover:text-red-400 px-4 py-2 rounded-full text-sm font-semibold transition">Logout</button>
            </>
          )}
        </div>

        {/* Mobile right — Login button always visible + hamburger for logged-in users */}
        <div className="md:hidden flex items-center gap-2">
          {userType === 'guest' && (
            <Link
              to="/login"
              className="border border-gray-600 hover:border-gray-400 text-gray-300 hover:text-white px-4 py-1.5 rounded-full font-semibold transition text-sm"
            >
              Login
            </Link>
          )}
          {userType === 'guest' && (
            <Link
              to="/register"
              className={`${CTA_BUTTON_CLASS} text-white px-4 py-1.5 rounded-full font-semibold transition text-sm`}
            >
              Join
            </Link>
          )}
          {userType !== 'guest' && (
            <button
              className="flex flex-col gap-1.5 p-2 focus:outline-none"
              onClick={() => setMenuOpen(o => !o)}
              aria-label="Toggle menu"
            >
              <span className={`block w-5 h-0.5 bg-gray-300 transition-all duration-300 ${menuOpen ? 'rotate-45 translate-y-2' : ''}`} />
              <span className={`block w-5 h-0.5 bg-gray-300 transition-all duration-300 ${menuOpen ? 'opacity-0' : ''}`} />
              <span className={`block w-5 h-0.5 bg-gray-300 transition-all duration-300 ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`} />
            </button>
          )}
        </div>
      </div>

      {/* Mobile drawer — only shown for logged-in users */}
      {menuOpen && userType !== 'guest' && (
        <div className="md:hidden bg-gray-800 border-t border-gray-700 px-6 pb-6 pt-4 flex flex-col gap-1">
          <Link to="/" onClick={close} className="text-gray-300 hover:text-orange-400 py-3 border-b border-gray-700 font-medium text-sm">Home</Link>
          <Link to="/about" onClick={close} className="text-gray-300 hover:text-orange-400 py-3 border-b border-gray-700 font-medium text-sm">About</Link>
          <Link to={dashRoute} onClick={close} className="text-gray-300 hover:text-orange-400 py-3 border-b border-gray-700 font-medium text-sm">Dashboard</Link>
          <button onClick={logout} className="bg-red-600 text-white py-3 rounded-full font-semibold mt-4 hover:bg-red-700 transition text-sm">Logout</button>
        </div>
      )}
    </nav>
  );
};

/* =========================
   CONTENT / SEEDING (Removed local seeding)
   ========================= */

// ** DELETED: Local content seeding functions **


/* =========================
   MEMBER UTILITIES (FIXED: Removed 'async' to prevent false positives)
   ========================= */

// Find user by email (used for login and registration check)
function findUserByEmailAsync(allUsers, email) {
    if (!allUsers || !email) return null;
    return allUsers.find(u => u.email.toLowerCase() === email.toLowerCase());
}

// Find user by referral (used during registration)
function findUserByReferralAsync(allUsers, code) {
    if (!allUsers || !code) return null;
    return allUsers.find(u => u.referralCode === code);
}

/* =========================
   PUBLIC PAGES - HOMEPAGE (Premium Redesign — fully responsive)
   ========================= */

const Landing = () => {
  const userType = localStorage.getItem(LS_USER_TYPE) || 'guest';
  const { content } = useAppGlobal();
  const featuredCats = (content?.categories || []).slice(0, 3);

  const isGuest = userType === 'guest';

  // ── Shared CTA button ──────────────────────────────────────────────
  const PrimaryCTA = ({ size = 'lg' }) => (
    isGuest
      ? <Link
          to="/register"
          className={`inline-block bg-red-600 hover:bg-red-700 active:scale-95 text-white font-bold rounded-full transition-all shadow-lg shadow-red-900/30 ${size === 'lg' ? 'py-4 px-8 text-base sm:text-lg' : 'py-3 px-6 text-sm'}`}
        >
          Start learning — ₹6,999
        </Link>
      : <Link
          to="/dashboard"
          className={`inline-block bg-red-600 hover:bg-red-700 active:scale-95 text-white font-bold rounded-full transition-all shadow-lg shadow-red-900/30 ${size === 'lg' ? 'py-4 px-8 text-base sm:text-lg' : 'py-3 px-6 text-sm'}`}
        >
          Go to dashboard
        </Link>
  );

  // ── 1. HERO ────────────────────────────────────────────────────────
  const Hero = () => (
    <div className="relative bg-gray-950 text-white overflow-hidden">
      {/* Subtle red radial glow — top center */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ background: 'radial-gradient(ellipse 80% 40% at 50% 0%, rgba(220,38,38,0.13) 0%, transparent 70%)' }}
      />
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28 lg:py-36 text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-red-950/60 border border-red-800/40 text-red-400 text-xs font-semibold tracking-widest uppercase px-4 py-2 rounded-full mb-8">
          <span className="w-1.5 h-1.5 bg-red-500 rounded-full animate-pulse" />
          Lifetime membership · One payment
        </div>

        {/* Headline */}
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.1] tracking-tight mb-6 max-w-4xl mx-auto">
          Learn Premium Skills{' '}
          <span className="bg-gradient-to-r from-orange-400 to-red-500 bg-clip-text text-transparent">
            that actually work
          </span>
        </h1>

        {/* Sub */}
        <p className="text-base sm:text-lg lg:text-xl text-gray-400 max-w-2xl mx-auto mb-10 leading-relaxed">
          Pre-recorded expert courses across multiple categories. Pay once, access everything forever — no subscriptions, no limits.
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
          <PrimaryCTA size="lg" />
          {isGuest && (
            <Link
              to="/browse"
              className="inline-flex items-center gap-2 border border-gray-700 hover:border-gray-500 text-gray-300 hover:text-white font-semibold rounded-full py-4 px-8 text-base transition-all"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="5 3 19 12 5 21 5 3"/></svg>
              Watch free preview
            </Link>
          )}
        </div>

        {/* Micro trust */}
        <p className="text-xs text-gray-600 tracking-wide">
          GST invoice included &nbsp;·&nbsp; Secure checkout via Easebuzz &nbsp;·&nbsp; Instant access
        </p>
      </div>
    </div>
  );

  // ── 2. TRUST STRIP ────────────────────────────────────────────────
  const TrustStrip = () => (
    <div className="bg-gray-900 border-y border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
          {[
            { icon: <Icon name="lock" className="w-4 h-4" />, text: 'Secure payment' },
            { icon: <Icon name="repeat" className="w-4 h-4" />, text: 'Lifetime access' },
            { icon: <Icon name="file-text" className="w-4 h-4" />, text: 'GST invoice' },
            { icon: <Icon name="smartphone" className="w-4 h-4" />, text: 'Any device' },
            { icon: <Icon name="zap" className="w-4 h-4" />, text: 'Instant access' },
          ].map(({ icon, text }) => (
            <div key={text} className="flex items-center gap-2 text-gray-400 text-xs sm:text-sm font-medium whitespace-nowrap">
              <span className="text-base">{icon}</span>
              {text}
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  // ── 3. WHAT YOU GET ───────────────────────────────────────────────
  const WhatYouGet = () => (
    <div className="bg-white py-16 sm:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <p className="text-xs font-bold uppercase tracking-widest text-red-600 mb-3">What you get</p>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-gray-900 tracking-tight mb-4">
            Everything in one membership
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-sm sm:text-base">
            No upsells. No tiers. One payment unlocks all of this.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {[
            {
              emoji: <Icon name="target" className="w-5 h-5 sm:w-6 h-6 text-red-600" />,
              color: 'bg-red-50 border-red-100',
              iconBg: 'bg-red-100',
              title: 'Expert-curated courses',
              desc: 'Every course is handpicked for practical value. No filler — only skills that translate directly to real results.',
            },
            {
              emoji: <Icon name="book-open" className="w-5 h-5 sm:w-6 h-6 text-orange-600" />,
              color: 'bg-orange-50 border-orange-100',
              iconBg: 'bg-orange-100',
              title: 'Growing course library',
              desc: 'New categories and courses are added regularly. Your membership grows in value over time at no extra cost.',
            },
            {
              emoji: <Icon name="repeat" className="w-5 h-5 sm:w-6 h-6 text-gray-700" />,
              color: 'bg-gray-50 border-gray-100',
              iconBg: 'bg-gray-200',
              title: 'Lifetime access',
              desc: 'Every new course added to Edgram is yours automatically. No renewal, no expiry.',
            },
            {
              emoji: <Icon name="check-circle" className="w-5 h-5 sm:w-6 h-6 text-green-600" />,
              color: 'bg-green-50 border-green-100',
              iconBg: 'bg-green-100',
              title: 'Progress tracking',
              desc: 'Mark videos complete, see your progress per course, and stay motivated with visual dashboards.',
            },
            {
              emoji: <Icon name="file-text" className="w-5 h-5 sm:w-6 h-6 text-blue-600" />,
              color: 'bg-blue-50 border-blue-100',
              iconBg: 'bg-blue-100',
              title: 'GST invoice',
              desc: 'A proper tax invoice is generated for every purchase — useful for business expense claims.',
            },
            {
              emoji: <Icon name="graduation-cap" className="w-5 h-5 sm:w-6 h-6 text-purple-600" />,
              color: 'bg-purple-50 border-purple-100',
              iconBg: 'bg-purple-100',
              title: 'Self-paced learning',
              desc: 'No deadlines. No pressure. Learn in 10-minute bursts or binge entire courses — your choice.',
            },
          ].map(({ emoji, color, iconBg, title, desc }) => (
            <div key={title} className={`rounded-2xl border p-5 sm:p-6 ${color} hover:shadow-md transition group`}>
              <div className={`w-10 h-10 sm:w-12 sm:h-12 ${iconBg} rounded-xl flex items-center justify-center text-xl sm:text-2xl mb-4`}>
                {emoji}
              </div>
              <h3 className="font-bold text-gray-900 text-base sm:text-lg mb-2">{title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  // ── 4. COURSE PREVIEW ─────────────────────────────────────────────
  const CoursePreview = () => {
    if (featuredCats.length === 0) return null;
    return (
      <div className="bg-gray-50 py-16 sm:py-20 border-t border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 sm:mb-12">
            <p className="text-xs font-bold uppercase tracking-widest text-red-600 mb-3">Course library</p>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-gray-900 tracking-tight mb-4">
              A sneak peek inside
            </h2>
            <p className="text-gray-500 max-w-xl mx-auto text-sm sm:text-base">
              These are the categories waiting for you. New content added regularly.
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mb-8">
            {featuredCats.map(cat => {
              const catVideos = (content?.videos || []).filter(v => v.categoryId === cat.id);
              const freeVideo = catVideos.find(v => v.isFreePreview);
              const firstVideo = catVideos[0];
              const linkTarget = freeVideo ? `/video/${freeVideo.id}` : `/browse/${cat.id}`;
              return (
                <Link key={cat.id} to={linkTarget} className="bg-white rounded-2xl overflow-hidden border border-gray-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 group block">
                  <div className="relative h-44 sm:h-48 overflow-hidden">
                    {firstVideo ? (
                      <img
                        src={ytThumb(firstVideo.videoId)}
                        className="w-full h-full object-cover group-hover:scale-105 transition duration-500"
                        alt={cat.name}
                      />
                    ) : (
                      <div className="w-full h-full bg-gradient-to-br from-orange-400 to-red-600 flex items-center justify-center text-5xl">📚</div>
                    )}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
                    {/* Play button overlay on hover */}
                    <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                      <div className="w-14 h-14 bg-white/90 rounded-full flex items-center justify-center shadow-xl">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="#dc2626"><polygon points="5 3 19 12 5 21 5 3"/></svg>
                      </div>
                    </div>
                    <div className="absolute bottom-3 left-4 right-4">
                      <p className="text-white font-bold text-base sm:text-lg leading-tight drop-shadow">{cat.name}</p>
                    </div>
                    <div className="absolute top-3 right-3 bg-black/60 backdrop-blur-sm text-white text-xs px-2.5 py-1 rounded-full font-medium">
                      {catVideos.length} videos
                    </div>
                    {freeVideo && (
                      <div className="absolute top-3 left-3 bg-green-600 text-white text-xs px-2.5 py-1 rounded-full font-semibold">
                        Free preview
                      </div>
                    )}
                  </div>
                  <div className="p-4">
                    <p className="text-gray-500 text-sm leading-relaxed line-clamp-2">
                      {cat.description || 'Explore this category with your Edgram membership.'}
                    </p>
                    <p className="text-xs text-red-600 font-semibold mt-2">
                      {freeVideo ? 'Watch free preview →' : 'Browse category →'}
                    </p>
                  </div>
                </Link>
              );
            })}
          </div>
          <div className="text-center">
            <Link
              to="/browse"
              className="inline-flex items-center gap-2 border-2 border-gray-200 hover:border-red-500 hover:text-red-600 text-gray-600 font-semibold py-3 px-7 rounded-full transition-all text-sm sm:text-base"
            >
              Browse all courses →
            </Link>
          </div>
        </div>
      </div>
    );
  };

  // ── 5. HOW IT WORKS ───────────────────────────────────────────────
  const HowItWorks = () => (
    <div className="bg-white py-16 sm:py-20 border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <p className="text-xs font-bold uppercase tracking-widest text-red-600 mb-3">How it works</p>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-gray-900 tracking-tight">
            Three steps to start learning
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 max-w-4xl mx-auto">
          {[
            {
              n: '1',
              title: 'Pay once',
              desc: 'Complete checkout with ₹6,999 via UPI, card, or NetBanking. GST invoice generated instantly.',
              color: 'bg-red-600',
            },
            {
              n: '2',
              title: 'Access instantly',
              desc: 'Your dashboard is ready the second payment clears. No waiting, no verification delays.',
              color: 'bg-orange-500',
            },
            {
              n: '3',
              title: 'Learn at your pace',
              desc: 'Watch from any device, track your progress, revisit any video anytime. It never expires.',
              color: 'bg-gray-800',
            },
          ].map(({ n, title, desc, color }) => (
            <div key={n} className="relative bg-gray-50 rounded-2xl p-6 sm:p-8 border border-gray-100 hover:shadow-md transition">
              <div className={`w-12 h-12 ${color} rounded-xl flex items-center justify-center text-white text-xl font-black mb-5`}>
                {n}
              </div>
              <h3 className="font-bold text-gray-900 text-lg mb-2">{title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  // ── 6. TESTIMONIALS ───────────────────────────────────────────────
  const Testimonials = () => {
    const list = [
      { name: 'Priya S.', role: 'Edgram member', quote: 'The content is genuinely practical. I started applying it within a week of joining.' },
      { name: 'Rohan K.', role: 'Entrepreneur', quote: 'Simple platform, great videos. The content library keeps growing — best value for money.' },
      { name: 'Aisha B.', role: 'Edgram member', quote: 'I was skeptical at first. Edgram completely changed how I approach learning online.' },
      { name: 'Karthik V.', role: 'Freelancer', quote: "Best investment I've made. Practical, well-structured, and directly applicable to real life." },
    ];
    return (
      <div className="bg-gray-950 py-16 sm:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <p className="text-xs font-bold uppercase tracking-widest text-red-500 mb-3">Member stories</p>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-white tracking-tight">
              Real people, real results
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {list.map(({ name, role, quote }) => (
              <div
                key={name}
                className="bg-gray-900 border border-gray-800 rounded-2xl p-5 sm:p-6 hover:border-red-900/50 transition-all hover:-translate-y-0.5"
              >
                {/* Stars */}
                <div className="flex gap-0.5 mb-4">
                  {[1,2,3,4,5].map(s => (
                    <svg key={s} xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="#f97316">
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                    </svg>
                  ))}
                </div>
                <p className="text-gray-300 text-sm leading-relaxed mb-4">"{quote}"</p>
                <div>
                  <p className="text-white font-semibold text-sm">{name}</p>
                  <p className="text-gray-500 text-xs">{role}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  // ── 7. PRICING HIGHLIGHT ──────────────────────────────────────────
  const Pricing = () => (
    <div className="bg-white py-16 sm:py-20 border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-xl mx-auto text-center">
          <p className="text-xs font-bold uppercase tracking-widest text-red-600 mb-3">Simple pricing</p>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-gray-900 tracking-tight mb-4">
            One price. Everything included.
          </h2>
          <div className="bg-gray-950 rounded-3xl p-8 sm:p-10 text-center mt-8">
            <p className="text-gray-400 text-sm mb-2 uppercase tracking-widest font-medium">Lifetime membership</p>
            <div className="text-5xl sm:text-6xl font-black text-white mb-1">₹6,999</div>
            <p className="text-gray-500 text-sm mb-8">One-time · GST included · Never pay again</p>
            <div className="grid grid-cols-2 gap-3 text-left mb-8">
              {[
                'All current courses',
                'All future courses (free)',
                'Progress tracking',
                'GST invoice',
                'New courses (free)',
                'Any device access',
              ].map(f => (
                <div key={f} className="flex items-center gap-2 text-gray-300 text-sm">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>
                  {f}
                </div>
              ))}
            </div>
            <PrimaryCTA size="lg" />
          </div>
        </div>
      </div>
    </div>
  );

  // ── 8. FINAL CTA ─────────────────────────────────────────────────
  const FinalCTA = () => (
    <div className="bg-gradient-to-br from-red-700 to-orange-600 py-16 sm:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-white tracking-tight mb-4">
          Ready to start learning today?
        </h2>
        <p className="text-red-100 text-base sm:text-lg max-w-xl mx-auto mb-10 leading-relaxed">
          Join Edgram. Pay once. Access our entire course library forever — and everything we add in the future.
        </p>
        <Link
          to={isGuest ? '/register' : '/dashboard'}
          className="inline-block bg-white text-red-700 font-black text-base sm:text-lg py-4 px-10 rounded-full hover:bg-gray-100 active:scale-95 transition-all shadow-xl"
        >
          {isGuest ? 'Get lifetime access — ₹6,999' : 'Go to my dashboard'}
        </Link>
        <p className="text-red-200/70 text-xs mt-5">
          GST invoice · Secure checkout · Instant access
        </p>
      </div>
    </div>
  );

  return (
    <>
      <Hero />
      <TrustStrip />
      <WhatYouGet />
      <CoursePreview />
      <HowItWorks />
      <Testimonials />
      <Pricing />
      <FinalCTA />
    </>
  );
};


/* =========================
   PUBLIC PAGES - CATEGORY LIST (UPDATED to use global state)
   ========================= */

function CategoryList() {
  const { content, isLoading, error, fetchData, progress, memberUser } = useAppGlobal();
  const userType = localStorage.getItem(LS_USER_TYPE) || 'guest';

  if (isLoading) return <Container><SkeletonCategoryGrid /></Container>;
  if (error) return <Container><Card><div className="text-center py-4 text-red-600">Error: {error}</div></Card></Container>;

  const userProgress = progress[memberUser?.id] || [];

  return (
    <Container>
      <h2 className="text-3xl font-bold mb-2 text-center">Explore Our Premium Content</h2>
      <p className="text-gray-600 mb-8 text-center max-w-xl mx-auto">
        Click on a category to see the detailed video courses available to Edgram members.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {(content?.categories || []).map(cat => {
          const catVideos = content.videos.filter(v => v.categoryId === cat.id);
          const completed = catVideos.filter(v => userProgress.includes(v.id)).length;
          const total = catVideos.length;
          const pct = total > 0 ? Math.round((completed / total) * 100) : 0;
          const isComplete = total > 0 && completed === total;

          return (
            <Link
              key={cat.id}
              to={`/browse/${cat.id}`}
              className="bg-white rounded-xl shadow-lg cursor-pointer overflow-hidden group hover:shadow-xl transition duration-300 border border-gray-100"
            >
              <div className="relative h-44 overflow-hidden">
                {catVideos[0] ? (
                  <img src={ytThumb(catVideos[0].videoId)} className="w-full h-full object-cover group-hover:scale-105 transition duration-500" alt={cat.name} />
                ) : (
                  <div className="w-full h-full bg-gradient-to-br from-orange-400 to-red-600 flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><path d="M12 2L2 7l10 5 10-5-10-5zm0 17v-10"/><path d="M2 12l10 5 10-5"/></svg>
                  </div>
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                <div className="absolute bottom-3 left-3 right-3">
                  <span className="text-white font-bold text-base drop-shadow">{cat.name}</span>
                </div>
                {total > 0 && <div className="absolute top-3 right-3 bg-black/50 backdrop-blur-sm text-white text-xs px-2 py-1 rounded-full font-medium">{total} videos</div>}
                {isComplete && (
                  <div className="absolute top-3 left-3 bg-green-600 text-white text-xs px-2 py-1 rounded-full font-semibold flex items-center gap-1"><Icon name="check-circle" className="w-3 h-3" /> Complete</div>
                )}
              </div>
              <div className="p-4">
                <p className="text-gray-500 text-sm mb-3 line-clamp-2">{cat.description}</p>

                {/* Progress bar — only shown for logged-in members */}
                {(userType === ROLE_MEMBER || userType === ROLE_SUPER_PREMIUM) && total > 0 && (
                  <div>
                    <div className="flex justify-between items-center mb-1">
                      <span className="text-xs text-gray-500">{completed} of {total} videos</span>
                      <span className={`text-xs font-semibold ${isComplete ? 'text-green-600' : pct > 0 ? 'text-orange-600' : 'text-gray-400'}`}>
                        {isComplete ? 'Completed' : pct > 0 ? `${pct}%` : 'Not started'}
                      </span>
                    </div>
                    <div className="h-1.5 bg-gray-100 rounded-full overflow-hidden">
                      <div
                        className={`h-1.5 rounded-full transition-all duration-500 ${isComplete ? 'bg-green-500' : 'bg-gradient-to-r from-orange-500 to-red-600'}`}
                        style={{ width: `${pct}%` }}
                      />
                    </div>
                  </div>
                )}

                {/* Video count for guests */}
                {userType === 'guest' && total > 0 && (
                  <div className="text-xs text-gray-400">{total} videos</div>
                )}
              </div>
            </Link>
          );
        })}
        {(content?.categories || []).length === 0 && (
          <EmptyState title="No Categories" message="Admin has not added any content categories yet." />
        )}
      </div>
    </Container>
  );
}
function CategoryDetail() {
    const { categoryId } = useParams();
    const navigate = useNavigate();
    const userType = localStorage.getItem(LS_USER_TYPE) || 'guest';
    const { content, progress, memberUser, isLoading, error } = useAppGlobal();
    
    if (isLoading) return <Container><SkeletonVideoGrid /></Container>;
    if (error) return <Container><Card><div className="text-center py-4 text-red-600">Error: {error}</div></Card></Container>;

    const cat = content.categories.find(c => c.id === categoryId);
    const videos = content.videos.filter(v => v.categoryId === categoryId);
    const userProgress = progress[memberUser?.id] || [];

    // Require token + correct role — prevents localStorage tampering
    const token = localStorage.getItem(LS_TOKEN);
    const isMember = !!(token && (userType === ROLE_MEMBER || userType === ROLE_SUPER_PREMIUM));

    const onClickVideo = (v) => {
        if (v.isFreePreview || isMember) {
            navigate(`/video/${v.id}`);
        } else {
            toast.error('This video requires membership. Join Edgram to unlock all content.');
            navigate('/register');
        }
    };
    
    return (
        <Container>
            <Link to="/browse" className={`${PRIMARY_COLOR_CLASS} mb-4 inline-block font-medium hover:text-red-700`}>&larr; Back to Categories</Link>
            <h2 className="text-3xl font-bold mb-2 text-gray-800">{cat ? cat.name : 'Category'}</h2>
            <p className="text-gray-600 mb-6 text-lg">{cat ? cat.description : ''}</p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {videos.map(v => (
                    <div key={v.id} className="bg-white rounded-xl shadow-lg overflow-hidden cursor-pointer hover:shadow-xl transition duration-200" onClick={() => onClickVideo(v)}>
                        <div className="relative">
                            <img src={ytThumb(v.videoId)} className="w-full h-40 object-cover" alt={v.title} />
                            {!v.isFreePreview && <div className="absolute inset-0 bg-black/50 text-white flex items-center justify-center text-xl font-bold gap-2"><Icon name="lock" className="w-6 h-6" /> Locked (Premium)</div>}
                            {userProgress.includes(v.id) && <div className="absolute top-2 right-2 bg-green-600 text-white text-xs px-3 py-1 rounded-full font-semibold flex items-center gap-1"><Icon name="check-circle" className="w-3 h-3" /> Completed</div>}
                        </div>
                        <div className="p-4">
                            <h4 className="font-semibold text-lg text-gray-800">{v.title}</h4>
                            <p className="text-sm text-gray-500 mt-1">{v.isFreePreview ? 'Free Preview' : 'Premium'}</p>
                        </div>
                    </div>
                ))}
                {videos.length === 0 && (
                    <EmptyState title="No Videos" message="There are no videos in this category yet." />
                )}
            </div>
        </Container>
    );
}

function VideoPlayer() {
    const { videoId } = useParams();
    const navigate = useNavigate();
    const userType = localStorage.getItem(LS_USER_TYPE) || 'guest';
    const { content, progress, memberUser, isLoading, error, fetchData } = useAppGlobal();

    const video = content.videos.find(v => v.id === videoId);
    const category = video ? content.categories.find(c => c.id === video.categoryId) : null;
    const allCatVideos = video ? content.videos.filter(v => v.categoryId === video.categoryId) : [];
    const videoIndex = allCatVideos.findIndex(v => v.id === videoId);
    const nextVideo = allCatVideos[videoIndex + 1] || null;
    const sidebarVideos = allCatVideos.filter(v => v.id !== videoId);

    // Must have BOTH a valid token AND a paid role — prevents localStorage tampering
    const token = localStorage.getItem(LS_TOKEN);
    const isMember = !!(token && (userType === ROLE_MEMBER || userType === ROLE_SUPER_PREMIUM));
    const canWatch = video?.isFreePreview || isMember;

    const isComplete = useMemo(() => {
        if (!memberUser) return false;
        return (progress[memberUser.id] || []).includes(videoId);
    }, [videoId, memberUser, progress]);

    const [marking, setMarking] = useState(false);
    const markComplete = async () => {
        if (!memberUser) { toast.error('Please log in to track progress.'); return; }
        setMarking(true);
        try {
            await ApiClient.saveProgress(videoId);
            toast.success('Marked as complete!');
            await fetchData();
        } catch (e) {
            toast.error('Could not save progress: ' + e.message);
        } finally { setMarking(false); }
    };

    if (isLoading) return (
        <div className="min-h-screen bg-gray-950 flex items-center justify-center">
            <div className="text-center text-white">
                <svg className="animate-spin w-10 h-10 mx-auto mb-4 text-red-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/></svg>
                <p className="text-gray-400 text-sm">Loading video...</p>
            </div>
        </div>
    );
    if (!video) return (
        <div className="min-h-screen bg-gray-950 flex items-center justify-center text-center px-4">
            <div>
                <div className="flex justify-center mb-4 text-gray-600"><Icon name="video" className="w-14 h-14" /></div>
                <h2 className="text-white text-xl font-bold mb-2">Video not found</h2>
                <p className="text-gray-400 text-sm mb-6">This video may have been removed or the link is incorrect.</p>
                <Link to="/browse" className="bg-red-600 text-white px-6 py-3 rounded-xl font-semibold hover:bg-red-700 transition">Back to courses</Link>
            </div>
        </div>
    );

    return (
        <div className="min-h-screen bg-gray-950">
            {/* Top bar */}
            <div className="bg-gray-900 border-b border-gray-800 px-4 sm:px-6 py-3 flex items-center gap-3">
                <button
                    onClick={() => navigate(`/browse/${video.categoryId}`)}
                    className="flex items-center gap-2 text-gray-400 hover:text-white transition text-sm font-medium"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6"/></svg>
                    Back
                </button>
                <span className="text-gray-700">·</span>
                <Link to="/browse" className="text-gray-400 hover:text-white transition text-sm hidden sm:inline">Courses</Link>
                <span className="text-gray-700 hidden sm:inline">›</span>
                <span className="text-gray-400 text-sm hidden sm:inline truncate max-w-[160px]">{category?.name}</span>
                <span className="text-gray-700 hidden sm:inline">›</span>
                <span className="text-white text-sm font-medium truncate max-w-[200px]">{video.title}</span>
            </div>

            <div className="max-w-7xl mx-auto px-0 sm:px-4 lg:px-8 py-0 sm:py-6">
                <div className="flex flex-col lg:flex-row gap-0 lg:gap-6">

                    {/* ── Main video area ── */}
                    <div className="flex-1 min-w-0">
                        {/* Video player */}
                        <div className="bg-black w-full aspect-video relative">
                            {canWatch ? (
                                <iframe
                                    className="w-full h-full"
                                    title={video.title}
                                    src={ytEmbed(video.videoId)}
                                    allowFullScreen
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                />
                            ) : (
                                /* Locked state for guests / non-members */
                                <div className="w-full h-full flex flex-col items-center justify-center bg-gray-900 text-white text-center px-6 relative">
                                    <img
                                        src={ytThumb(video.videoId)}
                                        className="absolute inset-0 w-full h-full object-cover opacity-20"
                                        alt=""
                                    />
                                    <div className="relative z-10">
                                        <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4 shadow-xl">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                                        </div>
                                        <h3 className="text-xl font-bold mb-2">Premium content</h3>
                                        <p className="text-gray-400 text-sm mb-6 max-w-sm">This video is part of the paid membership. Get lifetime access for a one-time payment.</p>
                                        <Link to="/register" className="bg-red-600 hover:bg-red-700 text-white font-bold px-8 py-3 rounded-full transition shadow-lg">
                                            Get access — ₹6,999
                                        </Link>
                                        {userType === 'guest' && (
                                            <p className="text-gray-500 text-xs mt-4">
                                                Already a member?{' '}
                                                <Link to="/login" className="text-red-400 hover:underline">Sign in</Link>
                                            </p>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Video info bar */}
                        <div className="bg-gray-900 sm:bg-white sm:rounded-2xl sm:mt-4 sm:border sm:border-gray-100 p-4 sm:p-6">
                            <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
                                <div className="flex-1 min-w-0">
                                    <div className="flex items-center gap-2 mb-2 flex-wrap">
                                        {video.isFreePreview && (
                                            <span className="bg-green-100 text-green-700 text-xs font-bold px-2.5 py-1 rounded-full">Free Preview</span>
                                        )}
                                        {category && (
                                            <span className="bg-gray-100 text-gray-500 text-xs font-medium px-2.5 py-1 rounded-full">{category.name}</span>
                                        )}
                                        {allCatVideos.length > 1 && (
                                            <span className="text-gray-400 text-xs">Video {videoIndex + 1} of {allCatVideos.length}</span>
                                        )}
                                    </div>
                                    <h1 className="text-lg sm:text-xl font-bold text-white sm:text-gray-900 leading-tight">{video.title}</h1>
                                </div>

                                {/* Mark complete — only for logged-in members */}
                                {isMember && (
                                    <button
                                        onClick={markComplete}
                                        disabled={isComplete || marking}
                                        className={`flex-shrink-0 flex items-center gap-2 px-5 py-2.5 rounded-xl font-semibold text-sm transition-all ${
                                            isComplete
                                                ? 'bg-green-100 text-green-700 cursor-default border border-green-200'
                                                : 'bg-green-600 hover:bg-green-700 text-white shadow-sm hover:shadow-md active:scale-95'
                                        }`}
                                    >
                                        {marking ? (
                                            <svg className="animate-spin w-4 h-4" viewBox="0 0 24 24" fill="none"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/></svg>
                                        ) : isComplete ? (
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>
                                        ) : null}
                                        {isComplete ? 'Completed' : marking ? 'Saving...' : 'Mark complete'}
                                    </button>
                                )}
                            </div>

                            {/* Next video button */}
                            {nextVideo && isMember && (
                                <div className="mt-4 pt-4 border-t border-gray-800 sm:border-gray-100">
                                    <Link
                                        to={`/video/${nextVideo.id}`}
                                        className="flex items-center gap-3 group"
                                    >
                                        <img src={ytThumb(nextVideo.videoId)} className="w-20 h-12 object-cover rounded-lg flex-shrink-0" alt={nextVideo.title} />
                                        <div className="flex-1 min-w-0">
                                            <p className="text-xs text-gray-400 mb-0.5 font-medium">Up next</p>
                                            <p className="text-sm font-semibold text-white sm:text-gray-800 group-hover:text-red-600 transition truncate">{nextVideo.title}</p>
                                        </div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-gray-500 flex-shrink-0"><polyline points="9 18 15 12 9 6"/></svg>
                                    </Link>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* ── Sidebar — all videos in category ── */}
                    <div className="w-full lg:w-80 xl:w-96 flex-shrink-0">
                        <div className="bg-gray-900 sm:bg-white sm:rounded-2xl sm:border sm:border-gray-100 overflow-hidden">
                            <div className="px-4 py-3 border-b border-gray-800 sm:border-gray-100 flex items-center justify-between">
                                <h3 className="font-bold text-white sm:text-gray-900 text-sm">{category?.name || 'Course content'}</h3>
                                <span className="text-xs text-gray-400">{allCatVideos.length} videos</span>
                            </div>
                            <div className="divide-y divide-gray-800 sm:divide-gray-100 max-h-[60vh] overflow-y-auto">
                                {allCatVideos.map((v, idx) => {
                                    const isCurrentVideo = v.id === videoId;
                                    const isDone = memberUser && (progress[memberUser.id] || []).includes(v.id);
                                    const isLocked = !v.isFreePreview && !isMember;
                                    return (
                                        <div
                                            key={v.id}
                                            onClick={() => {
                                                if (isLocked) {
                                                    // Show inline upsell toast — do NOT navigate to the video
                                                    toast(
                                                        (t) => (
                                                            <span style={{display:'flex',flexDirection:'column',gap:'8px'}}>
                                                                <strong style={{fontSize:'13px'}}><Icon name="lock" className="w-3.5 h-3.5 inline" /> Premium content</strong>
                                                                <span style={{fontSize:'12px',color:'#666'}}>Get membership to unlock all videos.</span>
                                                                <button
                                                                    onClick={() => { toast.dismiss(t.id); navigate('/register'); }}
                                                                    style={{background:'#dc2626',color:'#fff',border:'none',borderRadius:'8px',padding:'6px 14px',fontSize:'12px',fontWeight:'700',cursor:'pointer',alignSelf:'flex-start'}}
                                                                >
                                                                    Get access — ₹6,999
                                                                </button>
                                                            </span>
                                                        ),
                                                        { duration: 6000 }
                                                    );
                                                } else {
                                                    navigate(`/video/${v.id}`);
                                                }
                                            }}
                                            className={`flex items-start gap-3 p-3 transition-all ${
                                                isLocked
                                                    ? 'cursor-default opacity-60'
                                                    : isCurrentVideo
                                                        ? 'cursor-pointer bg-red-950/40 sm:bg-red-50 border-l-2 border-red-500'
                                                        : 'cursor-pointer hover:bg-gray-800 sm:hover:bg-gray-50'
                                            }`}
                                        >
                                            {/* Index or completion */}
                                            <div className={`w-7 h-7 rounded-full flex-shrink-0 flex items-center justify-center text-xs font-bold mt-0.5 ${
                                                isDone ? 'bg-green-600 text-white' :
                                                isCurrentVideo ? 'bg-red-600 text-white' :
                                                isLocked ? 'bg-gray-600 sm:bg-gray-300 text-gray-400' :
                                                'bg-gray-700 sm:bg-gray-200 text-gray-300 sm:text-gray-500'
                                            }`}>
                                                {isDone ? '✓' : isLocked ? <Icon name="lock" className="w-3 h-3" /> : idx + 1}
                                            </div>
                                            {/* Thumbnail */}
                                            <div className="relative flex-shrink-0">
                                                <img src={ytThumb(v.videoId)} className="w-20 h-12 object-cover rounded-lg" alt={v.title} />
                                                {isLocked && (
                                                    <div className="absolute inset-0 bg-black/70 rounded-lg flex items-center justify-center">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                                                    </div>
                                                )}
                                            </div>
                                            {/* Info */}
                                            <div className="flex-1 min-w-0">
                                                <p className={`text-xs font-semibold leading-tight line-clamp-2 ${isCurrentVideo ? 'text-red-400 sm:text-red-600' : isLocked ? 'text-gray-500' : 'text-gray-200 sm:text-gray-800'}`}>{v.title}</p>
                                                <p className={`text-xs mt-1 font-medium ${v.isFreePreview ? 'text-green-500' : isLocked ? 'text-red-400' : 'text-gray-400'}`}>
                                                    {v.isFreePreview ? '✓ Free preview' : isLocked ? <><Icon name="lock" className="w-3 h-3 inline" /> Members only</> : 'Premium'}
                                                </p>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

/* =========================
   MEMBER: Register / Login / Dashboard (REPLACED ALL LS/MOCK API CALLS)
   ========================= */

function MemberRegister({ setUserType }) {
  const { fetchData } = useAppGlobal();
  const q = parseQuery();
  const refCode = q.ref || '';
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false); 
  
  const securityQuestions = [
    "What was your first pet's name?",
    "What is your mother's maiden name?",
    "What was the name of your elementary school?",
    "In what city were you born?",
    "What is your favorite book?"
  ];

  const [secretQ, setSecretQ] = useState(securityQuestions[0]); 
  const [secretA, setSecretA] = useState('');
  const [agreed, setAgreed] = useState(false);
  const [step, setStep] = useState(1);
  const [legalDocs, setLegalDocs] = useState({ termsUrl: '#', privacyUrl: '#' });
  const price = 6999;
  const navigate = useNavigate();
  
  useEffect(() => {
    // These still need dedicated async calls since they are outside global state
    ApiClient.fetchLegalDocs().then(setLegalDocs);
  }, []);


  const onSubmit = async (e) => {
    e.preventDefault();

    if (!name || !email || !password || !secretQ || !secretA) {
      toast.error('Please fill all fields.');
      return;
    }
    if (password.length < 8) {
      toast.error('Password must be at least 8 characters.');
      return;
    }
    if (!agreed) {
      toast.error('You must agree to the Terms and Conditions.');
      return;
    }
    // Ask the server whether this email is still free BEFORE moving on to
    // payment. The browser used to check against a member list it is not
    // allowed to read, so a clash was only discovered after the customer paid.
    try {
      const check = await ApiClient.checkEmailAvailable(email);
      if (check && check.available === false) {
        toast.error('An account already exists with this email. Please use the Login screen.');
        return;
      }
    } catch (err) {
      console.error('Email availability check failed:', err.message);
    }
    setStep(2);
  };

      const afterPaid = async (paymentTicket) => {
    setLoading(true);
    
    // 1. Prepare New User Data
            const newUser = {
        name,
        email,
        password,
        secretQuestion: secretQ, 
        secretAnswer: secretA,  
        role: ROLE_MEMBER,
        referralCode: generateReferralCode(),
        bank: { isVerified: false, accountNumber: '', ifsc: '', pan: '', chequeUrl: '' }, 
        status: STATUS_ACTIVE,
        referredBy: refCode || '', // server looks up the referrer and records the commission
                     paymentTicket, // proof from a real verified Easebuzz payment; backend rejects registration without it
    };

    try {
        // 2. API Call: Register New User & Get Auth Token/Data
        const regResponse = await ApiClient.registerUser(newUser);

        // Assuming API returns { token, user } on success
        if (!regResponse.user || !regResponse.token) {
            throw new Error('Registration failed, missing user data or token.');
        }

        const registeredUser = regResponse.user;
        localStorage.setItem(LS_TOKEN, regResponse.token);

        // 3. The sale record and any referral commission are now created by the
        // server as part of registration. Doing it here required the complete
        // member list (admin-only), which is why referral commissions were
        // never actually being saved.
        
        setMember(email, registeredUser.role);
        setUserType(registeredUser.role); 
        toast.success('Payment successful. Welcome to Edgram!');
        navigate('/dashboard');
    } catch (e) {
        toast.error('Registration error: ' + e.message);
        console.error("Registration flow failed:", e);
    } finally {
        setLoading(false);
        fetchData(); // Refresh global state
    }
  };

  // =====================
  // EASEBUZZ PAYMENT
  // =====================
  const payWithEasebuzz = async () => {
    if (!name || !email) {
      toast.error('Please fill in your name and email before paying.');
      return;
    }

    setLoading(true);
    try {
      // Generate unique transaction ID
      const txnid = 'EDGRAM_' + Date.now() + '_' + Math.random().toString(36).slice(2, 6).toUpperCase();

      // Call backend — backend handles hash computation and Easebuzz API call (avoids CORS)
      const res = await fetch(`${API_URL}/api/create-easebuzz-order`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          txnid,
          amount: String(price),
          productinfo: 'Edgram Lifetime Membership',
          firstname: name,
          email,
          phone: '9999999999',
          surl: `${APP_DOMAIN}/dashboard`,
          furl: `${APP_DOMAIN}/register`,
          udf1: refCode || '',
        })
      });

      const data = await res.json();

      if (data.status !== 1 || !data.data) {
        throw new Error(data.error_desc || data.msg || 'Could not initiate payment. Please try again.');
      }

      const accessKey = data.data;
       const checkoutKey = data.easebuzzKey || '03B3P99PQ'; // falls back to the old key only if the server didn't return one
       const checkoutEnv = data.easebuzzEnv || 'test'; // uses the server's real live/test setting instead of being hardcoded

      // Load Easebuzz SDK and open checkout popup
      const EasebuzzCheckout = await loadEasebuzzCheckout();
    const ebzCheckout = new EasebuzzCheckout(checkoutKey, checkoutEnv); // key + mode now come from the server (matches its live/test setting)

      ebzCheckout.initiatePayment({
        access_key: accessKey,
        onResponse: async (response) => {
                       setLoading(false);
                       if (response.status === 'success') {
                                        try {
                                                           const verifyRes = await fetch(`${API_URL}/api/verify-easebuzz-payment`, {
                                                                                method: 'POST',
                                                                                headers: { 'Content-Type': 'application/json' },
                                                                                body: JSON.stringify(response)
                                                           });
                                                           const verifyData = await verifyRes.json();
                                                                           if (verifyData.verified && verifyData.paymentTicket) {
                                                                                toast.success('Payment successful! Setting up your account...');
                                                                                                  afterPaid(verifyData.paymentTicket);
                                                           } else {
                                                                                toast.error('Payment verification failed. Please contact support.');
                                                                                console.error('Verification failed:', verifyData);
                                                           }
                                        } catch (e) {
                                                           toast.error('Could not verify payment. Please contact support.');
                                                           console.error('Verification error:', e);
                                        }
                       } else {
                                        toast.error('Payment failed or cancelled. Please try again.');
                                        console.error('Easebuzz response:', response);
                       }
},
        theme: '#dc2626'
      });

    } catch (e) {
      toast.error('Payment failed: ' + e.message);
      console.error('Easebuzz error:', e);
      setLoading(false);
    }
  };

  const [showPassword, setShowPassword] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);

  // Render Google button on mount — far more reliable than gsi.prompt()
  useEffect(() => {
    const callback = async (response) => {
      setGoogleLoading(true);
      try {
        const res = await fetch(`${API_URL}/api/auth/google`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ credential: response.credential })
        });
        const data = await res.json();
        // Existing member — log them in directly
        if (data.token && data.user && data.isExisting) {
          localStorage.setItem(LS_TOKEN, data.token);
          setMember(data.user.email, data.user.role);
          setUserType(data.user.role);
          toast.success('Welcome back! You already have an account.');
          navigate('/dashboard');
          return;
        }
        // New user — pre-fill details and go to payment
        if (data.googleUser) {
          setName(data.googleUser.name || '');
          setEmail(data.googleUser.email || '');
          // Google sign-up used to jump straight to payment without ever setting
          // a password, and with a placeholder security answer, so the account
          // could not actually be created afterwards and could never be
          // recovered. Name and email are pre-filled and the customer now
          // finishes the short form as normal before paying.
          toast.success('Google account verified. Please choose a password and a security question to continue.');
        } else {
          toast.error(data.error || 'Google signup failed. Please try again.');
        }
      } catch (err) {
        toast.error('Google signup error: ' + err.message);
      } finally {
        setGoogleLoading(false);
      }
    };
    renderGoogleButton('google-signup-btn', callback).catch(() => {});
  }, []);

  const inputClass = "w-full border border-gray-200 bg-gray-50 focus:bg-white focus:border-red-400 focus:ring-2 focus:ring-red-100 rounded-xl px-4 py-3 text-sm text-gray-800 placeholder-gray-400 outline-none transition";
  const labelClass = "block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5";

  const ValueProp = () => (
    <div className="bg-gradient-to-br from-red-600 to-orange-500 rounded-2xl p-6 text-white h-full flex flex-col justify-between">
      <div>
        <div className="inline-flex items-center gap-2 bg-white/20 rounded-full px-3 py-1 text-xs font-semibold mb-4">
          <Icon name="graduation-cap" className="w-4 h-4" /> Lifetime Access
        </div>
        <h3 className="text-xl font-bold mb-2">Everything you need to grow</h3>
        <p className="text-white/80 text-sm mb-6">One payment. Unlimited access. Learn at your own pace, forever.</p>
        <div className="space-y-3">
          {[
            ['target', 'Expert-curated courses', 'Practical content that delivers real-world results'],
            ['book-open', 'Growing course library', 'New courses added regularly across multiple categories'],
            ['check-circle', 'Progress Tracking', 'Track your learning journey'],
            ['file-text', 'GST Invoice Included', 'For your records and claims'],
          ].map(([icon, title, desc]) => (
            <div key={title} className="flex items-start gap-3">
              <span className="mt-0.5"><Icon name={icon} className="w-5 h-5" /></span>
              <div>
                <p className="font-semibold text-sm">{title}</p>
                <p className="text-white/70 text-xs">{desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="mt-6 pt-4 border-t border-white/20">
        <p className="text-xs text-white/60 text-center">Trusted by learners across India</p>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-10 px-4">
      <div className="w-full max-w-4xl">

        {/* Header */}
        <div className="text-center mb-8">
          <Link to="/" className="inline-flex items-center gap-2 mb-4">
            <span className="text-2xl font-black text-red-600">Edgram</span>
          </Link>
          <div className="flex items-center justify-center gap-3 mt-2">
            {[1, 2].map(s => (
              <div key={s} className="flex items-center gap-2">
                <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold transition-all ${step >= s ? 'bg-red-600 text-white' : 'bg-gray-200 text-gray-400'}`}>{s}</div>
                <span className={`text-xs font-medium hidden sm:block ${step >= s ? 'text-red-600' : 'text-gray-400'}`}>{s === 1 ? 'Your Details' : 'Payment'}</span>
                {s < 2 && <div className={`w-12 h-0.5 ${step > s ? 'bg-red-600' : 'bg-gray-200'}`} />}
              </div>
            ))}
          </div>
        </div>

        {/* Step 1 */}
        {step === 1 && (
          <div className="grid md:grid-cols-5 gap-6 items-start">
            {/* Form — 3/5 width */}
            <div className="md:col-span-3 bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-1">Create your account</h2>
              <p className="text-sm text-gray-500 mb-6">Fill in your details to get started</p>

              {refCode && (
                <div className="flex items-center gap-2 text-sm text-green-700 bg-green-50 border border-green-200 rounded-xl px-4 py-3 mb-5">
                  <span>🎉</span>
                  <span>Referral code <strong>{refCode}</strong> applied — you're all set!</span>
                </div>
              )}

              {/* Google renders its own button here */}
              <div id="google-signup-btn" className="w-full mb-2 flex justify-center min-h-[44px]">
                {googleLoading && (
                  <div className="flex items-center gap-2 text-gray-500 text-sm py-3">
                    <svg className="animate-spin" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 12a9 9 0 11-6.219-8.56"/></svg>
                    Connecting to Google...
                  </div>
                )}
              </div>
              <div className="flex items-center gap-3 mb-2">
                <div className="flex-1 h-px bg-gray-100" />
                <span className="text-xs text-gray-400 font-medium">or fill in manually</span>
                <div className="flex-1 h-px bg-gray-100" />
              </div>

              <form onSubmit={onSubmit} className="space-y-4">
                <div>
                  <label className={labelClass}>Full Name</label>
                  <input className={inputClass} placeholder="e.g. Rahul Sharma" value={name} onChange={e => setName(e.target.value)} />
                </div>
                <div>
                  <label className={labelClass}>Email Address</label>
                  <input className={inputClass} type="email" placeholder="you@example.com" value={email} onChange={e => setEmail(e.target.value)} />
                </div>
                <div>
                  <label className={labelClass}>Password</label>
                  <div className="relative">
                    <input className={inputClass + " pr-12"} type={showPassword ? 'text' : 'password'} placeholder="Min. 8 characters" value={password} onChange={e => setPassword(e.target.value)} />
                    <button type="button" onClick={() => setShowPassword(p => !p)} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 text-xs font-medium">
                      {showPassword ? 'Hide' : 'Show'}
                    </button>
                  </div>
                </div>

                <div className="bg-gray-50 rounded-xl p-4 border border-gray-100 space-y-3">
                  <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide">Security Question (for password recovery)</p>
                  <select className={inputClass} value={secretQ} onChange={e => setSecretQ(e.target.value)}>
                    {securityQuestions.map(q => <option key={q} value={q}>{q}</option>)}
                  </select>
                  <input className={inputClass} placeholder="Your answer" value={secretA} onChange={e => setSecretA(e.target.value)} />
                </div>

                <label className="flex items-start gap-3 cursor-pointer">
                  <input type="checkbox" checked={agreed} onChange={() => setAgreed(!agreed)} className="mt-0.5 h-4 w-4 rounded text-red-600 focus:ring-red-500 border-gray-300 flex-shrink-0" />
                  <span className="text-gray-600 text-sm leading-relaxed">
                    I agree to the{' '}
                    <Link to="/terms" target="_blank" className="text-red-600 hover:underline font-medium">Terms & Conditions</Link>
                    {' '}and{' '}
                    <Link to="/privacy" target="_blank" className="text-red-600 hover:underline font-medium">Privacy Policy</Link>
                  </span>
                </label>

                <button
                  type="submit"
                  disabled={!agreed}
                  className="w-full bg-red-600 hover:bg-red-700 disabled:bg-gray-300 disabled:cursor-not-allowed text-white font-bold py-3.5 rounded-xl transition text-sm tracking-wide"
                >
                  Continue to Payment →
                </button>

                <p className="text-center text-xs text-gray-400">
                  Already have an account?{' '}
                  <Link to="/login" className="text-red-600 hover:underline font-medium">Sign in</Link>
                </p>
              </form>
            </div>

            {/* Value prop — 2/5 width */}
            <div className="md:col-span-2">
              <ValueProp />
            </div>
          </div>
        )}

        {/* Step 2 — Checkout */}
        {step === 2 && (
          <div className="grid md:grid-cols-5 gap-6 items-start">
            {/* Payment — 3/5 */}
            <div className="md:col-span-3 bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-1">Complete your payment</h2>
              <p className="text-sm text-gray-500 mb-6">You're one step away from lifetime access</p>

              {loading ? (
                <div className="flex flex-col items-center justify-center py-16 gap-4 text-gray-500">
                  <svg className="animate-spin text-red-600" xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 12a9 9 0 11-6.219-8.56"/></svg>
                  <p className="font-semibold text-gray-700">Processing your payment...</p>
                  <p className="text-xs text-gray-400">Please do not close or refresh this window</p>
                </div>
              ) : (
                <div className="space-y-4">
                  <button
                    onClick={payWithEasebuzz}
                    className="w-full bg-red-600 hover:bg-red-700 active:scale-95 text-white font-bold py-4 rounded-xl transition-all text-base flex items-center justify-center gap-3 shadow-lg shadow-red-100"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>
                    Pay {formatINR(price)} Securely
                  </button>

                  <div className="flex items-center gap-3 text-xs text-gray-400">
                    <div className="flex-1 h-px bg-gray-100" />
                    <span>Accepted payment methods</span>
                    <div className="flex-1 h-px bg-gray-100" />
                  </div>

                  <div className="flex flex-wrap gap-2 justify-center">
                    {['UPI', 'Debit Card', 'Credit Card', 'NetBanking', 'Wallets'].map(m => (
                      <span key={m} className="text-xs bg-gray-100 text-gray-600 px-3 py-1.5 rounded-lg font-medium">{m}</span>
                    ))}
                  </div>

                  <div className="flex items-center justify-center gap-4 pt-2">
                    {['256-bit SSL', '✓ Secure checkout', '🇮🇳 Indian payment gateway'].map(b => (
                      <span key={b} className="text-xs text-gray-400">{b}</span>
                    ))}
                  </div>

                  <button onClick={() => setStep(1)} className="w-full text-gray-400 hover:text-gray-600 py-2 text-sm transition">
                    ← Back to details
                  </button>
                </div>
              )}

              <p className="text-xs text-gray-400 text-center mt-4 border-t border-gray-100 pt-4">
                Digital product — access is granted immediately after payment. No refunds.
              </p>
            </div>

            {/* Order Summary — 2/5 */}
            <div className="md:col-span-2 bg-white rounded-2xl shadow-sm border border-gray-100 p-6 space-y-4">
              <h4 className="font-bold text-gray-800">Order Summary</h4>

              <div className="bg-gradient-to-r from-red-50 to-orange-50 rounded-xl p-4 border border-red-100">
                <p className="font-semibold text-gray-800 text-sm">Edgram Lifetime Membership</p>
                <p className="text-xs text-gray-500 mt-0.5">For: {name} ({email})</p>
              </div>

              <div className="space-y-2 text-sm">
                <div className="flex justify-between text-gray-500">
                  <span>Base price</span>
                  <span>₹{Math.round(price / 1.18).toLocaleString('en-IN')}</span>
                </div>
                <div className="flex justify-between text-gray-500">
                  <span>GST (18%)</span>
                  <span>₹{Math.round(price - price / 1.18).toLocaleString('en-IN')}</span>
                </div>
                <div className="border-t border-gray-100 pt-2 flex justify-between font-bold text-gray-900 text-base">
                  <span>Total</span>
                  <span className="text-red-600">{formatINR(price)}</span>
                </div>
              </div>

              <div className="space-y-2 pt-2 border-t border-gray-100">
                {[
                  'Lifetime access — pay once, learn forever',
                  'All current and future courses',
                  'Self-paced video learning',
                  'Progress tracking dashboard',
                  'GST invoice on purchase',
                ].map(f => (
                  <p key={f} className="text-xs text-gray-600 flex items-center gap-2"><Icon name="check-circle" className="w-3.5 h-3.5 text-green-600 flex-shrink-0" /> {f}</p>
                ))}
              </div>

              {refCode && (
                <div className="bg-green-50 rounded-xl px-4 py-2 border border-green-100 text-xs text-green-700 font-medium">
                  Referred by a member
                </div>
              )}
            </div>
          </div>
        )}

      </div>
    </div>
  );
} // <--- THIS is what was missing! It officially closes MemberRegister.

function MemberLogin({ setUserType }) {
  const { fetchData } = useAppGlobal();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);
  const navigate = useNavigate();

  const inputClass = "w-full border border-gray-200 bg-gray-50 focus:bg-white focus:border-red-400 focus:ring-2 focus:ring-red-100 rounded-xl px-4 py-3 text-sm text-gray-800 placeholder-gray-400 outline-none transition";
  const labelClass = "block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5";

  const handleAuthSuccess = (data) => {
    const u = data.user;
    if (u.status === STATUS_BLOCKED) { toast.error('Your account has been suspended.'); return; }
    localStorage.setItem(LS_TOKEN, data.token);
    setMember(u.email, u.role);
    setUserType(u.role);
    toast.success('Welcome back!');
    fetchData();
    if (u.role === ROLE_ACCOUNTANT) navigate('/accountant');
    else navigate('/dashboard');
  };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await ApiClient.login(email, password);
      if (data.token && data.user) handleAuthSuccess(data);
      else throw new Error('Invalid response');
    } catch (e) {
      toast.error('Invalid email or password.');
    } finally { setLoading(false); }
  };

  // Render Google button on mount — far more reliable than gsi.prompt()
  useEffect(() => {
    const callback = async (response) => {
      setGoogleLoading(true);
      try {
        const res = await fetch(`${API_URL}/api/auth/google`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ credential: response.credential })
        });
        const data = await res.json();
        if (data.token && data.user) handleAuthSuccess(data);
        else toast.error(data.error || 'Google login failed. Please try again.');
      } catch (err) {
        toast.error('Google login error: ' + err.message);
      } finally {
        setGoogleLoading(false);
      }
    };
    renderGoogleButton('google-login-btn', callback).catch(() => {});
  }, []);

  const GoogleBtn = () => (
    <div id="google-login-btn" className="w-full flex justify-center min-h-[44px]">
      {googleLoading && (
        <div className="flex items-center gap-2 text-gray-500 text-sm py-3">
          <svg className="animate-spin" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 12a9 9 0 11-6.219-8.56"/></svg>
          Signing in with Google...
        </div>
      )}
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-10 px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/"><span className="text-3xl font-black text-red-600">Edgram</span></Link>
          <p className="text-gray-500 text-sm mt-2">Welcome back. Sign in to continue learning.</p>
        </div>
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Sign in</h2>
          <GoogleBtn />
          <div className="flex items-center gap-3 my-5">
            <div className="flex-1 h-px bg-gray-100" />
            <span className="text-xs text-gray-400 font-medium">or sign in with email</span>
            <div className="flex-1 h-px bg-gray-100" />
          </div>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className={labelClass}>Email Address</label>
              <input className={inputClass} type="email" placeholder="you@example.com" value={email} onChange={e => setEmail(e.target.value)} required />
            </div>
            <div>
              <div className="flex items-center justify-between mb-1.5">
                <label className={labelClass} style={{marginBottom:0}}>Password</label>
                <Link to="/forgot-password" className="text-xs text-red-600 hover:underline font-medium">Forgot password?</Link>
              </div>
              <div className="relative">
                <input className={inputClass + " pr-12"} type={showPassword ? 'text' : 'password'} placeholder="Your password" value={password} onChange={e => setPassword(e.target.value)} required />
                <button type="button" onClick={() => setShowPassword(p => !p)} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 text-xs font-medium">
                  {showPassword ? 'Hide' : 'Show'}
                </button>
              </div>
            </div>
            <button type="submit" disabled={loading || googleLoading} className="w-full bg-red-600 hover:bg-red-700 disabled:bg-gray-300 disabled:cursor-not-allowed text-white font-bold py-3.5 rounded-xl transition text-sm">
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>
          <p className="text-center text-xs text-gray-400 mt-6">
            Don't have an account?{' '}
            <Link to="/register" className="text-red-600 hover:underline font-medium">Create one</Link>
          </p>
        </div>
        <p className="text-center text-xs text-gray-400 mt-4">
          Admin? <Link to="/admin-login" className="text-gray-500 hover:underline">Sign in here</Link>
        </p>
      </div>
    </div>
  );
} // <--- Only ONE closing bracket!

function ForgotPassword() {
  const { fetchData } = useAppGlobal();
  const [step, setStep] = useState(1); 
  const [email, setEmail] = useState('');
  const [user, setUser] = useState(null);
  const [answer, setAnswer] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleFindEmail = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // The server tells us which security question was set. It never sends the
      // answer, so the answer can no longer be read out of the page.
      const found = await ApiClient.fetchSecretQuestion(email);
      setUser({ email: found.email || email, secretQuestion: found.secretQuestion });
      setStep(2);
    } catch (err) {
      toast.error(err.message || 'No account with a security question was found for that email.');
    } finally {
      setLoading(false);
    }
  };

  const handleCheckAnswer = (e) => {
    e.preventDefault();
    if (!answer.trim()) {
      toast.error('Please enter your answer.');
      return;
    }
    // The answer is checked on the server, together with the new password.
    setStep(3);
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    if (newPassword.length < 8) {
      toast.error('Password must be at least 8 characters.');
      return;
    }
    if (newPassword !== confirmPassword) {
      toast.error('Passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      await ApiClient.resetPassword(user.email, answer, newPassword);
      toast.success('Password reset successfully! Please log in.');
      navigate('/login');
    } catch (err) {
      toast.error(err.message || 'Failed to reset password. Please try again.');
      setAnswer('');
      setStep(2);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Card>
        {step === 1 && (
          <form onSubmit={handleFindEmail} className="max-w-sm mx-auto">
            <h2 className="text-2xl font-bold mb-4">Forgot Password</h2>
            <p className="text-gray-600 mb-4">Enter your email to find your account.</p>
            <input className="border p-2 rounded w-full" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} required />
            <button className={`${CTA_BUTTON_CLASS} text-white px-4 py-2 rounded-full font-semibold w-full mt-3`} type="submit" disabled={loading}>
                {loading ? 'Finding Account...' : 'Find Account'}
            </button>
          </form>
        )}
        {step === 2 && user && (
          <form onSubmit={handleCheckAnswer} className="max-w-sm mx-auto">
            <h2 className="text-2xl font-bold mb-4">Security Question</h2>
            <p className="text-gray-700 mb-2 font-semibold">{user.secretQuestion}</p>
            <input className="border p-2 rounded w-full" placeholder="Your Answer" value={answer} onChange={e => setAnswer(e.target.value)} required />
            <button className={`${CTA_BUTTON_CLASS} text-white px-4 py-2 rounded-full font-semibold w-full mt-3`} type="submit">Submit Answer</button>
          </form>
        )}
        {step === 3 && user && (
          <form onSubmit={handleResetPassword} className="max-w-sm mx-auto">
            <h2 className="text-2xl font-bold mb-4">Reset Your Password</h2>
            <input className="border p-2 rounded w-full mb-3" type="password" placeholder="New Password" value={newPassword} onChange={e => setNewPassword(e.target.value)} required />
            <input className="border p-2 rounded w-full" type="password" placeholder="Confirm New Password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required />
            <button className={`${CTA_BUTTON_CLASS} text-white px-4 py-2 rounded-full font-semibold w-full mt-3`} type="submit" disabled={loading}>
                {loading ? 'Resetting...' : 'Reset Password'}
            </button>
          </form>
        )}
      </Card>
    </Container>
  );
}

const LS_WELCOME_SEEN = 'ed_welcome_seen_v1';

function WelcomeModal({ user, onClose }) {
  const referralLink = `${APP_DOMAIN}/register?ref=${user?.referralCode || ''}`;
  const payoutAmount = user?.role === ROLE_SUPER_PREMIUM ? PAYOUT_SUPER_PREMIUM : PAYOUT_MEMBER;

  const dismiss = () => {
    localStorage.setItem(LS_WELCOME_SEEN, '1');
    onClose();
  };

  const copyAndDismiss = () => {
    if (navigator.clipboard) navigator.clipboard.writeText(referralLink);
    toast.success('Referral link copied!');
    dismiss();
  };

  return (
    <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden">
        {/* Header */}
        <div className={`${CTA_BUTTON_CLASS} p-6 text-white text-center`}>
          <div className="text-3xl mb-2">🎉</div>
          <h2 className="text-2xl font-bold">Welcome to Edgram!</h2>
          <p className="text-orange-100 text-sm mt-1">Here's how to get the most out of your membership</p>
        </div>

        {/* Steps */}
        <div className="p-6 space-y-3">
          {[
            { n: '1', title: 'Start learning now', desc: 'Browse all available courses in your member content library' },
            { n: '2', title: 'Refer & get recognized', desc: 'Share your unique link — you may be recognized as per company policy when someone joins through it' },
            { n: '3', title: 'Add your bank details', desc: 'Fill in Payout Details in case you become eligible for recognition' },
          ].map(({ n, title, desc }) => (
            <div key={n} className="flex gap-3 items-start bg-gray-50 rounded-xl p-3">
              <div className={`w-8 h-8 ${CTA_BUTTON_CLASS} rounded-full flex items-center justify-center text-white text-sm font-bold flex-shrink-0`}>{n}</div>
              <div>
                <div className="font-semibold text-gray-800 text-sm">{title}</div>
                <div className="text-gray-500 text-xs mt-0.5">{desc}</div>
              </div>
            </div>
          ))}

          {/* Referral link */}
          <div className="bg-gray-50 rounded-xl p-3 border border-gray-200">
            <div className="text-xs text-gray-500 mb-2 font-medium">Your referral link</div>
            <div className="font-mono text-xs text-gray-600 bg-white border border-gray-200 rounded-lg px-3 py-2 truncate mb-2">
              {referralLink}
            </div>
            <div className="flex gap-2">
              <button
                onClick={copyAndDismiss}
                className="flex-1 bg-gray-800 text-white py-2 rounded-lg text-xs font-semibold hover:bg-gray-700 transition"
              >
                Copy link
              </button>
              
              {/* FIX: Added the missing <a opening tag right below */}
              <a
                href={`https://wa.me/?text=${encodeURIComponent(`Join Edgram with my link and get lifetime access to premium Finance & Digital Marketing courses: ${referralLink}`)}`}
                target="_blank"
                rel="noopener noreferrer"
                onClick={dismiss}
                className="flex-1 bg-green-600 text-white py-2 rounded-lg text-xs font-semibold hover:bg-green-700 transition text-center"
              >
                Share on WhatsApp
              </a>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 pb-6">
          <button
            onClick={dismiss}
            className={`w-full ${CTA_BUTTON_CLASS} text-white py-3 rounded-full font-semibold transition`}
          >
            Go to my dashboard
          </button>
          <button onClick={dismiss} className="w-full text-xs text-gray-400 hover:text-gray-600 mt-3">
            Don't show this again
          </button>
        </div>
      </div>
    </div>
  );
}
function MemberDashboard() {
  const { allPayouts, content, progress, memberUser, isLoading, fetchData } = useAppGlobal();
  const navigate = useNavigate();

  // Profile dropdown
  const [profileOpen, setProfileOpen] = useState(false);

  // Modals
  const [modal, setModal] = useState(null); // 'refer' | 'password' | null

  // Welcome modal
  const [showWelcome, setShowWelcome] = useState(!localStorage.getItem(LS_WELCOME_SEEN));

  if (isLoading) return <Container><SkeletonDashboard /></Container>;
  if (!memberUser) return <Navigate to="/login" replace />;

  // Referral calculations
  const userPayouts = allPayouts.filter(p => p.referrerEmail === memberUser.email);
  const amountPaid = userPayouts.filter(p => p.status === 'Paid').reduce((a, b) => a + b.amount, 0);
  const amountPending = userPayouts.filter(p => p.status === 'Pending').reduce((a, b) => a + b.amount, 0);
  const amountLim = userPayouts.filter(p => p.status === 'Data Limitation').reduce((a, b) => a + b.amount, 0);
  const total = amountPaid + amountPending + amountLim;
  const referralLink = `${APP_DOMAIN}/register?ref=${memberUser.referralCode || 'yourcode'}`;

  const copyLink = () => {
    navigator.clipboard?.writeText(referralLink);
    toast.success('Referral link copied!');
  };
  const shareWhatsApp = () => {
    const msg = `I just joined Edgram! 🎯 Access premium courses with lifetime membership. Join with my link: ${referralLink}`;
    window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`, '_blank');
  };
  const shareMessage = () => {
    const msg = `I just joined Edgram! 🎯 Access premium courses with lifetime membership for ₹6,999. Join with my link: ${referralLink}`;
    navigator.clipboard?.writeText(msg);
    toast.success('Share message copied!');
  };

  // Initials avatar
  const initials = memberUser.name
    ? memberUser.name.split(' ').map(w => w[0]).slice(0, 2).join('').toUpperCase()
    : '?';

  return (
    <Container>
      {/* Welcome modal */}
      {showWelcome && memberUser && (
        <WelcomeModal user={memberUser} onClose={() => setShowWelcome(false)} />
      )}

      {/* ── Refer Now Modal ────────────────────────────────────── */}
      {modal === 'refer' && (
        <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/60 backdrop-blur-sm p-0 sm:p-4" onClick={() => setModal(null)}>
          <div className="bg-white w-full sm:max-w-lg sm:rounded-2xl rounded-t-2xl shadow-2xl max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
            {/* Modal header */}
            <div className="flex items-center justify-between p-5 border-b border-gray-100 sticky top-0 bg-white rounded-t-2xl z-10">
              <div>
                <h2 className="font-bold text-gray-900 text-lg">Refer Now</h2>
                <p className="text-xs text-gray-400">Share your link and track your earnings</p>
              </div>
              <button onClick={() => setModal(null)} className="w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center text-gray-500 transition font-bold">×</button>
            </div>

            <div className="p-5 space-y-6">
              {/* Referral link */}
              <div>
                <p className="text-xs font-bold text-gray-500 uppercase tracking-wide mb-3">Your referral link</p>
                <div className="bg-gray-50 border border-gray-200 rounded-xl p-3 font-mono text-xs text-gray-600 mb-3 break-all">{referralLink}</div>
                <div className="flex flex-col sm:flex-row gap-2">
                  <button onClick={copyLink} className="flex-1 bg-gray-900 hover:bg-gray-700 text-white py-2.5 rounded-xl text-sm font-semibold transition">
                    Copy link
                  </button>
                  <button onClick={shareWhatsApp} className="flex-1 bg-green-600 hover:bg-green-700 text-white py-2.5 rounded-xl text-sm font-semibold transition flex items-center justify-center gap-2">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="white"><path d="M20.52 3.48A11.93 11.93 0 0012 0C5.37 0 0 5.37 0 12a11.9 11.9 0 001.64 6.06L0 24l6.15-1.61A11.94 11.94 0 0012 24c6.63 0 12-5.37 12-12a11.93 11.93 0 00-3.48-8.52z"/></svg>
                    Share on WhatsApp
                  </button>
                  <button onClick={shareMessage} className="flex-1 border border-gray-200 hover:border-gray-400 text-gray-700 py-2.5 rounded-xl text-sm font-semibold transition">
                    Copy message
                  </button>
                </div>
              </div>

              {/* Earnings summary */}
              <div>
                <p className="text-xs font-bold text-gray-500 uppercase tracking-wide mb-3">Referral earnings</p>
                <div className="grid grid-cols-3 gap-3">
                  <div className="bg-gray-50 rounded-xl p-3 text-center border border-gray-100">
                    <p className="text-xs text-gray-400 mb-1">Total earned</p>
                    <p className="font-bold text-gray-900 text-sm">{formatINR(total)}</p>
                  </div>
                  <div className="bg-green-50 rounded-xl p-3 text-center border border-green-100">
                    <p className="text-xs text-gray-400 mb-1">Paid</p>
                    <p className="font-bold text-green-700 text-sm">{formatINR(amountPaid)}</p>
                  </div>
                  <div className="bg-orange-50 rounded-xl p-3 text-center border border-orange-100">
                    <p className="text-xs text-gray-400 mb-1">Pending</p>
                    <p className="font-bold text-orange-600 text-sm">{formatINR(amountPending)}</p>
                  </div>
                </div>
              </div>

              {/* Earnings history table */}
              {userPayouts.length > 0 ? (
                <div>
                  <p className="text-xs font-bold text-gray-500 uppercase tracking-wide mb-3">History</p>
                  <div className="overflow-x-auto rounded-xl border border-gray-100">
                    <table className="min-w-full text-xs">
                      <thead>
                        <tr className="bg-gray-50 border-b border-gray-100">
                          <th className="px-3 py-2 text-left text-gray-400 font-semibold">Referee</th>
                          <th className="px-3 py-2 text-left text-gray-400 font-semibold">Amount</th>
                          <th className="px-3 py-2 text-left text-gray-400 font-semibold">Status</th>
                          <th className="px-3 py-2 text-left text-gray-400 font-semibold">UTR</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-50">
                        {userPayouts.map(p => (
                          <tr key={p.id} className="hover:bg-gray-50">
                            <td className="px-3 py-2.5 text-gray-700">{p.referee}</td>
                            <td className="px-3 py-2.5 font-semibold text-gray-900">{formatINR(p.amount)}</td>
                            <td className="px-3 py-2.5">
                              <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold ${p.status === 'Paid' ? 'bg-green-100 text-green-700' : p.status === 'Pending' ? 'bg-orange-100 text-orange-700' : 'bg-red-100 text-red-700'}`}>
                                <Icon name={p.status === 'Paid' ? 'check-circle' : p.status === 'Pending' ? 'clock' : 'alert-triangle'} className="w-3 h-3" /> {p.status}
                              </span>
                            </td>
                            <td className="px-3 py-2.5 font-mono text-gray-400">{p.utrNumber || '—'}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <div className="text-center py-6 text-gray-400 text-sm bg-gray-50 rounded-xl">
                  <div className="flex justify-center mb-2 text-gray-300"><Icon name="link" className="w-6 h-6" /></div>
                  No referrals yet. Share your link to get started!
                </div>
              )}

              {/* Bank details */}
              <div>
                <p className="text-xs font-bold text-gray-500 uppercase tracking-wide mb-3">Bank details for payouts</p>
                <PayoutDetailsForm onSave={fetchData} user={memberUser} />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── Change Password Modal ───────────────────────────────── */}
      {modal === 'password' && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4" onClick={() => setModal(null)}>
          <div className="bg-white w-full max-w-md rounded-2xl shadow-2xl" onClick={e => e.stopPropagation()}>
            <div className="flex items-center justify-between p-5 border-b border-gray-100">
              <h2 className="font-bold text-gray-900 text-lg">Change Password</h2>
              <button onClick={() => setModal(null)} className="w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center text-gray-500 transition font-bold">×</button>
            </div>
            <div className="p-5">
              <ChangePasswordForm onSave={() => { fetchData(); setModal(null); }} user={memberUser} />
            </div>
          </div>
        </div>
      )}

      {/* ── Dashboard Header ────────────────────────────────────── */}
      <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl p-5 sm:p-6 mb-6 text-white flex items-center justify-between gap-4">
        <div className="min-w-0">
          <p className="text-gray-400 text-xs font-medium mb-1">My Dashboard</p>
          <h1 className="text-xl sm:text-2xl font-black truncate">
            {memberUser?.name ? `Hey, ${memberUser.name.split(' ')[0]}!` : 'Welcome back!'}
          </h1>
          <p className="text-gray-500 text-xs mt-1 truncate">{memberUser?.email}</p>
        </div>

        {/* Profile button — always visible */}
        <div className="relative flex-shrink-0">
          <button
            onClick={() => setProfileOpen(o => !o)}
            className="w-11 h-11 rounded-full bg-gradient-to-br from-orange-500 to-red-600 flex items-center justify-center text-white font-bold text-sm shadow-lg hover:shadow-xl transition-all hover:scale-105 border-2 border-white/20"
          >
            {initials}
          </button>

          {/* Dropdown */}
          {profileOpen && (
            <div className="absolute right-0 top-14 w-56 bg-white rounded-2xl shadow-2xl border border-gray-100 z-50 overflow-hidden">
              {/* User info header */}
              <div className="px-4 py-3 border-b border-gray-100 bg-gray-50">
                <p className="font-bold text-gray-900 text-sm truncate">{memberUser.name}</p>
                <p className="text-xs text-gray-400 truncate">{memberUser.email}</p>
                <span className={`inline-flex items-center gap-1 mt-1.5 px-2 py-0.5 rounded-full text-xs font-bold ${memberUser.role === ROLE_SUPER_PREMIUM ? 'bg-yellow-100 text-yellow-700' : 'bg-orange-100 text-orange-700'}`}>
                  {memberUser.role === ROLE_SUPER_PREMIUM ? 'Super Premium' : 'Premium Member'}
                </span>
              </div>

              {/* Menu items */}
              <div className="py-1.5">
                <button
                  onClick={() => { setModal('refer'); setProfileOpen(false); }}
                  className="w-full flex items-center gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 transition text-left font-semibold"
                >
                  <span className="w-8 h-8 bg-orange-100 rounded-lg flex items-center justify-center text-orange-600"><Icon name="link" className="w-4 h-4" /></span>
                  Refer Now
                </button>
                <button
                  onClick={() => { setModal('password'); setProfileOpen(false); }}
                  className="w-full flex items-center gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 transition text-left"
                >
                  <span className="w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center text-gray-600"><Icon name="lock" className="w-4 h-4" /></span>
                  Change Password
                </button>
              </div>

              {/* Logout */}
              <div className="border-t border-gray-100 py-1.5">
                <button
                  onClick={() => {
                    sessionStorage.removeItem('admin_unlocked');
                    localStorage.removeItem(LS_TOKEN);
                    localStorage.removeItem(LS_USER_TYPE);
                    localStorage.removeItem(LS_EMAIL);
                    localStorage.removeItem(LS_MEMBER_EMAIL);
                    setProfileOpen(false);
                    toast.success('Logged out.');
                    navigate('/');
                  }}
                  className="w-full flex items-center gap-3 px-4 py-3 text-sm text-red-600 hover:bg-red-50 transition text-left"
                >
                  <span className="w-8 h-8 bg-red-100 rounded-lg flex items-center justify-center text-red-600"><Icon name="log-out" className="w-4 h-4" /></span>
                  Logout
                </button>
              </div>
            </div>
          )}

          {/* Click-outside close */}
          {profileOpen && (
            <div className="fixed inset-0 z-40" onClick={() => setProfileOpen(false)} />
          )}
        </div>
      </div>

      {/* ── My Courses — full width, clean ─────────────────────── */}
      <div>
        <h2 className="text-lg font-bold text-gray-800 mb-4">My Courses</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {content.categories.length === 0 ? (
            <div className="col-span-3">
              <EmptyState title="Courses coming soon" message="Your course library is being built. Check back shortly!" icon={<Icon name="book-open" className="w-8 h-8" />} />
            </div>
          ) : (
            content.categories.map(cat => {
              const catVideos = content.videos.filter(v => v.categoryId === cat.id);
              const userProgress = progress[memberUser?.id] || [];
              const completedCount = catVideos.filter(v => userProgress.includes(v.id)).length;
              const progressPct = catVideos.length > 0 ? Math.round((completedCount / catVideos.length) * 100) : 0;
              const firstVideo = catVideos[0];
              return (
                <Link
                  key={cat.id}
                  to={`/browse/${cat.id}`}
                  className="bg-white rounded-2xl border border-gray-100 overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-200 block group"
                >
                  <div className="relative h-44 overflow-hidden">
                    {firstVideo ? (
                      <img src={ytThumb(firstVideo.videoId)} className="w-full h-full object-cover group-hover:scale-105 transition duration-300" alt={cat.name} />
                    ) : (
                      <div className="w-full h-full bg-gradient-to-br from-orange-400 to-red-600 flex items-center justify-center text-white/70"><Icon name="book-open" className="w-10 h-10" /></div>
                    )}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                    <div className="absolute bottom-3 left-4 right-4">
                      <p className="text-white font-bold text-base drop-shadow">{cat.name}</p>
                    </div>
                    <div className="absolute top-3 right-3 bg-black/60 backdrop-blur-sm text-white text-xs px-2.5 py-1 rounded-full">
                      {catVideos.length} videos
                    </div>
                    {progressPct === 100 && (
                      <div className="absolute top-3 left-3 bg-green-600 text-white text-xs px-2.5 py-1 rounded-full font-semibold flex items-center gap-1"><Icon name="check-circle" className="w-3 h-3" /> Done</div>
                    )}
                  </div>
                  <div className="p-4">
                    <p className="text-sm text-gray-500 mb-3 line-clamp-2">{cat.description}</p>
                    <div className="flex justify-between text-xs text-gray-400 mb-1.5">
                      <span>{completedCount} of {catVideos.length} completed</span>
                      <span className="font-semibold text-red-600">{progressPct}%</span>
                    </div>
                    <div className="w-full bg-gray-100 rounded-full h-1.5">
                      <div
                        className="bg-gradient-to-r from-orange-500 to-red-600 h-1.5 rounded-full transition-all duration-500"
                        style={{ width: `${progressPct}%` }}
                      />
                    </div>
                  </div>
                </Link>
              );
            })
          )}
        </div>
      </div>
    </Container>
  );
}

function PayoutDetailsForm({ onSave, user }) {
  const [bankDetails, setBankDetails] = useState(user?.bank || { accountNumber: '', ifsc: '', pan: '', chequeUrl: '', isVerified: false });
  const [loading, setLoading] = useState(false);
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setBankDetails(prev => ({ ...prev, [name]: value }));
  };

  const save = async () => {
    setLoading(true);
    // Check mandatory fields 
    if (!bankDetails.accountNumber || !bankDetails.ifsc || !bankDetails.pan || !bankDetails.chequeUrl) {
      toast.error('All bank fields, including the Cheque/Bank Statement URL, are mandatory.');
      setLoading(false);
      return;
    }

    const updatedBank = { ...bankDetails, isVerified: false }; // Reset verification on change
    
    try {
        // API Call: Update user bank details
        await ApiClient.updateUser(user.id, { bank: updatedBank });

        // API Call: Update affected payouts status (Optional: Backend might handle this on user update)
        // For robustness, we trigger a payout refresh.
        // await ApiClient.updatePayoutsStatus(user.email, updatedBank); 
        
        // Update local state and trigger parent refresh
        setBankDetails(updatedBank); 
        onSave(); // Refetch parent data via global hook
        toast.success('Payout details saved. Admin verification required.');
    } catch (e) {
        toast.error('Failed to save details: ' + e.message);
        console.error("Save Payout Details Error:", e);
    } finally {
        setLoading(false);
    }
  };

  const inputClass = "w-full border border-gray-200 bg-gray-50 focus:bg-white focus:border-red-400 focus:ring-2 focus:ring-red-100 rounded-xl px-4 py-3 text-sm text-gray-800 outline-none transition mt-1.5";
  const labelClass = "block text-xs font-semibold text-gray-500 uppercase tracking-wide";

  return (
    <Card>
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-orange-50 rounded-xl flex items-center justify-center text-orange-600"><Icon name="landmark" className="w-5 h-5" /></div>
        <div>
          <h3 className="text-xl font-bold text-gray-900">Bank & Tax Details</h3>
          <p className="text-xs text-gray-500">Required for referral payout processing</p>
        </div>
      </div>
      {bankDetails.isVerified && (
        <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-xl mb-5 flex items-center gap-2 text-sm font-medium">
          <Icon name="check-circle" className="w-4 h-4 flex-shrink-0" /> Your bank details have been verified by Admin.
        </div>
      )}
      <div className="grid md:grid-cols-2 gap-5">
        <div>
          <label className={labelClass}>Bank Account Number</label>
          <input name="accountNumber" className={inputClass} placeholder="Enter account number" value={bankDetails.accountNumber} onChange={handleInputChange} />
        </div>
        <div>
          <label className={labelClass}>IFSC Code</label>
          <input name="ifsc" className={inputClass} placeholder="e.g. HDFC0001234" value={bankDetails.ifsc} onChange={handleInputChange} />
        </div>
        <div>
          <label className={labelClass}>PAN Number</label>
          <input name="pan" className={inputClass} placeholder="e.g. ABCDE1234F" value={bankDetails.pan} onChange={handleInputChange} />
        </div>
        <div>
          <label className={labelClass}>Cancelled Cheque / Bank Statement URL</label>
          <input name="chequeUrl" className={inputClass} placeholder="https://drive.google.com/..." value={bankDetails.chequeUrl} onChange={handleInputChange} />
          {bankDetails.chequeUrl && <a href={bankDetails.chequeUrl} target="_blank" rel="noopener noreferrer" className="text-xs text-red-600 hover:underline mt-1 inline-block">↗ View Document</a>}
        </div>
      </div>
      <div className="mt-6 pt-5 border-t border-gray-100 flex items-center justify-between">
        <p className="text-xs text-gray-400">Details are submitted for admin verification before payouts are processed.</p>
        <button
          className={`${CTA_BUTTON_CLASS} text-white px-6 py-2.5 rounded-xl font-semibold transition disabled:opacity-50 text-sm`}
          onClick={save}
          disabled={loading}
        >
          {loading ? 'Saving...' : 'Save Details'}
        </button>
      </div>
    </Card>
  );
}

function ChangePasswordForm({ onSave, user }) {
  // Use the memberUser passed from the dashboard instead of local fetching
  const [loadingSave, setLoadingSave] = useState(false);
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const save = async () => {
    if (!user) { toast.error('Not logged in'); return; }
    setLoadingSave(true);

    if (currentPassword !== user.password) {
      toast.error('Current password does not match.');
      setLoadingSave(false);
      return;
    }
    if (newPassword.length < 4) {
      toast.error('New password must be at least 4 characters.');
      setLoadingSave(false);
      return;
    }
    if (newPassword !== confirmPassword) {
      toast.error('New passwords do not match.');
      setLoadingSave(false);
      return;
    }
    
    try {
        // API Call: Update user password
        await ApiClient.updateUser(user.id, { password: newPassword });
        
        toast.success('Password changed successfully.');
        setCurrentPassword('');
        setNewPassword('');
        setConfirmPassword('');
        onSave(); // Trigger global refresh (important if user.password is needed elsewhere)
    } catch (e) {
        toast.error('Failed to change password: ' + e.message);
        console.error("Change Password Error:", e);
    } finally {
        setLoadingSave(false);
    }
  };

  if (!user) return <Card><div className="text-center py-4">Error loading user data.</div></Card>;

  const inputCls = "w-full border border-gray-200 bg-gray-50 focus:bg-white focus:border-red-400 focus:ring-2 focus:ring-red-100 rounded-xl px-4 py-3 text-sm text-gray-800 outline-none transition mt-1.5";
  const labelCls = "block text-xs font-semibold text-gray-500 uppercase tracking-wide";
  return (
    <Card>
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-red-50 rounded-xl flex items-center justify-center text-xl">a<Icon name="lock" className="w-5 h-5" /></div>
        <div>
          <h3 className="text-xl font-bold text-gray-900">Change Password</h3>
          <p className="text-xs text-gray-500">Keep your account secure</p>
        </div>
      </div>
      <div className="grid gap-4 max-w-md">
        <div><label className={labelCls}>Current Password</label><input className={inputCls} type="password" placeholder="Your current password" value={currentPassword} onChange={e => setCurrentPassword(e.target.value)} /></div>
        <div><label className={labelCls}>New Password</label><input className={inputCls} type="password" placeholder="Choose a strong password" value={newPassword} onChange={e => setNewPassword(e.target.value)} /></div>
        <div><label className={labelCls}>Confirm New Password</label><input className={inputCls} type="password" placeholder="Repeat new password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} /></div>
        <button className={`${CTA_BUTTON_CLASS} text-white py-3 px-6 rounded-xl font-bold text-sm disabled:opacity-50 transition`} onClick={save} disabled={loadingSave}>
          {loadingSave ? 'Saving...' : 'Update Password'}
        </button>
      </div>
    </Card>
  );
}

/* =========================
   ADMIN: Content Manager (UPDATED to use global state & ApiClient)
   ========================= */
function ContentManager() {
  // Use content and setContent from global hook
  const { content, isLoading, fetchData, setContent } = useAppGlobal();
  const [catName, setCatName] = useState(''); 
  const [catDesc, setCatDesc] = useState('');
  const [selCat, setSelCat] = useState('');
  const [vTitle, setVTitle] = useState(''); 
  const [vUrl, setVUrl] = useState(''); 
  const [vFree, setVFree] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  
  // Set initial selected category once content is loaded
  useEffect(() => {
    if (content.categories.length > 0 && !selCat) {
        setSelCat(content.categories[0].id);
    }
  }, [content.categories, selCat]);
  
  if (isLoading) return <Card><div className="text-center py-4">Loading content manager...</div></Card>;
  if (!content) return null;

  const handleSaveContent = async (next) => {
    setIsSaving(true);
    try {
        await ApiClient.saveContent(next); 
        setContent(next); // Optimistically update local state for quick UI feedback
        fetchData(); // Trigger full refresh just in case
        toast.success('Content saved successfully!');
    } catch (e) {
        toast.error('Failed to save content: ' + e.message);
        console.error("Content Save Error:", e);
    } finally {
        setIsSaving(false);
    }
  }

  const addCategory = async () => {
    if (!catName.trim()) { toast.error('Category name required'); return; }
    const c = { id: uid('cat'), name: catName.trim(), description: catDesc.trim() };
    const next = { ...content, categories: [...content.categories, c] };
    await handleSaveContent(next);
    setCatName(''); setCatDesc(''); 
    if (!selCat) setSelCat(c.id);
  };
  
  const deleteCategory = async (id) => {
    const next = { categories: content.categories.filter(c => c.id !== id), videos: content.videos.filter(v => v.categoryId !== id) };
    await handleSaveContent(next);
    if (selCat === id) setSelCat(next.categories[0]?.id || '');
  };
  
  const addVideo = async () => {
    if (!selCat) { toast.error('Select a category'); return; }
    if (!vTitle.trim() || !vUrl.trim()) { toast.error('Title and URL required'); return; }
    const vid = getYouTubeId(vUrl);
    if (!vid) { toast.error('Invalid YouTube URL'); return; }
    const nv = { id: uid('vid'), categoryId: selCat, title: vTitle.trim(), youtubeUrl: vUrl.trim(), videoId: vid, isFreePreview: !!vFree };
    const next = { ...content, videos: [...content.videos, nv] };
    await handleSaveContent(next);
    setVTitle(''); setVUrl(''); setVFree(false);
  };
  
  const deleteVideo = async (id) => { 
    const next = { ...content, videos: content.videos.filter(v => v.id !== id) }; 
    await handleSaveContent(next);
  };

  const toggleFreePreview = async (videoId) => {
    const updatedVideos = content.videos.map(v => 
      v.id === videoId ? { ...v, isFreePreview: !v.isFreePreview } : v
    );
    const next = { ...content, videos: updatedVideos };
    await handleSaveContent(next);
    toast.success(`Video access switched to ${updatedVideos.find(v => v.id === videoId).isFreePreview ? 'Free Preview' : 'Premium Access'}.`);
  };

  return (
    <div className="grid md:grid-cols-2 gap-6">
      <Card>
        <h3 className="font-bold mb-2 text-xl">Categories</h3>
        <div className="flex gap-2 mb-2">
          <input className="border p-2 rounded w-full" placeholder="Category name" value={catName} onChange={e => setCatName(e.target.value)} disabled={isSaving}/>
          <button className={`${CTA_BUTTON_CLASS} text-white px-4 py-2 rounded-full font-semibold transition`} onClick={addCategory} disabled={isSaving}>Add</button>
        </div>
        <textarea className="border p-2 rounded w-full mb-3" rows="2" placeholder="Description" value={catDesc} onChange={e => setCatDesc(e.target.value)} disabled={isSaving} />
        <div className="space-y-2 max-h-72 overflow-auto">
          {content.categories.map(c => (
            <div key={c.id} className={'p-3 rounded-xl border flex items-center justify-between ' + (selCat === c.id ? 'bg-red-100 border-red-400' : 'bg-gray-50 hover:bg-gray-100')}>
              <div>
                <div className="font-semibold text-gray-800">{c.name}</div>
                <div className="text-xs text-gray-600">{c.description}</div>
              </div>
              <div className="flex gap-2">
                <button className={`px-3 py-1 rounded-full text-xs font-medium ${selCat === c.id ? `${CTA_BUTTON_CLASS} text-white` : 'bg-gray-200 hover:bg-gray-300'}`} onClick={() => setSelCat(c.id)} disabled={isSaving}>Select</button>
                <button className="px-3 py-1 bg-red-500 text-white rounded-full text-xs font-medium hover:bg-red-600 transition" onClick={() => deleteCategory(c.id)} disabled={isSaving}>Delete</button>
              </div>
            </div>
          ))}
          {!content.categories.length && <div className="text-sm text-gray-500 p-4"><EmptyState title="No Categories" message="Add your first category above." /></div>}
        </div>
      </Card>

      <Card>
        <h3 className="font-bold mb-2 text-xl">Videos in Selected Category</h3>
        <div className="text-sm mb-4 p-2 bg-orange-50 rounded-lg border border-orange-200">Selected: <strong className="text-orange-800">{content.categories.find(c => c.id === selCat)?.name || 'None'}</strong></div>
        <div className="grid gap-2">
          <input className="border p-2 rounded" placeholder="Video Title" value={vTitle} onChange={e => setVTitle(e.target.value)} disabled={isSaving}/>
          <input className="border p-2 rounded" placeholder="YouTube URL" value={vUrl} onChange={e => setVUrl(e.target.value)} disabled={isSaving} />
          <label className="inline-flex items-center gap-2"><input type="checkbox" checked={vFree} onChange={e => setVFree(e.target.checked)} className="rounded text-red-600" disabled={isSaving} /> Free Preview</label>
          <div><button className={`${CTA_BUTTON_CLASS} text-white px-4 py-2 rounded-full font-semibold transition`} onClick={addVideo} disabled={isSaving}>Add Video</button></div>
        </div>
        <hr className="my-4 border-gray-200" />
        <div className="space-y-3 max-h-72 overflow-auto">
          {content.videos.filter(v => v.categoryId === selCat).map(v => (
            <div key={v.id} className="flex gap-3 items-center bg-gray-50 p-2 rounded-lg justify-between">
              <div className="flex-1">
                <div className="font-semibold text-sm text-gray-800">{v.title}</div>
                <div className="text-xs text-gray-600">{v.isFreePreview ? 'Free Preview (Open)' : 'Premium (Locked)'}</div>
              </div>
              <div className="flex gap-2">
                <button 
                  className={`px-3 py-1 rounded-full text-xs font-semibold transition ${v.isFreePreview ? 'bg-orange-500 hover:bg-orange-600' : 'bg-green-500 hover:bg-green-600'} text-white`} 
                  onClick={() => toggleFreePreview(v.id)}
                  disabled={isSaving}
                >
                  {v.isFreePreview ? 'Switch to Paid' : 'Switch to Free'}
                </button>
                <button className="px-3 py-1 bg-red-500 text-white rounded-full text-xs font-medium hover:bg-red-600 transition" onClick={() => deleteVideo(v.id)} disabled={isSaving}>Delete</button>
              </div>
            </div>
          ))}
          {!content.videos.filter(v => v.categoryId === selCat).length && <div className="text-sm text-gray-500 p-4"><EmptyState title="No Videos" message="Add a video to this category above." /></div>}
        </div>
      </Card>
    </div>
  );
}

/* =========================
   ADMIN: Payouts (UPDATED to use global state & ApiClient)
   ========================= */
function PayoutsReport() {
  const { allPayouts, allUsers, isLoading, fetchData } = useAppGlobal();
  const [loading, setLoading] = useState(false); // Local loading for export/import
  const [filter, setFilter] = useState('All');

  // Recalculate status based on current user data whenever global data changes
  const recalculatedPayouts = useMemo(() => {
    if (allPayouts.length === 0) return [];
    
    // Create a map for quick user lookup
    const userMap = allUsers.reduce((map, user) => {
        map[user.email] = user;
        return map;
    }, {});
    
    return allPayouts.map(p => {
        const ref = userMap[p.referrerEmail];
        const isReady = !!(ref?.bank?.accountNumber && ref.bank?.ifsc && ref.bank?.pan && ref.bank?.chequeUrl && ref.bank?.isVerified);
        
        let status = p.status;
        let bankDetails = p.bankDetails;

        if (p.status === 'Data Limitation' && isReady) {
            status = 'Pending';
            bankDetails = { ...ref.bank }; // Update details to current verified ones
        }
        if (p.status === 'Pending' && !isReady) {
            status = 'Data Limitation';
            // Note: We don't update bank details here unless the user explicitly removes them.
            // Keeping the existing data limitation details for historical context in the payout object.
        }
        
        // IMPORTANT: We need to persist these changes back to the database.
        // We defer this mass update until a major action (like exporting/editing) or assume the backend handles it.
        // For now, we only use this for display and update when actively saving/importing.
        return { ...p, status, bankDetails };
    });
  }, [allPayouts, allUsers]);

  const list = filter === 'All' ? recalculatedPayouts : recalculatedPayouts.filter(p => p.status === filter);

  const exportCSV = () => {
    const rows = list.filter(p => p.status === 'Pending');
    if (!rows.length) {
      toast.error('No pending payouts to export under this filter.');
      return;
    }
    const header = ["Id", "Referrer", "Referee", "BankAccount", "IFSC", "PAN", "Amount", "Status", "UTRNumber"];
    const lines = [header.join(",")];
    rows.forEach(p => {
      const bankAcc = `'${String(p.bankDetails?.accountNumber || "").replace(/'/g, "''")}`; 
      lines.push([
        p.id, csvCell(p.referrer), csvCell(p.referee), csvCell(bankAcc),
        csvCell(p.bankDetails?.ifsc || ''), csvCell(p.bankDetails?.pan || ''),
        p.amount, p.status, ""
      ].join(","));
    });
    const blob = new Blob([lines.join("\n")], { type: 'text/csv;charset=utf-8;' }); trigger(blob, 'pending_payouts.csv');
  };

  const importCSV = async (e) => {
    const f = e.target.files?.[0]; if (!f) return;
    setLoading(true);
    
    try {
        const text = await new Promise((resolve, reject) => {
            const r = new FileReader();
            r.onload = () => resolve(String(r.result || ''));
            r.onerror = reject;
            r.readAsText(f);
        });

        const { headers, rows } = parseCSV(text);
        const need = ["Id", "Status", "UTRNumber"]; need.forEach(h => { if (!headers.includes(h)) throw new Error(`Missing column: ${h}`); });
        const idI = headers.indexOf('Id'), stI = headers.indexOf('Status'), utrI = headers.indexOf('UTRNumber');
        const upd = rows.map(arr => ({ id: Number(arr[idI]), status: String(arr[stI]).trim(), utr: String(arr[utrI] || '').trim() }))
                        .filter(x => x.id && x.status.toLowerCase() === 'paid' && x.utr); 
        
        if (!upd.length) { 
            toast.error('No valid Paid rows with UTR found in CSV.'); 
            return; 
        }
        
        const today = (() => { const d = new Date(); const dd = ('0' + d.getDate()).slice(-2); const mm = ('0' + (d.getMonth() + 1)).slice(-2); const yyyy = d.getFullYear(); return `${dd}-${mm}-${yyyy}`; })();
        
        // Apply updates to the current global list
        const nextPayouts = allPayouts.map(p => { 
            const u = upd.find(z => z.id === p.id); 
            return u ? { ...p, status: 'Paid', utrNumber: u.utr, paymentDate: today } : p; 
        });
        
        await ApiClient.savePayouts(nextPayouts); // Persist updated payouts
        fetchData(); // Refresh global state
        toast.success(`Import complete. ${upd.length} rows updated.`);
        
    } catch (err) { 
        toast.error('CSV parse error: ' + err.message); 
    } finally { 
        e.target.value = '';
        setLoading(false);
    }
  };

  if (isLoading) return <Card><div className="text-center py-4">Loading payouts report...</div></Card>;
  if (!allPayouts) return null;

  return (
    <div>
      <h3 className="text-xl font-bold mb-3">Payouts Report</h3>
      <div className="mb-3 flex gap-2 flex-wrap">
        {['All', 'Pending', 'Paid', 'Data Limitation'].map(f => (
          <button key={f} onClick={() => setFilter(f)} className={'px-4 py-1 rounded-full text-sm font-semibold transition ' + (filter === f ? `${CTA_BUTTON_CLASS} text-white` : 'bg-gray-200 hover:bg-gray-300')}>{f}</button>
        ))}
      </div>
      <div className="mb-4 flex flex-wrap items-center gap-3">
        <button className={`px-4 py-2 bg-green-600 text-white rounded-full font-semibold transition disabled:opacity-50 hover:bg-green-700`} onClick={exportCSV} disabled={loading}>Export CSV (Pending)</button>
        <label className={`px-4 py-2 bg-red-600 text-white rounded-full cursor-pointer font-semibold transition disabled:opacity-50 hover:bg-red-700 ${loading ? 'opacity-50' : ''}`}>Import CSV (Paid + UTR)
          <input type="file" accept=".csv" className="hidden" onChange={importCSV} disabled={loading}/>
        </label>
      </div>
      <div className="bg-white rounded-xl shadow overflow-x-auto border">
        {loading ? <div className="text-center py-6 text-gray-600">Processing request...</div> : (
          <table className="min-w-full text-sm">
            <thead className="bg-gray-50"><tr>
              <th className="px-3 py-2 text-left">Referrer</th>
              <th className="px-3 py-2 text-left">Referee</th>
              <th className="px-3 py-2 text-left">Amount</th>
              <th className="px-3 py-2 text-left">Status</th>
              <th className="px-3 py-2 text-left">Payment Date</th>
              <th className="px-3 py-2 text-left">UTR</th>
            </tr></thead>
            <tbody>
              {list.map(p => (
                <tr key={p.id} className="border-b">
                  <td className="px-3 py-2">{p.referrer}</td>
                  <td className="px-3 py-2">{p.referee}</td>
                  <td className="px-3 py-2">{formatINR(p.amount)}</td>
                  <td className="px-3 py-2">
                    <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${p.status === 'Paid' ? 'bg-green-100 text-green-800' : p.status === 'Pending' ? 'bg-orange-100 text-orange-800' : 'bg-red-100 text-red-800'}`}>
                      {p.status}
                    </span>
                  </td>
                  <td className="px-3 py-2">{p.paymentDate || '-'}</td>
                  <td className="px-3 py-2">{p.utrNumber || '-'}</td>
                </tr>
              ))}
              {!list.length && <tr><td className="px-3 py-6 text-gray-500" colSpan="6">
                <EmptyState title="No Payouts Found" message="No payouts match the current filter." />
              </td></tr>}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
function parseCSV(text) { const lines = text.replace(/\r/g, '').split('\n').filter(Boolean); if (!lines.length) return { headers: [], rows: [] }; const headers = splitCSVLine(lines[0]); const rows = lines.slice(1).map(splitCSVLine); return { headers, rows }; }
function splitCSVLine(line) { const out = []; let cur = ''; let inQ = false; for (let i = 0; i < line.length; i++) { const ch = line[i]; if (inQ) { if (ch === '"') { if (line[i + 1] === '"') { cur += '"'; i++; } else inQ = false; } else cur += ch; } else { if (ch === '"') inQ = true; else if (ch === ',') { out.push(cur); cur = ''; } else cur += ch; } } out.push(cur); return out; }

/* =========================
   ADMIN: Invoices + Settings (UPDATED to use dedicated API calls)
   ========================= */
function Invoices() {
  const { allSales, isLoading } = useAppGlobal();
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true); // Local loading for dedicated fetches
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [year, setYear] = useState(new Date().getFullYear());
  const [rows, setRows] = useState([]);
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    // Only need to fetch settings once
    ApiClient.fetchInvoiceSettings().then(setSettings).then(() => setLoading(false));
  }, []);
  
  if (isLoading || loading) return <Card><div className="text-center py-4">Loading invoices...</div></Card>;

  const generate = async () => {
    setLoading(true);
    
    // allSales is already available from the global hook
    const nextNo = await ApiClient.fetchNextInvoiceNumber();
    
    let next = nextNo;
    const filtered = allSales.filter(s => { const d = new Date(s.date); return d.getMonth() + 1 === Number(month) && d.getFullYear() === Number(year); });
    const enr = filtered.map(s => {
      const sameState = String(settings.companyState || '').toUpperCase() === String(s.customerState || '').toUpperCase();
      const t = splitGST({ grossAmount: s.amount, sameState });
      return { orderId: s.id, date: s.date, customerName: s.customerName, customerGSTIN: s.customerGSTIN || '', customerState: s.customerState || '', invoiceNo: `${settings.invoicePrefix || 'INV-'}${next++}`, taxableValue: t.taxable, cgst: t.cgst, sgst: t.sgst, igst: t.igst, total: t.total };
    });
    setRows(enr); 
    await ApiClient.saveNextInvoiceNumber(next);
    setLoading(false);
    if (!enr.length) {
      toast('No sales found for this period.', { icon: 'ℹ️' });
    }
  };
  const downloadGSTCsv = () => {
    if (!rows.length) { toast.error('Generate a report first'); return; }
    const header = ['InvoiceNumber', 'Date', 'CustomerName', 'CustomerGSTIN', 'PlaceOfSupply', 'TaxableValue', 'CGST', 'SGST', 'IGST', 'Total', 'SAC', 'CompanyGSTIN'];
    const lines = [header.join(',')];
    rows.forEach(r => lines.push([r.invoiceNo, r.date, csvCell(r.customerName), r.customerGSTIN, r.customerState, r.taxableValue.toFixed(2), r.cgst.toFixed(2), r.sgst.toFixed(2), r.igst.toFixed(2), r.total.toFixed(2), settings.sacCode || '', settings.gstin || ''].join(',')));
    const blob = new Blob([lines.join('\n')], { type: 'text/csv;charset=utf-8' }); trigger(blob, `GST_Report_${monthName(month)}_${year}.csv`);
  };
  const downloadAllZip = async () => {
    if (!rows.length) { toast.error('Generate a report first'); return; }
    try {
      // Use the helper function to dynamically load JSZip
      const JSZip = await loadJSZip();
      
      const zip = new JSZip();
      rows.forEach(r => zip.file(`${r.invoiceNo}.html`, invoiceHTML(r, settings)));
      const content = await zip.generateAsync({ type: 'blob' }); trigger(content, `Invoices_${monthName(month)}_${year}.zip`);
    } catch (e) { toast.error('ZIP library failed to load: ' + e.message); }
  };

  return (
    <Card>
      <h2 className="text-2xl font-bold mb-2">Invoices</h2>
      <p className="text-gray-600 mb-4">Monthly report, GST CSV, ZIP of all invoices, and previews.</p>
      <div className="flex flex-wrap items-end gap-3 mb-4">
        <label>Month
          <select className="border rounded px-3 py-2 ml-2" value={month} onChange={e => setMonth(Number(e.target.value))}>
            {Array.from({ length: 12 }, (_, i) => i + 1).map(m => <option key={m} value={m}>{m} - {monthName(m)}</option>)}
          </select>
        </label>
        <label>Year
          <input type="number" className="border rounded px-3 py-2 ml-2 w-28" value={year} onChange={e => setYear(Number(e.target.value))} />
        </label>
        <button className={`${CTA_BUTTON_CLASS} text-white px-4 py-2 rounded-full font-semibold transition disabled:opacity-50`} onClick={generate} disabled={loading}>
            {loading ? 'Generating...' : 'Generate Report'}
        </button>
        <button className="bg-green-600 text-white px-4 py-2 rounded-full font-semibold hover:bg-green-700 transition" onClick={downloadGSTCsv} disabled={rows.length === 0}>Download GST Report (CSV)</button>
        <button className="bg-gray-900 text-white px-4 py-2 rounded-full font-semibold hover:bg-gray-700 transition" onClick={downloadAllZip} disabled={rows.length === 0}>Download All Invoices (ZIP)</button>
      </div>
      <div className="overflow-x-auto bg-white rounded-xl shadow border">
        <table className="min-w-full text-sm">
          <thead className="bg-gray-50"><tr>
            <th className="px-3 py-2 text-left">Invoice #</th>
            <th className="px-3 py-2 text-left">Date</th>
            <th className="px-3 py-2 text-left">Customer</th>
            <th className="px-3 py-2 text-left">Taxable</th>
            <th className="px-3 py-2 text-left">CGST</th>
            <th className="px-3 py-2 text-left">SGST</th>
            <th className="px-3 py-2 text-left">IGST</th>
            <th className="px-3 py-2 text-left">Total</th>
            <th className="px-3 py-2 text-left">Action</th>
          </tr></thead>
          <tbody>
            {rows.map(r => (
              <tr key={r.invoiceNo} className="border-b">
                <td className="px-3 py-2">{r.invoiceNo}</td>
                <td className="px-3 py-2">{r.date}</td>
                <td className="px-3 py-2">{r.customerName}</td>
                <td className="px-3 py-2">{formatINR(r.taxableValue)}</td>
                <td className="px-3 py-2">{formatINR(r.cgst)}</td>
                <td className="px-3 py-2">{formatINR(r.sgst)}</td>
                <td className="px-3 py-2">{formatINR(r.igst)}</td>
                <td className="px-3 py-2">{formatINR(r.total)}</td>
                <td className="px-3 py-2"><button className="px-3 py-1 bg-gray-200 rounded-full text-xs font-medium hover:bg-gray-300 transition" onClick={() => setPreview(r)}>View</button></td>
              </tr>
            ))}
            {!rows.length && <tr><td className="px-3 py-6 text-gray-500" colSpan="9">
              <EmptyState title="No Invoices" message="Generate a report to see invoices." />
            </td></tr>}
          </tbody>
        </table>
      </div>
      {preview && (
        <Modal onClose={() => setPreview(null)}>
          <iframe title="Invoice Preview" srcDoc={invoiceHTML(preview, settings)} className="w-full h-[70vh] rounded" />
        </Modal>
      )}
    </Card>
  );
}
function InvoiceSettings() {
  const [s, setS] = useState(null);
  const [next, setNext] = useState(1001);
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async () => {
    const [settingsData, nextNo] = await Promise.all([
        ApiClient.fetchInvoiceSettings(),
        ApiClient.fetchNextInvoiceNumber()
    ]);
    setS(settingsData);
    setNext(nextNo);
    setLoading(false);
  }, []);

  useEffect(() => { 
    fetchData(); 
  }, [fetchData]);
  
  const upd = (k, v) => setS(prev => ({ ...prev, [k]: v }));
  
  const save = async () => { 
    setLoading(true);
    try {
        await ApiClient.saveInvoiceSettings(s); 
        await ApiClient.saveNextInvoiceNumber(next);
        toast.success('Invoice settings saved'); 
    } catch (e) {
        toast.error('Failed to save settings.');
        console.error("Invoice Settings Save Error:", e);
    } finally {
        setLoading(false);
    }
  };
  
  if (loading) return <Card><div className="text-center py-4">Loading invoice settings...</div></Card>;

  return (
    <Card>
      <h2 className="text-2xl font-bold mb-4">Invoice Settings</h2>
      <p className="text-gray-600 mb-4">Applies to future invoices.</p>
      <div className="grid md:grid-cols-2 gap-4">
        <label className="block">Company Name<input className="w-full border p-2 rounded mt-1" value={s.companyName} onChange={e => upd('companyName', e.target.value)} /></label>
        <label className="block">Company State<input className="w-full border p-2 rounded mt-1" value={s.companyState} onChange={e => upd('companyState', e.target.value.toUpperCase())} /></label>
        <label className="block">Company Address<textarea rows={3} className="w-full border p-2 rounded mt-1" value={s.companyAddress} onChange={e => upd('companyAddress', e.target.value)} /></label>
        <label className="block">GSTIN<input className="w-full border p-2 rounded mt-1" value={s.gstin} onChange={e => upd('gstin', e.target.value)} /></label>
        <label className="block">SAC Code<input className="w-full border p-2 rounded mt-1" value={s.sacCode} onChange={e => upd('sacCode', e.target.value)} /></label>
        <label className="block">Company Logo URL<input className="w-full border p-2 rounded mt-1" value={s.logoUrl} onChange={e => upd('logoUrl', e.target.value)} /></label>
        <label className="block">Primary Color<input type="color" className="w-full border p-2 rounded mt-1 h-10" value={s.primaryColor} onChange={e => upd('primaryColor', e.target.value)} /></label>
        <label className="block">Font Size (px)<input type="number" className="w-full border p-2 rounded mt-1" value={s.fontSize} onChange={e => upd('fontSize', Number(e.target.value || 14))} /></label>
        <label className="block">Item Description<input className="w-full border p-2 rounded mt-1" value={s.itemDescription} onChange={e => upd('itemDescription', e.target.value)} /></label>
        <label className="block">Footer Note<input className="w-full border p-2 rounded mt-1" value={s.footerNote} onChange={e => upd('footerNote', e.target.value)} /></label>
        <label className="block">Signatory Name<input className="w-full border p-2 rounded mt-1" value={s.signatoryName} onChange={e => upd('signatoryName', e.target.value)} /></label>
        <label className="block">Signatory Image URL<input className="w-full border p-2 rounded mt-1" value={s.signatoryImageUrl} onChange={e => upd('signatoryImageUrl', e.target.value)} /></label>
        <label className="block">Invoice Prefix<input className="w-full border p-2 rounded mt-1" value={s.invoicePrefix} onChange={e => upd('invoicePrefix', e.target.value)} /></label>
        <label className="block">Next Invoice Number<input type="number" className="w-full border p-2 rounded mt-1" value={next} onChange={e => setNext(Number(e.target.value || 1))} /></label>
      </div>
      <button className={`mt-6 ${CTA_BUTTON_CLASS} text-white px-6 py-2 rounded-full font-semibold transition disabled:opacity-50`} onClick={save} disabled={loading}>
          {loading ? 'Saving...' : 'Save Settings'}
      </button>
    </Card>
  );
}

/* =========================
   ADMIN: Shell
   ========================= */

function ManageLegal() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [termsContent, setTermsContent] = useState('');
  const [privacyContent, setPrivacyContent] = useState('');
  const [refundContent, setRefundContent] = useState('');

  useEffect(() => {
    ApiClient.fetchLegalDocs().then(loadedDocs => {
      setTermsContent(loadedDocs.termsContent || '');
      setPrivacyContent(loadedDocs.privacyContent || '');
      setRefundContent(loadedDocs.refundContent || '');
      setLoading(false);
    }).catch(e => {
        toast.error('Failed to load legal settings.');
        console.error("Legal Fetch Error:", e);
        setLoading(false);
    });
  }, []);

  const handleSave = async () => {
    setSaving(true);
    try {
        await ApiClient.saveLegalDocs({ termsContent, privacyContent, refundContent });
        toast.success('Legal document content has been saved and is now live.');
    } catch (e) {
        toast.error('Failed to save legal settings.');
        console.error("Legal Save Error:", e);
    } finally {
        setSaving(false);
    }
  };

  if (loading) return <Card><div className="text-center py-4">Loading legal settings...</div></Card>;

  return (
    <Card>
      <h2 className="text-xl font-bold mb-2">Manage Legal Documents</h2>
      <p className="text-gray-600 mb-4">
        Edit the text below and click Save. Changes go live immediately on your website's Terms, Privacy, and Refund Policy pages — no developer needed. Leave a box empty to show the default built-in version instead. Separate paragraphs with a blank line.
      </p>
      <div className="space-y-6">
        <div>
          <label className="block font-semibold mb-1">Terms & Conditions</label>
          <textarea
            className="w-full border p-2 rounded mt-1 font-mono text-sm"
            rows={14}
            placeholder="Leave empty to use the default Terms & Conditions..."
            value={termsContent}
            onChange={e => setTermsContent(e.target.value)}
          />
        </div>
        <div>
          <label className="block font-semibold mb-1">Privacy Policy</label>
          <textarea
            className="w-full border p-2 rounded mt-1 font-mono text-sm"
            rows={14}
            placeholder="Leave empty to use the default Privacy Policy..."
            value={privacyContent}
            onChange={e => setPrivacyContent(e.target.value)}
          />
        </div>
        <div>
          <label className="block font-semibold mb-1">Refund & Cancellation Policy</label>
          <textarea
            className="w-full border p-2 rounded mt-1 font-mono text-sm"
            rows={14}
            placeholder="Leave empty to use the default Refund Policy..."
            value={refundContent}
            onChange={e => setRefundContent(e.target.value)}
          />
        </div>
        <button className={`${CTA_BUTTON_CLASS} text-white px-6 py-2 rounded-full font-semibold transition disabled:opacity-50`} onClick={handleSave} disabled={saving}>
          {saving ? 'Saving...' : 'Save & Publish'}
        </button>
      </div>
    </Card>
  );
}

function ManageContactInfo() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState(DEFAULT_CONTACT_INFO);

  useEffect(() => {
    ApiClient.fetchContactInfo().then(data => {
      const hasData = data && Object.keys(data).length > 0;
      setForm(hasData ? { ...DEFAULT_CONTACT_INFO, ...data } : DEFAULT_CONTACT_INFO);
      setLoading(false);
    }).catch(e => {
        toast.error('Failed to load contact settings.');
        console.error("Contact Fetch Error:", e);
        setLoading(false);
    });
  }, []);

  const upd = (key, value) => setForm(prev => ({ ...prev, [key]: value }));

  const handleSave = async () => {
    setSaving(true);
    try {
        await ApiClient.saveContactInfo(form);
        toast.success('Contact info saved and is now live on your Contact Us page.');
    } catch (e) {
        toast.error('Failed to save contact settings.');
        console.error("Contact Save Error:", e);
    } finally {
        setSaving(false);
    }
  };

  if (loading) return <Card><div className="text-center py-4">Loading contact settings...</div></Card>;

  return (
    <Card>
      <h2 className="text-xl font-bold mb-2">Manage Contact Us Page</h2>
      <p className="text-gray-600 mb-4">
        This information appears on your public Contact Us page and Privacy Policy Grievance Officer section. Update it here — no code changes needed.
      </p>
      <div className="space-y-4">
        <div>
          <label className="block font-semibold mb-1">Registered Business Address</label>
          <textarea className="w-full border p-2 rounded mt-1" rows={3} value={form.address} onChange={e => upd('address', e.target.value)} />
        </div>
        <div>
          <label className="block font-semibold mb-1">Phone Number</label>
          <input className="w-full border p-2 rounded mt-1" value={form.phone} onChange={e => upd('phone', e.target.value)} />
        </div>
        <div>
          <label className="block font-semibold mb-1">Primary Email</label>
          <input className="w-full border p-2 rounded mt-1" value={form.emailPrimary} onChange={e => upd('emailPrimary', e.target.value)} />
        </div>
        <div>
          <label className="block font-semibold mb-1">Secondary Email</label>
          <input className="w-full border p-2 rounded mt-1" value={form.emailSecondary} onChange={e => upd('emailSecondary', e.target.value)} />
        </div>
        <div>
          <label className="block font-semibold mb-1">Grievance Officer Name</label>
          <input className="w-full border p-2 rounded mt-1" value={form.grievanceOfficerName} onChange={e => upd('grievanceOfficerName', e.target.value)} />
        </div>
        <button className={`${CTA_BUTTON_CLASS} text-white px-6 py-2 rounded-full font-semibold transition disabled:opacity-50`} onClick={handleSave} disabled={saving}>
          {saving ? 'Saving...' : 'Save & Publish'}
        </button>
      </div>
    </Card>
  );
}
function AdminEditBankModal({ user, onClose, onSave }) {
  const [bank, setBank] = useState(user.bank || { accountNumber: '', ifsc: '', pan: '', chequeUrl: '', isVerified: false });
  const [isSaving, setIsSaving] = useState(false);
  
  const handleSave = async () => {
    if (!bank.accountNumber || !bank.ifsc || !bank.pan || !bank.chequeUrl) {
      toast.error('All bank fields must be filled before saving.');
      return;
    }
    
    setIsSaving(true);
    try {
        await ApiClient.updateUser(user.id, { bank });
        onSave(); // Trigger full global data refresh
        onClose();
        toast.success(`Bank details for ${user.name} updated.`);
    } catch (e) {
        toast.error('Failed to update bank details: ' + e.message);
        console.error("Admin Bank Update Error:", e);
    } finally {
        setIsSaving(false);
    }
  };

  return (
    <Modal onClose={onClose}>
      <h3 className="text-xl font-bold mb-4">Edit/Verify Payout Details for {user.name}</h3>
      <div className="grid md:grid-cols-2 gap-4">
        <label className="block">Account Number<input name="accountNumber" className="border p-2 rounded w-full mt-1" value={bank.accountNumber} onChange={e => setBank(p => ({ ...p, accountNumber: e.target.value }))} /></label>
        <label className="block">IFSC<input name="ifsc" className="border p-2 rounded w-full mt-1" value={bank.ifsc} onChange={e => setBank(p => ({ ...p, ifsc: e.target.value }))} /></label>
        <label className="block">PAN<input name="pan" className="border p-2 rounded w-full mt-1" value={bank.pan} onChange={e => setBank(p => ({ ...p, pan: e.target.value }))} /></label>
        <label className="block">Cheque/Bank Statement URL
          <input name="chequeUrl" className="border p-2 rounded w-full mt-1" value={bank.chequeUrl} onChange={e => setBank(p => ({ ...p, chequeUrl: e.target.value }))} />
          {bank.chequeUrl && <a href={bank.chequeUrl} target="_blank" rel="noopener noreferrer" className="text-xs text-blue-600 hover:underline">View Document</a>}
        </label>
      </div>
      <div className="flex items-center gap-4 mt-6">
        <label className="flex items-center gap-2 font-semibold">
          <input 
            type="checkbox" 
            checked={bank.isVerified} 
            onChange={e => setBank(p => ({ ...p, isVerified: e.target.checked }))} 
            className="h-5 w-5 rounded text-green-600 focus:ring-green-500"
          />
          Bank Details Verified (Admin Only)
        </label>
        <button className={`${CTA_BUTTON_CLASS} text-white px-6 py-2 rounded-full font-semibold transition`} onClick={handleSave} disabled={isSaving}>
            {isSaving ? 'Saving...' : 'Save Changes'}
        </button>
      </div>
    </Modal>
  );
}

// Updated UserManagement for bulk actions and admin bank editing (UPDATED to use global state & ApiClient)
function UserManagement() {
  const { allUsers, allPayouts, isLoading, fetchData } = useAppGlobal();
  const [loading, setLoading] = useState(false); // Local loading for form/bulk actions
  const [filterRole, setFilterRole] = useState('All');
  const [filterStatus, setFilterStatus] = useState('All');
  const [selectedUsers, setSelectedUsers] = useState(new Set());
  const [editModalUser, setEditModalUser] = useState(null); 

  // Form states
  const [accountantEmail, setAccountantEmail] = useState('');
  const [upgradeEmail, setUpgradeEmail] = useState('');
  const [upgradeRole, setUpgradeRole] = useState(ROLE_MEMBER);

  // Central function to update user in database
  const updateUserRoleOrStatus = async (userId, updates) => {
    setLoading(true);
    try {
        await ApiClient.updateUser(userId, updates);
        toast.success('User updated successfully.');
    } catch (e) {
        toast.error('Failed to update user: ' + e.message);
        console.error("User Update Error:", e);
    } finally {
        setLoading(false);
        fetchData(); // Trigger global refresh
    }
  }

  // 1. Appoint Accountant
  const handleAppointAccountant = async (e) => {
    e.preventDefault();
    const email = accountantEmail.trim().toLowerCase();
    const user = allUsers.find(u => u.email.toLowerCase() === email);
    
    if (!user) {
      toast.error('User not found. Please ask the user to register first.');
      return;
    }
    await updateUserRoleOrStatus(user.id, { role: ROLE_ACCOUNTANT });
    setAccountantEmail('');
  };

  // 2. Manually Upgrade User
  const handleUpgradeUser = async (e) => {
    e.preventDefault();
    const email = upgradeEmail.trim().toLowerCase();
    const user = allUsers.find(u => u.email.toLowerCase() === email);

    if (!user) {
      toast.error('User not found. Please ask the user to register first.');
      return;
    }
    await updateUserRoleOrStatus(user.id, { role: upgradeRole, status: STATUS_ACTIVE });
    setUpgradeEmail('');
    setUpgradeRole(ROLE_MEMBER);
  };
  
  const handleToggleBlock = async (userId, isCurrentlyBlocked) => {
    const newStatus = isCurrentlyBlocked ? STATUS_ACTIVE : STATUS_BLOCKED;
    await updateUserRoleOrStatus(userId, { status: newStatus });
  };
  
  // 3. View and Filter Users (Memoized calculation based on global state)
  const filteredUsers = useMemo(() => {
    if (!allUsers) return [];
    
    // Create map of earnings from payouts for efficiency
    const earningsMap = allPayouts.reduce((map, p) => {
        if (!map[p.referrerEmail]) map[p.referrerEmail] = { paid: 0, pending: 0 };
        if (p.status === 'Paid') {
            map[p.referrerEmail].paid += p.amount;
        } else if (p.status === 'Pending' || p.status === 'Data Limitation') {
            map[p.referrerEmail].pending += p.amount;
        }
        return map;
    }, {});
    
    return allUsers
      .filter(u => {
        const role = u.role || ROLE_MEMBER;
        const status = u.status || STATUS_ACTIVE;
        if (filterRole !== 'All' && role !== filterRole) return false;
        if (filterStatus !== 'All' && status !== filterStatus) return false;
        return true;
      })
      .map(u => {
        const earnings = earningsMap[u.email] || { paid: 0, pending: 0 };
        const hasFullBank = !!(u.bank?.accountNumber && u.bank?.ifsc && u.bank?.pan && u.bank?.chequeUrl);
        const isVerified = u.bank?.isVerified || false;
        
        return { 
          ...u, 
          paid: earnings.paid, 
          pending: earnings.pending, 
          hasFullBank, 
          isVerified,
          status: u.status || STATUS_ACTIVE, 
          role: u.role || ROLE_MEMBER
        };
      });
  }, [allUsers, allPayouts, filterRole, filterStatus]);

  // 5. Bulk Actions 
  const handleToggleSelect = (userId) => {
    const next = new Set(selectedUsers);
    if (next.has(userId)) {
      next.delete(userId);
    } else {
      next.add(userId);
    }
    setSelectedUsers(next);
  };

  const handleSelectAll = () => {
    const selectAllSet = new Set(filteredUsers.filter(u => u.role !== ROLE_ADMIN && u.role !== ROLE_ACCOUNTANT).map(u => u.id));
    
    if (selectedUsers.size === selectAllSet.size && selectedUsers.size > 0) {
      setSelectedUsers(new Set());
    } else {
      setSelectedUsers(selectAllSet);
    }
  };

  const handleBulkAction = async (action) => {
    setLoading(true);
    try {
        const updates = Array.from(selectedUsers).map(userId => {
            const user = allUsers.find(u => u.id === userId);
            if (!user) return null;

            let newRole = user.role;
            let newStatus = user.status || STATUS_ACTIVE;
            
            if (action === 'block') newStatus = STATUS_BLOCKED;
            else if (action === 'unblock') newStatus = STATUS_ACTIVE;
            else if (action === 'upgrade_super_premium') newRole = ROLE_SUPER_PREMIUM;
            else if (action === 'downgrade_member') newRole = ROLE_MEMBER;

            return { userId, updates: { role: newRole, status: newStatus } };
        }).filter(Boolean);
        
        // This should be optimized on the backend as a single /bulk-update route.
        // For now, we simulate by sending individual API calls (or could send the whole new user list)
        
        // Option 1: Send the resulting new list (easiest client-side simulation)
        const newUsers = allUsers.map(u => {
            const update = updates.find(up => up.userId === u.id);
            return update ? { ...u, ...update.updates } : u;
        });

        // The updateUser API route needs to handle this logic or we need a bulk endpoint.
        // Since we don't have a specific bulk endpoint, we use a loop and rely on fetchData() to sync.
        await Promise.all(updates.map(u => ApiClient.updateUser(u.userId, u.updates)));

        toast.success(`${updates.length} users updated successfully.`);
    } catch (e) {
        toast.error('Bulk update failed: ' + e.message);
        console.error("Bulk Action Error:", e);
    } finally {
        setSelectedUsers(new Set());
        setLoading(false);
        fetchData(); // Trigger global refresh
    }
  };


  const selectedMemberCount = Array.from(selectedUsers).filter(id => {
    const user = allUsers?.find(u => u.id === id);
    return user && (user.role === ROLE_MEMBER || user.role === ROLE_SUPER_PREMIUM);
  }).length;
  
  if (isLoading) return <Card><div className="text-center py-4">Loading user data...</div></Card>;

  return (
    <div className="space-y-6">
      <div className="grid md:grid-cols-2 gap-6">
        <Card>
          <h3 className="text-xl font-bold mb-2">Appoint an Accountant</h3>
          <p className="text-sm text-gray-600 mb-3">User must be registered first.</p>
          <form onSubmit={handleAppointAccountant} className="flex gap-2">
            <input 
              className="w-full px-3 py-2 border rounded" 
              placeholder="Accountant's Email" 
              value={accountantEmail} 
              onChange={e => setAccountantEmail(e.target.value)} 
              required 
            />
            <button type="submit" className={`${CTA_BUTTON_CLASS} text-white px-4 py-2 rounded-full font-semibold transition disabled:opacity-50`} disabled={loading}>
                {loading ? 'Processing...' : 'Appoint'}
            </button>
          </form>
        </Card>

        <Card>
          <h3 className="text-xl font-bold mb-2">Manually Change Member Role</h3>
          <p className="text-sm text-gray-600 mb-3">Change a user's role and associated commission.</p>
          <form onSubmit={handleUpgradeUser} className="flex flex-wrap gap-2">
            <input 
              className="flex-1 min-w-[200px] px-3 py-2 border rounded" 
              placeholder="Member's Email" 
              value={upgradeEmail} 
              onChange={e => setUpgradeEmail(e.target.value)} 
              required 
            />
            <select 
              className="px-3 py-2 border rounded" 
              value={upgradeRole} 
              onChange={e => setUpgradeRole(e.target.value)}
            >
              <option value={ROLE_MEMBER}>Premium Member (₹3000)</option>
              <option value={ROLE_SUPER_PREMIUM}>Super Premium (₹5000)</option>
            </select>
            <button type="submit" className="bg-green-600 text-white px-4 py-2 rounded-full font-semibold hover:bg-green-700 transition disabled:opacity-50" disabled={loading}>
                {loading ? 'Processing...' : 'Update Role'}
            </button>
          </form>
        </Card>
      </div>

        <Card>
        <h3 className="text-xl font-bold mb-4">All Users ({allUsers.length})</h3>
        
        {/* Filters and Bulk Actions */}
        <div className="flex flex-wrap gap-4 items-center mb-4">
          <select 
            className="border p-2 rounded" 
            value={filterRole} 
            onChange={e => setFilterRole(e.target.value)}
          >
            <option value="All">All Roles</option>
            <option value={ROLE_ADMIN}>Admin</option>
            <option value={ROLE_ACCOUNTANT}>Accountant</option>
            <option value={ROLE_MEMBER}>Premium Member</option>
            <option value={ROLE_SUPER_PREMIUM}>Super Premium</option>
          </select>
          <select 
            className="border p-2 rounded" 
            value={filterStatus} 
            onChange={e => setFilterStatus(e.target.value)}
          >
            <option value="All">All Statuses</option>
            <option value={STATUS_ACTIVE}>Active</option>
            <option value={STATUS_BLOCKED}>Blocked</option>
          </select>
          
          {selectedUsers.size > 0 && (
            <div className="flex flex-wrap gap-2 text-sm">
              <span className="p-2 bg-gray-100 rounded-full font-semibold">{selectedUsers.size} Selected</span>
              <button 
                className="bg-red-500 text-white px-3 py-2 rounded-full font-semibold hover:bg-red-600 transition"
                onClick={() => handleBulkAction('block')}
                disabled={loading}
              >
                Block
              </button>
              <button 
                className="bg-gray-700 text-white px-3 py-2 rounded-full font-semibold hover:bg-gray-600 transition"
                onClick={() => handleBulkAction('unblock')}
                disabled={loading}
              >
                Unblock
              </button>
              {selectedMemberCount > 0 && (
                <>
                  <button 
                    className="bg-blue-500 text-white px-3 py-2 rounded-full font-semibold hover:bg-blue-600 transition"
                    onClick={() => handleBulkAction('upgrade_super_premium')}
                    disabled={loading}
                  >
                    Bulk Upgrade ({selectedMemberCount})
                  </button>
                  <button 
                    className="bg-orange-500 text-white px-3 py-2 rounded-full font-semibold hover:bg-orange-600 transition"
                    onClick={() => handleBulkAction('downgrade_member')}
                    disabled={loading}
                  >
                    Bulk Downgrade ({selectedMemberCount})
                  </button>
                </>
              )}
            </div>
          )}
        </div>

        {/* User Table */}
        <div className="overflow-x-auto">
          {loading ? <div className="text-center py-6 text-gray-600">Processing request...</div> : (
            <table className="min-w-full text-sm">
              <thead className="bg-gray-50">
                <tr>
                  <th className="p-2 text-left w-10">
                    <input 
                      type="checkbox" 
                      onChange={handleSelectAll}
                      checked={selectedUsers.size > 0 && selectedUsers.size === filteredUsers.filter(u => u.role !== ROLE_ADMIN && u.role !== ROLE_ACCOUNTANT).length}
                      className="rounded text-red-600"
                    />
                  </th>
                  <th className="px-3 py-2 text-left">Name</th>
                  <th className="px-3 py-2 text-left">Email</th>
                  <th className="px-3 py-2 text-left">Role</th>
                  <th className="px-3 py-2 text-left">Status</th>
                  <th className="px-3 py-2 text-left">Earnings (Paid/Pending)</th>
                  <th className="px-3 py-2 text-left">Payout Status</th>
                  <th className="px-3 py-2 text-left">Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredUsers.map(u => (
                  <tr key={u.id} className="border-b hover:bg-gray-50 transition">
                    <td className="p-2">
                      {(u.role === ROLE_MEMBER || u.role === ROLE_SUPER_PREMIUM) && (
                        <input 
                          type="checkbox" 
                          checked={selectedUsers.has(u.id)}
                          onChange={() => handleToggleSelect(u.id)}
                          className="rounded text-red-600"
                        />
                      )}
                    </td>
                    <td className="px-3 py-2">{u.name || '-'}</td>
                    <td className="px-3 py-2">{u.email}</td>
                    <td className="px-3 py-2 capitalize">{u.role.replace('_', ' ')}</td>
                    <td className="px-3 py-2 capitalize">
                      <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${u.status === STATUS_BLOCKED ? 'bg-red-100 text-red-800' : 'bg-green-100 text-green-800'}`}>
                        {u.status}
                      </span>
                    </td>
                    <td className="px-3 py-2">{formatINR(u.paid)} / {formatINR(u.pending)}</td>
                    <td className="px-3 py-2">
                      <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${u.isVerified ? 'bg-green-100 text-green-800' : u.hasFullBank ? 'bg-yellow-100 text-yellow-800' : 'bg-red-100 text-red-800'}`}>
                        {u.isVerified ? 'Verified' : u.hasFullBank ? 'Awaiting Verification' : 'Incomplete Data'}
                      </span>
                    </td>
                    <td className="px-3 py-2 flex gap-2">
                      <button 
                        className={`px-3 py-1 rounded-full text-xs font-semibold transition ${u.status === STATUS_BLOCKED ? 'bg-gray-600 text-white hover:bg-gray-700' : 'bg-red-500 text-white hover:bg-red-600'}`}
                        onClick={() => handleToggleBlock(u.id, u.status === STATUS_BLOCKED)}
                      >
                        {u.status === STATUS_BLOCKED ? 'Unblock' : 'Block'}
                      </button>
                      {(u.role === ROLE_MEMBER || u.role === ROLE_SUPER_PREMIUM || u.role === ROLE_ACCOUNTANT) && (
                        <button 
                          className="px-3 py-1 bg-blue-500 text-white rounded-full text-xs font-semibold hover:bg-blue-600 transition"
                          onClick={() => setEditModalUser(u)}
                        >
                          Edit/Verify
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
                {!filteredUsers.length && (
                  <tr>
                    <td className="px-3 py-6 text-gray-500 text-center" colSpan="9">
                      <EmptyState title="No Users Found" message="No users match the current filters." />
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </Card>
      {editModalUser && (
        <AdminEditBankModal 
          user={editModalUser} 
          onClose={() => setEditModalUser(null)} 
          onSave={fetchData} // Pass the global refetch function
        />
      )}
    </div>
  );
}


function AdminDashboard() {
  const [tab, setTab] = useState('Analytics');
  return (
    <Container>
      <div className="flex items-center justify-between mb-6"><h1 className="text-3xl font-bold">Admin Dashboard</h1></div>
      <div className="flex gap-2 flex-wrap mb-6">
        {['Analytics', 'Content', 'Payouts', 'Invoices', 'Invoice Settings', 'User Management', 'Legal', 'Contact'].map(t => (
          <button key={t} className={'px-3 py-1 rounded-full text-sm font-semibold transition ' + (tab === t ? `${CTA_BUTTON_CLASS} text-white shadow-md` : 'bg-gray-200 hover:bg-gray-300')} onClick={() => setTab(t)}>{t}</button>
        ))}
      </div>
      {tab === 'Analytics' && <Card><div>Analytics (placeholder)</div></Card>}
      {tab === 'Content' && <ContentManager />}
      {tab === 'Payouts' && <PayoutsReport />}
      {tab === 'Invoices' && <Invoices />}
      {tab === 'Invoice Settings' && <InvoiceSettings />}
      {tab === 'User Management' && <UserManagement />}
      {tab === 'Legal' && <ManageLegal />}
      {tab === 'Contact' && <ManageContactInfo />}
    </Container>
  );
}

/* =========================
   ACCOUNTANT (re-uses Payouts)
   ========================= */
function AccountantDashboard() {
  return (<Container><h1 className="text-3xl font-bold mb-4">Accountant Dashboard</h1><PayoutsReport /></Container>);
}

/* =========================
   NEW: FAQ Page (Unchanged)
   ========================= */
function FaqPage() {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    // ── MEMBERSHIP ──
    {
      category: 'Membership & Pricing',
      q: 'What is Edgram?',
      a: 'Edgram is a premium EdTech platform offering curated video courses across multiple categories. You pay once and get lifetime access to the entire content library, along with all future content added to the platform.'
    },
    {
      category: 'Membership & Pricing',
      q: 'How much does membership cost?',
      a: 'Membership is a one-time fee of ₹6,999. There are no monthly charges, no renewals, and no hidden fees. Pay once, access everything forever.'
    },
    {
      category: 'Membership & Pricing',
      q: 'What do I get with my membership?',
      a: 'You get lifetime access to all video courses across every category on Edgram, progress tracking, and full access to any new content added to the platform in the future — at no extra cost.'
    },
    {
      category: 'Membership & Pricing',
      q: 'Is there a free trial or free content?',
      a: 'Yes. Select videos are marked as "Free Preview" and can be watched without registering. To access the full library, a one-time membership purchase is required.'
    },
    {
      category: 'Membership & Pricing',
      q: 'Can I get a refund after purchasing?',
      a: 'Since this is a digital product with immediate access granted upon payment, refunds are not available. Please watch the free preview videos before purchasing to ensure the content suits your needs.'
    },

    // ── CONTENT ──
    {
      category: 'Content & Learning',
      q: 'What topics are covered in the courses?',
      a: 'The course library covers multiple categories and is continuously expanding. New courses are added regularly — and as a lifetime member, you get access to all of them automatically.'
    },
    {
      category: 'Content & Learning',
      q: 'How are the videos delivered?',
      a: 'All courses are video-based and streamed through YouTube\'s embed player (ad-free, privacy mode). You can watch on any device — desktop, tablet, or mobile — as long as you are logged into your Edgram account.'
    },
    {
      category: 'Content & Learning',
      q: 'Can I track my progress?',
      a: 'Yes. On each video page, click "Mark as Complete" after watching. Your progress is saved to your account and synced across devices. Completed videos show a ✅ badge in the content library.'
    },
    {
      category: 'Content & Learning',
      q: 'Will new content be added after I join?',
      a: 'Yes. Your one-time payment gives you access to all current and future content added to the platform. There is no extra charge for new videos or categories.'
    },

    // ── REFERRAL PROGRAM ──
    {
      category: 'Referral Program',
      q: 'How does the referral program work?',
      a: 'Edgram is primarily a course-selling platform. As an ancillary benefit, members get a unique referral link. If someone independently purchases a course using your link, you may be recognized under the referral program as per Edgram\'s policy, at the company\'s sole discretion.'
    },
    {
      category: 'Referral Program',
      q: 'What does "Data Limitation" mean in my Earnings History?',
      a: '"Data Limitation" means a referral recognition is pending, but your bank details are either incomplete or have not yet been verified by the Admin. Once you fill in all payout details (Account Number, IFSC, PAN, and Cancelled Cheque) and Admin verifies them, the status will automatically upgrade to "Pending" and be included in the next payout batch.'
    },

    // ── PAYOUTS ──
    {
      category: 'Payouts & Bank Details',
      q: 'How do I receive recognition under the referral program?',
      a: 'Go to your Dashboard → "Payout Details" tab and fill in your Bank Account Number, IFSC Code, PAN, and upload a Cancelled Cheque or Bank Statement URL. Once Admin verifies your details, any pending amount will be processed in the next payout batch via bank transfer.'
    },
    {
      category: 'Payouts & Bank Details',
      q: 'When are payouts processed?',
      a: 'Payouts are processed in batches, typically at the end of every month. You can track your payout status (Pending / Paid) and the UTR number in your "Earnings History" tab.'
    },
    {
      category: 'Payouts & Bank Details',
      q: 'Can I update my bank details?',
      a: 'Yes. You can update your bank details anytime from the "Payout Details" tab. Please note that updating your details will reset Admin verification — your details will need to be re-verified before the next payout.'
    },
    {
      category: 'Payouts & Bank Details',
      q: 'What documents do I need for payout verification?',
      a: 'You need to provide: (1) Bank Account Number, (2) IFSC Code, (3) PAN Card Number, and (4) a publicly accessible URL to your Cancelled Cheque or Bank Statement (e.g., a Google Drive link with view access).'
    },
    {
      category: 'Payouts & Bank Details',
      q: 'My payout status shows "Pending" — when will I get paid?',
      a: '"Pending" means your bank details are complete and verified, and your payout is queued for the next batch. Payouts are typically processed at the end of the month. You will see the status change to "Paid" along with a UTR number once the transfer is done.'
    },

    // ── ACCOUNT ──
    {
      category: 'Account & Security',
      q: 'I forgot my password. How do I reset it?',
      a: 'Click "Forgot Password?" on the login screen. Enter your registered email, answer your security question, and set a new password. Make sure you remember the answer to the security question you chose during registration.'
    },
    {
      category: 'Account & Security',
      q: 'Can I change my password from inside the dashboard?',
      a: 'Yes. Go to your Dashboard → "Security" tab → enter your current password and your new password. Changes take effect immediately.'
    },
    {
      category: 'Account & Security',
      q: 'How do I contact support?',
      a: 'For any issues not covered here, email us at admin@edgram.in (or support@edgram.in). Include your registered email address and a brief description of your issue for the fastest resolution.'
    },
  ];

  const categories = [...new Set(faqs.map(f => f.category))];

  return (
    <Container>
      <div className="max-w-3xl mx-auto">
        <h1 className="text-4xl font-extrabold mb-2 text-gray-800">Frequently Asked Questions</h1>
        <p className="text-gray-500 mb-10">Everything you need to know about Edgram. Can't find an answer? <a href="mailto:admin@edgram.in" className={`${PRIMARY_COLOR_CLASS} hover:underline`}>Email us</a>.</p>

        {categories.map(cat => (
          <div key={cat} className="mb-10">
            <h2 className={`text-sm font-bold uppercase tracking-widest ${PRIMARY_COLOR_CLASS} mb-4`}>{cat}</h2>
            <div className="space-y-3">
              {faqs.filter(f => f.category === cat).map((faq, i) => {
                const key = `${cat}-${i}`;
                const isOpen = openIndex === key;
                return (
                  <div key={key} className="border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                    <button
                      className="w-full text-left px-5 py-4 flex justify-between items-center hover:bg-gray-50 transition"
                      onClick={() => setOpenIndex(isOpen ? null : key)}
                    >
                      <span className="font-semibold text-gray-800 pr-4">{faq.q}</span>
                      <span className={`text-xl font-light flex-shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-45 text-red-500' : 'text-gray-400'}`}>+</span>
                    </button>
                    {isOpen && (
                      <div className="px-5 pb-5 pt-1 text-gray-600 leading-relaxed border-t border-gray-100 bg-white">
                        {faq.a}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </Container>
  );
}

/* =========================
   LEGAL PAGES: Privacy Policy & Terms and Conditions
   Rendered directly on edgram.in — no external redirect.
   ========================= */

function LegalSection({ title, children }) {
  return (
    <div className="mb-8">
      <h2 className="text-xl font-bold text-gray-800 mb-3">{title}</h2>
      <div className="text-gray-600 leading-relaxed space-y-2">{children}</div>
    </div>
  );
}

function PlainTextLegalContent({ text }) {
  const paragraphs = text.split(/\n\s*\n/).filter(p => p.trim().length > 0);
  return (
    <div className="text-gray-600 leading-relaxed space-y-4 whitespace-pre-line">
      {paragraphs.map((p, i) => <p key={i}>{p.trim()}</p>)}
    </div>
  );
}

function useLegalContent(key) {
  const [content, setContent] = useState(null); // null = loading, '' = empty/not set, string = custom content
  useEffect(() => {
    let cancelled = false;
    ApiClient.fetchLegalDocs()
      .then(docs => { if (!cancelled) setContent((docs && docs[key]) || ''); })
      .catch(() => { if (!cancelled) setContent(''); }); // fail silently -> fallback to default
    return () => { cancelled = true; };
  }, [key]);
  return content;
}

function PrivacyPolicyPage() {
  const customContent = useLegalContent('privacyContent');

  if (customContent === null) {
    return <Container><div className="max-w-3xl mx-auto py-20 text-center text-gray-400">Loading...</div></Container>;
  }

  if (customContent.trim().length > 0) {
    return (
      <Container>
        <div className="max-w-3xl mx-auto py-10">
          <h1 className="text-4xl font-extrabold mb-2 text-gray-800">Privacy Policy</h1>
          <PlainTextLegalContent text={customContent} />
        </div>
      </Container>
    );
  }

  return (
    <Container>
      <div className="max-w-3xl mx-auto py-10">
        <h1 className="text-4xl font-extrabold mb-2 text-gray-800">Privacy Policy</h1>
        <p className="text-gray-500 mb-10">Last updated: 02 February 2026</p>

        <LegalSection title="1. Introduction">
          <p>This Privacy Policy explains how Edgram ("we", "us", "our") collects, uses, discloses, and protects your personal information when you visit or use our website https://www.edgram.in and related Services. By using the Platform, you consent to the practices described in this Privacy Policy.</p>
        </LegalSection>

        <LegalSection title="2. Information We Collect">
          <p><strong>2.1 Information you provide:</strong> Name, email address, phone number (if provided), password (stored in encrypted form), payment-related information (processed via secure third-party payment gateways; we typically do not store full card/UPI details), profile information and preferences, and any communications you send to us (emails, support requests, feedback).</p>
          <p><strong>2.2 Information collected automatically:</strong> Device information (device type, operating system, browser type and version), log data (IP address, pages visited, time and date of visit, referring pages, clickstream data), usage data (features used, content viewed, time spent, referral link activity and performance), and cookies and similar technologies.</p>
          <p><strong>2.3 Information from third parties:</strong> Payment processors, analytics providers, marketing/advertising partners, and referrers when you sign up using someone's referral link.</p>
        </LegalSection>

        <LegalSection title="3. How We Use Your Information">
          <p>We use your information to create and manage your account, provide and improve our educational content and referral program, process payments and maintain transaction records, track referral activity and process commissions, communicate with you about your account and support requests, send marketing communications (you can opt out anytime), analyze usage trends, detect and prevent fraud or abuse, and comply with applicable laws and legal requirements.</p>
        </LegalSection>

        <LegalSection title="4. Legal Bases for Processing (where applicable)">
          <p>Where required by law, we rely on: performance of a contract, legitimate interests, consent (for marketing communications and cookies where required), and compliance with legal obligations.</p>
        </LegalSection>

        <LegalSection title="5. Cookies and Similar Technologies">
          <p>We use cookies, web beacons, and similar technologies to remember your preferences, maintain sessions, understand usage patterns, and customize your experience. You can manage or disable cookies through your browser settings, but some features may not function properly if cookies are disabled.</p>
        </LegalSection>

        <LegalSection title="6. How We Share Your Information">
          <p>We may share your information with service providers and partners (payment processing, hosting, analytics, email delivery, customer support), other users to the extent necessary for referral tracking, professional advisors, government authorities or law enforcement when required by law, and third parties in connection with a business transaction. We do not sell your personal information to third parties.</p>
        </LegalSection>

        <LegalSection title="7. Data Retention">
          <p>We retain your personal information for as long as necessary to provide the Services, comply with legal obligations, resolve disputes, and enforce our agreements. When we no longer need your information, we will delete or anonymize it in accordance with applicable law.</p>
        </LegalSection>

        <LegalSection title="8. Data Security">
          <p>We implement reasonable technical and organizational measures to protect your personal information from unauthorized access, loss, misuse, or alteration. No method of transmission over the internet or electronic storage is completely secure, and we cannot guarantee absolute security.</p>
        </LegalSection>

        <LegalSection title="9. Your Rights and Choices">
          <p>Subject to applicable law, you may have the right to access, correct, or request deletion of your personal information, object to or restrict certain processing, withdraw consent, and opt out of marketing communications using the unsubscribe link in our emails or by contacting us. You can update certain account information directly within your account settings.</p>
        </LegalSection>

        <LegalSection title="10. Children's Privacy">
          <p>The Platform is not intended for children under 18 years of age, and we do not knowingly collect personal information from children. If we become aware of having collected personal data from a child without appropriate consent, we will delete it.</p>
        </LegalSection>

        <LegalSection title="11. International Data Transfers">
          <p>Your information may be stored and processed on servers located in India and possibly other jurisdictions where our service providers are based. By using the Platform, you consent to such transfers.</p>
        </LegalSection>

        <LegalSection title="12. Third-Party Links">
          <p>The Platform may contain links to third-party websites or services. This Privacy Policy does not apply to those third-party sites, and we are not responsible for their content or privacy practices.</p>
        </LegalSection>

        <LegalSection title="13. Changes to This Privacy Policy">
          <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated "Last updated" date. Continued use of the Platform after changes indicates your acceptance of the revised Privacy Policy.</p>
        </LegalSection>

        <LegalSection title="14. Grievance Officer">
          <p>In accordance with the Information Technology Act, 2000 and rules made thereunder, the details of the Grievance Officer are provided below. Any complaints or concerns regarding the processing of your personal information may be addressed to:</p>
          <p>Name: Gaurav</p>
          <p>Email: <a href="mailto:admin@edgram.in" className={`${PRIMARY_COLOR_CLASS} hover:underline`}>admin@edgram.in</a> (primary), <a href="mailto:support@edgram.in" className={`${PRIMARY_COLOR_CLASS} hover:underline`}>support@edgram.in</a> (secondary)</p>
          <p>Phone: +91 7827957393</p>
          <p>Address: 7th, 703, Palm Court, Mehrauli Gurugram Road, Sector 16, Gurugram, Haryana, 122007</p>
          <p>The Grievance Officer will acknowledge and address your complaint within a reasonable timeframe as required under applicable law.</p>
        </LegalSection>

        <LegalSection title="15. Contact Us">
          <p>If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, contact us at:</p>
          <p>Email: <a href="mailto:admin@edgram.in" className={`${PRIMARY_COLOR_CLASS} hover:underline`}>admin@edgram.in</a> (primary), <a href="mailto:support@edgram.in" className={`${PRIMARY_COLOR_CLASS} hover:underline`}>support@edgram.in</a> (secondary)</p>
          <p>Phone: +91 7827957393</p>
          <p>Website: <a href="https://www.edgram.in" className={`${PRIMARY_COLOR_CLASS} hover:underline`}>https://www.edgram.in</a></p>
        </LegalSection>
      </div>
    </Container>
  );
}

function TermsPage() {
  const customContent = useLegalContent('termsContent');

  if (customContent === null) {
    return <Container><div className="max-w-3xl mx-auto py-20 text-center text-gray-400">Loading...</div></Container>;
  }

  if (customContent.trim().length > 0) {
    return (
      <Container>
        <div className="max-w-3xl mx-auto py-10">
          <h1 className="text-4xl font-extrabold mb-2 text-gray-800">Terms and Conditions</h1>
          <PlainTextLegalContent text={customContent} />
        </div>
      </Container>
    );
  }

  return (
    <Container>
      <div className="max-w-3xl mx-auto py-10">
        <h1 className="text-4xl font-extrabold mb-2 text-gray-800">Terms and Conditions</h1>
        <p className="text-gray-500 mb-10">Last updated: 02 February 2026</p>

        <LegalSection title="1. Introduction">
          <p>These Terms and Conditions ("Terms") govern your access to and use of the Edgram website located at https://www.edgram.in and any related mobile or web applications (collectively, the "Platform"), including all content, products, services, and referral programs offered through the Platform (collectively, the "Services"). By accessing or using the Platform, you agree to be bound by these Terms. If you do not agree, you must not access or use the Platform.</p>
        </LegalSection>

        <LegalSection title="2. Eligibility">
          <p>You must be at least 18 years old and capable of entering into a legally binding contract under applicable law. By using the Platform, you represent that the information you provide is true, accurate, and complete, and that you will keep it updated.</p>
        </LegalSection>

        <LegalSection title="3. Account Registration">
          <p>To access certain features (including paid content), you must create an account by providing accurate personal information and a valid email address. You are responsible for maintaining the confidentiality of your login credentials and for all activities that occur under your account. Notify Edgram immediately of any unauthorized use of your account or security breach.</p>
        </LegalSection>

        <LegalSection title="4. Services and Content Access">
          <p>Upon successful enrollment and payment of the applicable fee (currently ₹6,999 for lifetime access, unless otherwise specified), you receive a limited, non-exclusive, non-transferable, revocable license to access and view the educational content made available to you on the Platform for your personal, non-commercial use. Edgram may update, modify, remove, or add content, features, or functionalities at any time, including changing the structure or pricing of the Services, at its sole discretion, with or without prior notice. Edgram does not guarantee any specific learning outcomes, job placement, or income results from using the educational content.</p>
        </LegalSection>

        <LegalSection title="5. Referral Program">
          <p>Edgram's primary purpose is the sale of educational courses and digital content. As an ancillary benefit, Edgram may, at its sole and absolute discretion, recognize eligible members who refer prospective customers to the Platform. Recognition under this program becomes applicable only after the referred individual independently purchases a course from Edgram; no benefit accrues merely for referring or recruiting a person.</p>
          <p>The existence, structure, eligibility criteria, and any benefit under this program are determined solely by Edgram and may be introduced, modified, suspended, or discontinued at any time without prior notice, at Edgram's sole discretion. Edgram does not publish or guarantee any fixed or specific amount under this program, and nothing in these Terms should be construed as a promise of income, return, or financial benefit of any kind.</p>
          <p>A referral is considered eligible only where the referred individual (a) uses the referring member's unique link, (b) completes registration, and (c) independently purchases a course, with such purchase not being cancelled, refunded, or disputed. Edgram reserves the right to verify, withhold, delay, or reverse any recognition under this program in cases of suspected fraud, self-referral, duplicate accounts, misuse, or any activity inconsistent with the primary objective of course sales. Any applicable taxes on amounts received are the sole responsibility of the member; Edgram may deduct tax at source where required by law.</p>
        </LegalSection>

        <LegalSection title="6. Payments, Pricing, and Refunds">
          <p>All fees are displayed on the Platform and payable in Indian Rupees (INR), unless stated otherwise. You authorize Edgram or its third-party payment processors to charge your selected payment method for all purchases. Payments are generally non-refundable, except where a specific refund policy is mentioned on the Platform at the time of purchase, or a refund is required under applicable law. Edgram may offer limited-time promotions or trial periods, subject to additional terms and modification at any time.</p>
        </LegalSection>

        <LegalSection title="7. Acceptable Use and Prohibited Activities">
          <p>You agree not to: use the Platform for unlawful, harmful, fraudulent, or misleading activity; copy, reproduce, distribute, modify, reverse engineer, or create derivative works of the Platform except as permitted; share your account credentials or resell access; bypass or interfere with security features or tracking systems; engage in spamming or unauthorized advertising; or use the referral program in a deceptive or misleading manner, including false earnings claims or impersonation.</p>
        </LegalSection>

        <LegalSection title="8. Intellectual Property">
          <p>All content on the Platform, including text, videos, graphics, logos, trademarks, icons, and software, is owned by Edgram or its licensors and protected by intellectual property laws. You are granted only a limited license to access and use the content as described in these Terms and do not acquire any ownership rights. You may not use Edgram's name, logo, or trademarks without prior written permission.</p>
        </LegalSection>

        <LegalSection title="9. User Content">
          <p>If you submit content to the Platform (reviews, comments, testimonials, feedback), you grant Edgram a worldwide, non-exclusive, royalty-free, transferable license to use, reproduce, modify, publish, display, and distribute it in connection with the Platform and Edgram's marketing activities. You represent that you own or have necessary rights to the content you share and that it does not infringe any third-party rights. Edgram may remove content it considers inappropriate or in violation of these Terms.</p>
        </LegalSection>

        <LegalSection title="10. Third-Party Services">
          <p>The Platform may contain links to third-party websites or services not owned or controlled by Edgram. Edgram does not endorse and is not responsible for any third-party content, services, or privacy practices. You access third-party sites at your own risk.</p>
        </LegalSection>

        <LegalSection title="11. Disclaimers">
          <p>The Platform and Services are provided on an "as is" and "as available" basis without warranties of any kind. Edgram does not warrant that the Platform will be uninterrupted, error-free, secure, or free of harmful components, and does not guarantee any specific earnings, business results, or career outcomes. Any examples of earnings or success are illustrative only.</p>
        </LegalSection>

        <LegalSection title="12. Limitation of Liability">
          <p>To the maximum extent permitted by law, Edgram and its directors, officers, employees, and agents will not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of the Platform. Edgram's total aggregate liability for any claims will be limited to the amount you paid to Edgram during the six (6) months preceding the event giving rise to the claim.</p>
        </LegalSection>

        <LegalSection title="13. Indemnity">
          <p>You agree to indemnify, defend, and hold harmless Edgram and its affiliates, officers, employees, and agents from any claims, liabilities, damages, losses, and expenses arising out of your use of the Platform, your violation of these Terms, or your violation of any rights of another person or entity.</p>
        </LegalSection>

        <LegalSection title="14. Suspension and Termination">
          <p>Edgram may suspend, restrict, or terminate your access to the Platform at any time, with or without notice, if it reasonably believes you have violated these Terms or applicable law, or for any other reason at its discretion. Certain provisions (intellectual property, disclaimers, limitation of liability, and indemnity) will survive termination.</p>
        </LegalSection>

        <LegalSection title="15. Changes to the Terms">
          <p>Edgram may modify these Terms from time to time. Updated Terms will be posted on this page with a revised "Last updated" date. Continued use of the Platform after changes are posted constitutes acceptance of the revised Terms.</p>
        </LegalSection>

        <LegalSection title="16. Governing Law and Dispute Resolution">
          <p>These Terms shall be governed by and construed in accordance with the laws of India. Subject to applicable law, you agree that the courts located in Gurugram, Haryana, India shall have exclusive jurisdiction over any disputes arising out of or in connection with these Terms or your use of the Platform.</p>
        </LegalSection>

        <LegalSection title="17. Contact Information">
          <p>If you have questions about these Terms, contact us at:</p>
          <p>Email: <a href="mailto:admin@edgram.in" className={`${PRIMARY_COLOR_CLASS} hover:underline`}>admin@edgram.in</a> (primary), <a href="mailto:support@edgram.in" className={`${PRIMARY_COLOR_CLASS} hover:underline`}>support@edgram.in</a> (secondary)</p>
          <p>Website: <a href="https://www.edgram.in" className={`${PRIMARY_COLOR_CLASS} hover:underline`}>https://www.edgram.in</a></p>
        </LegalSection>
      </div>
    </Container>
  );
}

function RefundPolicyPage() {
  const customContent = useLegalContent('refundContent');

  if (customContent === null) {
    return <Container><div className="max-w-3xl mx-auto py-20 text-center text-gray-400">Loading...</div></Container>;
  }

  if (customContent.trim().length > 0) {
    return (
      <Container>
        <div className="max-w-3xl mx-auto py-10">
          <h1 className="text-4xl font-extrabold mb-2 text-gray-800">Refund & Cancellation Policy</h1>
          <PlainTextLegalContent text={customContent} />
        </div>
      </Container>
    );
  }

  return (
    <Container>
      <div className="max-w-3xl mx-auto py-10">
        <h1 className="text-4xl font-extrabold mb-2 text-gray-800">Refund & Cancellation Policy</h1>
        <p className="text-gray-500 mb-10">Last updated: 02 February 2026</p>

        <LegalSection title="1. Nature of Product">
          <p>Edgram sells digital educational courses and e-library content. Access to purchased content is granted instantly and automatically upon successful payment.</p>
        </LegalSection>

        <LegalSection title="2. No Refunds After Purchase">
          <p>Because access to digital content is granted immediately upon payment, and the content can be viewed, downloaded, or consumed instantly, all sales are final and non-refundable once payment is successfully processed, except where a refund is expressly required under applicable Indian law.</p>
        </LegalSection>

        <LegalSection title="3. Before You Purchase">
          <p>We strongly encourage you to review the free preview content and course descriptions available on the Platform before making a purchase, to ensure the content meets your learning requirements.</p>
        </LegalSection>

        <LegalSection title="4. Failed or Duplicate Transactions">
          <p>If an amount is debited from your bank account or card but the transaction shows as failed on the Platform, or if you are charged more than once for the same purchase due to a technical or payment gateway error, the excess or erroneous amount will be reviewed and refunded to the original payment method within a reasonable timeframe upon verification.</p>
        </LegalSection>

        <LegalSection title="5. Cancellation">
          <p>Since access to digital content is instant, there is no cancellation window once a purchase is completed. If you wish to raise a concern regarding a purchase, contact us within 7 days of the transaction date.</p>
        </LegalSection>

        <LegalSection title="6. How to Raise a Request">
          <p>For any refund-related concern arising from a failed, duplicate, or erroneous transaction, contact us with your registered email address, transaction ID, and date of purchase at:</p>
          <p>Email: <a href="mailto:admin@edgram.in" className={`${PRIMARY_COLOR_CLASS} hover:underline`}>admin@edgram.in</a> (primary), <a href="mailto:support@edgram.in" className={`${PRIMARY_COLOR_CLASS} hover:underline`}>support@edgram.in</a> (secondary)</p>
          <p>Phone: +91 7827957393</p>
        </LegalSection>

        <LegalSection title="7. Changes to This Policy">
          <p>Edgram may update this Refund & Cancellation Policy from time to time. Any changes will be posted on this page with a revised "Last updated" date.</p>
        </LegalSection>
      </div>
    </Container>
  );
}

const DEFAULT_CONTACT_INFO = {
  address: '7th, 703, Palm Court, Mehrauli Gurugram Road, Sector 16, Gurugram, Haryana, 122007',
  phone: '+91 7827957393',
  emailPrimary: 'admin@edgram.in',
  emailSecondary: 'support@edgram.in',
  grievanceOfficerName: 'Gaurav',
};

function useContactInfo() {
  const [info, setInfo] = useState(null);
  useEffect(() => {
    let cancelled = false;
    ApiClient.fetchContactInfo()
      .then(data => {
        if (cancelled) return;
        const hasData = data && Object.keys(data).length > 0;
        setInfo(hasData ? { ...DEFAULT_CONTACT_INFO, ...data } : DEFAULT_CONTACT_INFO);
      })
      .catch(() => { if (!cancelled) setInfo(DEFAULT_CONTACT_INFO); });
    return () => { cancelled = true; };
  }, []);
  return info;
}

function ContactPage() {
  const info = useContactInfo();

  if (!info) {
    return <Container><div className="max-w-2xl mx-auto py-20 text-center text-gray-400">Loading...</div></Container>;
  }

  return (
    <Container>
      <div className="max-w-2xl mx-auto py-10">
        <h1 className="text-4xl font-extrabold mb-2 text-gray-800">Contact Us</h1>
        <p className="text-gray-500 mb-8">We're here to help. Reach out to us anytime.</p>

        <div className="bg-white border border-gray-200 rounded-xl shadow-sm divide-y divide-gray-100">
          <div className="p-6 flex gap-4 items-start">
            <div className="w-10 h-10 rounded-full bg-orange-50 flex items-center justify-center flex-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={PRIMARY_COLOR_CLASS}><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
            </div>
            <div>
              <h5 className="font-semibold text-gray-800 mb-1">Registered Business Address</h5>
              <p className="text-gray-600 text-sm leading-relaxed">{info.address}</p>
            </div>
          </div>

          <div className="p-6 flex gap-4 items-start">
            <div className="w-10 h-10 rounded-full bg-orange-50 flex items-center justify-center flex-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={PRIMARY_COLOR_CLASS}><path d="M4 4h16v16H4z" opacity="0"/><path d="M22 6l-10 7L2 6"/><path d="M2 6h20v12H2z"/></svg>
            </div>
            <div>
              <h5 className="font-semibold text-gray-800 mb-1">Email</h5>
              <p className="text-gray-600 text-sm">
                <a href={`mailto:${info.emailPrimary}`} className={`${PRIMARY_COLOR_CLASS} hover:underline font-medium`}>{info.emailPrimary}</a>
                <span className="text-gray-400"> (primary)</span>
              </p>
              <p className="text-gray-600 text-sm mt-1">
                <a href={`mailto:${info.emailSecondary}`} className={`${PRIMARY_COLOR_CLASS} hover:underline`}>{info.emailSecondary}</a>
                <span className="text-gray-400"> (secondary)</span>
              </p>
            </div>
          </div>

          <div className="p-6 flex gap-4 items-start">
            <div className="w-10 h-10 rounded-full bg-orange-50 flex items-center justify-center flex-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={PRIMARY_COLOR_CLASS}><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
            </div>
            <div>
              <h5 className="font-semibold text-gray-800 mb-1">Phone</h5>
              <p className="text-gray-600 text-sm">
                <a href={`tel:${info.phone.replace(/\s+/g, '')}`} className={`${PRIMARY_COLOR_CLASS} hover:underline`}>{info.phone}</a>
              </p>
            </div>
          </div>

          <div className="p-6 flex gap-4 items-start">
            <div className="w-10 h-10 rounded-full bg-orange-50 flex items-center justify-center flex-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={PRIMARY_COLOR_CLASS}><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4.4 3.6-8 8-8s8 3.6 8 8"/></svg>
            </div>
            <div>
              <h5 className="font-semibold text-gray-800 mb-1">Grievance Officer</h5>
              <p className="text-gray-600 text-sm">{info.grievanceOfficerName}</p>
              <p className="text-gray-600 text-sm mt-1">
                <a href={`mailto:${info.emailPrimary}`} className={`${PRIMARY_COLOR_CLASS} hover:underline`}>{info.emailPrimary}</a>
                {' · '}
                <a href={`tel:${info.phone.replace(/\s+/g, '')}`} className={`${PRIMARY_COLOR_CLASS} hover:underline`}>{info.phone}</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
}


/* =========================
   ABOUT US PAGE
   ========================= */
function AboutPage() {
  return (
    <div className="bg-gray-50 min-h-screen">
      {/* Hero */}
      <div className="bg-gray-900 text-white py-20">
        <Container>
          <div className="max-w-3xl mx-auto text-center">
            <span className="inline-block bg-orange-500/20 text-orange-400 text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">Our Story</span>
            <h1 className="text-4xl sm:text-5xl font-extrabold mb-4 leading-tight">
              Built for <span className="text-orange-400">Learners</span>, by Learners
            </h1>
            <p className="text-gray-300 text-lg leading-relaxed">
              Edgram was founded with a single belief — high-quality, practical education should be affordable and accessible to everyone in India.
            </p>
          </div>
        </Container>
      </div>

      {/* Mission */}
      <Container>
        <div className="max-w-4xl mx-auto py-16">
          <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Our Mission</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                We believe that knowledge is the greatest investment you can make. At Edgram, we curate the best practical, no-fluff courses across multiple categories — skills that directly translate to real income and career growth.
              </p>
              <p className="text-gray-600 leading-relaxed">
                Our platform gives you lifetime access to a growing library of content for a single, one-time payment. No subscriptions. No hidden fees. Just knowledge, forever.
              </p>
            </div>
            <div className="grid grid-cols-2 gap-4">
              {[
                { number: '100%', label: 'Practical Content' },
                { number: '2+', label: 'Course Categories' },
                { number: '1x', label: 'Lifetime Payment' },
                { number: '24/7', label: 'Content Access' },
              ].map(({ number, label }) => (
                <div key={label} className="bg-white rounded-2xl p-6 text-center shadow-sm border border-gray-100">
                  <p className="text-3xl font-black text-red-600 mb-1">{number}</p>
                  <p className="text-sm text-gray-500 font-medium">{label}</p>
                </div>
              ))}
            </div>
          </div>

          {/* What We Offer */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">What We Offer</h2>
            <div className="grid md:grid-cols-3 gap-6">
              {[
                {
                  icon: <Icon name="target" className="w-8 h-8 text-red-600" />,
                  title: 'Expert-curated courses',
                  desc: 'Every course is handpicked for practical value — no filler, no theory overload. Content that delivers real-world results.'
                },
                {
                  icon: <Icon name="book-open" className="w-8 h-8 text-orange-600" />,
                  title: 'Multiple categories',
                  desc: 'Our library spans multiple disciplines and keeps growing. New courses are added regularly across diverse topics.'
                },
                {
                  icon: <Icon name="graduation-cap" className="w-8 h-8 text-purple-600" />,
                  title: 'Self-Paced Learning',
                  desc: 'No deadlines, no pressure. Learn at your own pace, revisit content anytime, and track your progress as you go.'
                },
              ].map(({ icon, title, desc }) => (
                <div key={title} className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 hover:shadow-md transition">
                  <div className="text-4xl mb-4">{icon}</div>
                  <h3 className="font-bold text-gray-800 text-lg mb-2">{title}</h3>
                  <p className="text-gray-500 text-sm leading-relaxed">{desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Values */}
          <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-3xl p-10 text-white mb-16">
            <h2 className="text-3xl font-bold mb-8 text-center">Our Values</h2>
            <div className="grid md:grid-cols-2 gap-6">
              {[
                { icon: <Icon name="eye" className="w-6 h-6 text-orange-400" />, title: 'Transparency', desc: 'Clear pricing, clear policies, clear communication. No surprises.' },
                { icon: <Icon name="graduation-cap" className="w-6 h-6 text-orange-400" />, title: 'Quality First', desc: 'Every piece of content is curated for practical value, not just volume.' },
                { icon: <Icon name="lock" className="w-6 h-6 text-orange-400" />, title: 'Trust & Security', desc: 'Your data and payments are handled with the highest security standards.' },
                { icon: <Icon name="trending-up" className="w-6 h-6 text-orange-400" />, title: 'Constant Growth', desc: 'We keep adding content. Your membership grows in value over time.' },
              ].map(({ icon, title, desc }) => (
                <div key={title} className="flex gap-4 items-start">
                  <span className="text-2xl mt-1">{icon}</span>
                  <div>
                    <h4 className="font-bold text-orange-400 mb-1">{title}</h4>
                    <p className="text-gray-300 text-sm">{desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Contact CTA */}
          <div className="text-center bg-white rounded-2xl p-10 shadow-sm border border-gray-100">
            <h2 className="text-2xl font-bold text-gray-900 mb-3">Have Questions?</h2>
            <p className="text-gray-500 mb-6">We're a small, dedicated team and we read every message. Reach out anytime.</p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <a href="mailto:support@edgram.in" className="bg-red-600 hover:bg-red-700 text-white font-bold py-3 px-6 rounded-xl transition">
                Email Us
              </a>
              <Link to="/contact" className="border-2 border-gray-200 hover:border-red-400 text-gray-700 font-bold py-3 px-6 rounded-xl transition">
                Contact Page
              </Link>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}

/* =========================
   404 NOT FOUND PAGE
   ========================= */
function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <div className="text-8xl font-black text-gray-200 mb-2">404</div>
        <div className="text-6xl mb-6">🧭</div>
        <h1 className="text-2xl font-bold text-gray-800 mb-3">Page Not Found</h1>
        <p className="text-gray-500 mb-8 leading-relaxed">
          Looks like this page doesn't exist or has been moved. Let's get you back on track.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={() => navigate(-1)}
            className="border-2 border-gray-200 hover:border-red-400 text-gray-700 font-bold py-3 px-6 rounded-xl transition"
          >
            ← Go Back
          </button>
          <Link to="/" className="bg-red-600 hover:bg-red-700 text-white font-bold py-3 px-6 rounded-xl transition">
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}

/* =========================
   NEW: Main App Footer (Unchanged)
   ========================= */
function AppFooter() {
  return (
    <footer className="bg-gray-900 text-gray-300 py-10 mt-12 border-t border-gray-800">
      <Container>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div>
            <h4 className={`font-bold ${SECONDARY_COLOR_CLASS} text-xl mb-3`}>Edgram</h4>
            <p className="text-sm mb-3">Learn. Grow. Succeed.</p>
            <p className="text-xs text-gray-400 leading-relaxed">
              7th, 703, Palm Court,<br />
              Mehrauli Gurugram Road,<br />
              Sector 16, Gurugram,<br />
              Haryana, 122007
            </p>
          </div>
          <div>
            <h5 className="font-semibold text-white mb-3">Navigate</h5>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm hover:text-orange-400 transition">Home</Link>
              <Link to="/login" className="text-sm hover:text-orange-400 transition">Member Login</Link>
              <Link to="/register" className="text-sm hover:text-red-400 transition">Start Learning</Link>
            </div>
          </div>
          <div>
            <h5 className="font-semibold text-white mb-3">Support</h5>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm hover:text-orange-400 transition">About Us</Link>
              <Link to="/contact" className="text-sm hover:text-orange-400 transition">Contact Us</Link>
              <Link to="/admin-login" className="text-sm hover:text-orange-400 transition">Admin Login</Link>
            </div>
          </div>
          <div>
            <h5 className="font-semibold text-white mb-3">Legal</h5>
            <div className="flex flex-col gap-2">
              <Link to="/terms" className="text-sm hover:text-orange-400 transition">Terms & Conditions</Link>
              <Link to="/privacy" className="text-sm hover:text-orange-400 transition">Privacy Policy</Link>
              <Link to="/refund-policy" className="text-sm hover:text-orange-400 transition">Refund Policy</Link>
            </div>
          </div>
        </div>
        <div className="text-center text-xs text-gray-500 mt-10 pt-6 border-t border-gray-800">
          © {new Date().getFullYear()} Edgram. All rights reserved. Built with ❤️ in India.
        </div>
      </Container>
    </footer>
  );
}


/* =========================
   MAIN APP (Refactored to use Global Data Provider)
   ========================= */
export default function App() {
  const [userType, setUserType] = useState(localStorage.getItem(LS_USER_TYPE) || 'guest');
  const globalData = useGlobalData();

     const PUBLIC_PATHS = ['/', '/about', '/faq', '/terms', '/privacy', '/refund-policy', '/contact', '/login', '/register', '/admin-login', '/forgot-password'];
   const isPublicPath = typeof window !== 'undefined' && PUBLIC_PATHS.includes(window.location.pathname);

if (globalData.isLoading && !isPublicPath) {
    return (
        // Background: Matches your Navbar & Hero Section (bg-gray-900)
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-900 p-6 text-white">
            
            <div className="text-center">
                {/* Icon Box: Darker gray container with your brand gradient border */}
                <div className="w-20 h-20 bg-gray-800 rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-2xl border border-gray-700 animate-pulse">
                    <Icon name="zap" className="w-9 h-9 text-orange-400" />
                </div>

                {/* Main Heading: Uses your exact CTA gradient (Orange to Red) for the text */}
                <h1 className="text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-red-600 tracking-tight drop-shadow-lg mb-4">
                    Edgram
                </h1>

                {/* Subtitle: Light gray to match your footer text */}
                <p className="text-gray-400 text-lg font-light tracking-wide">
                    Igniting your digital potential...
                </p>

                {/* Loading Bar: Matches your button gradient */}
                <div className="mt-8 w-32 h-1 bg-gray-800 rounded-full overflow-hidden mx-auto">
                    <div className="h-full bg-gradient-to-r from-orange-500 to-red-600 w-full animate-[ping_1.5s_cubic-bezier(0,0,0.2,1)_infinite] opacity-75"></div>
                </div>
            </div>
        </div>
    );
}
  return (
    <BrowserRouter>
      <GlobalDataContext.Provider value={globalData}>
        <Toaster position="top-right" reverseOrder={false} />
        <div className="min-h-screen bg-gray-50 flex flex-col">
          <AuthWrapper setUserType={setUserType}>
            <Navbar userType={userType} setUserType={setUserType} />
            <main className="flex-grow">
              <Routes>
                <Route path="/" element={<Landing />} /> 
                <Route path="/browse" element={<CategoryList />} />
                <Route path="/browse/:categoryId" element={<CategoryDetail />} />
                <Route path="/video/:videoId" element={<VideoPlayer />} />
                <Route path="/register" element={<MemberRegister setUserType={setUserType} />} />
                <Route path="/login" element={<MemberLogin setUserType={setUserType} />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/admin-login" element={<Login />} />
                <Route path="/faq" element={<FaqPage />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="/privacy" element={<PrivacyPolicyPage />} />
                <Route path="/refund-policy" element={<RefundPolicyPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/about" element={<AboutPage />} />

                <Route path="/dashboard" element={<MemberRoute><MemberDashboard /></MemberRoute>} />
                <Route path="/accountant" element={<AccountantRoute><AccountantDashboard /></AccountantRoute>} />
                <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />

                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </main>
            <AppFooter />
          </AuthWrapper>
        </div>
      </GlobalDataContext.Provider>
    </BrowserRouter>
  );
}
